// AUTO-GENERATED — do not edit by hand.
// Universal country + state/province reference for the whole platform (all
// custodians), sourced from IBKR's "Country and State-Province Code" list.
// STORED VALUES ARE ISO CODES (IBKR format): country = ISO 3166-1 alpha-2;
// state/province = US 2-letter abbreviation, or full ISO 3166-2 elsewhere.
// Display names are cleaned; regenerate from the same sheet if it changes.

export interface Region {
  code: string;
  name: string;
}
export interface Country {
  name: string;
  code2: string;
  code3: string;
}

export const COUNTRIES: Country[] = [
  { name: 'Albania', code2: 'AL', code3: 'ALB' },
  { name: 'Algeria', code2: 'DZ', code3: 'DZA' },
  { name: 'Andorra', code2: 'AD', code3: 'AND' },
  { name: 'Antigua and Barbuda', code2: 'AG', code3: 'ATG' },
  { name: 'Argentina', code2: 'AR', code3: 'ARG' },
  { name: 'Armenia', code2: 'AM', code3: 'ARM' },
  { name: 'Australia', code2: 'AU', code3: 'AUS' },
  { name: 'Austria', code2: 'AT', code3: 'AUT' },
  { name: 'Azerbaijan', code2: 'AZ', code3: 'AZE' },
  { name: 'Bahamas', code2: 'BS', code3: 'BHS' },
  { name: 'Bahrain', code2: 'BH', code3: 'BHR' },
  { name: 'Bangladesh', code2: 'BD', code3: 'BGD' },
  { name: 'Barbados', code2: 'BB', code3: 'BRB' },
  { name: 'Belgium', code2: 'BE', code3: 'BEL' },
  { name: 'Belize', code2: 'BZ', code3: 'BLZ' },
  { name: 'Benin', code2: 'BJ', code3: 'BEN' },
  { name: 'Bhutan', code2: 'BT', code3: 'BTN' },
  { name: 'Bolivia', code2: 'BO', code3: 'BOL' },
  { name: 'Bosnia and Herzegovina', code2: 'BA', code3: 'BIH' },
  { name: 'Botswana', code2: 'BW', code3: 'BWA' },
  { name: 'Brazil', code2: 'BR', code3: 'BRA' },
  { name: 'Brunei Darussalam', code2: 'BN', code3: 'BRN' },
  { name: 'Bulgaria', code2: 'BG', code3: 'BGR' },
  { name: 'Burkina Faso', code2: 'BF', code3: 'BFA' },
  { name: 'Burundi', code2: 'BI', code3: 'BDI' },
  { name: 'Cambodia', code2: 'KH', code3: 'KHM' },
  { name: 'Cameroon', code2: 'CM', code3: 'CMR' },
  { name: 'Canada', code2: 'CA', code3: 'CAN' },
  { name: 'Cape Verde', code2: 'CV', code3: 'CPV' },
  { name: 'Central African Republic', code2: 'CF', code3: 'CAF' },
  { name: 'Chad', code2: 'TD', code3: 'TCD' },
  { name: 'Chile', code2: 'CL', code3: 'CHL' },
  { name: 'China', code2: 'CN', code3: 'CHN' },
  { name: 'Colombia', code2: 'CO', code3: 'COL' },
  { name: 'Comoros', code2: 'KM', code3: 'COM' },
  { name: 'Costa Rica', code2: 'CR', code3: 'CRI' },
  { name: 'Croatia', code2: 'HR', code3: 'HRV' },
  { name: 'Cyprus', code2: 'CY', code3: 'CYP' },
  { name: 'Czech Republic', code2: 'CZ', code3: 'CZE' },
  { name: 'Denmark', code2: 'DK', code3: 'DNK' },
  { name: 'Djibouti', code2: 'DJ', code3: 'DJI' },
  { name: 'Dominica', code2: 'DM', code3: 'DMA' },
  { name: 'Dominican Republic', code2: 'DO', code3: 'DOM' },
  { name: 'East Timor', code2: 'TL', code3: 'TLS' },
  { name: 'Ecuador', code2: 'EC', code3: 'ECU' },
  { name: 'Egypt', code2: 'EG', code3: 'EGY' },
  { name: 'El Salvador', code2: 'SV', code3: 'SLV' },
  { name: 'Equatorial Guinea', code2: 'GQ', code3: 'GNQ' },
  { name: 'Eritrea', code2: 'ER', code3: 'ERI' },
  { name: 'Estonia', code2: 'EE', code3: 'EST' },
  { name: 'Ethiopia', code2: 'ET', code3: 'ETH' },
  { name: 'Fiji', code2: 'FJ', code3: 'FJI' },
  { name: 'Finland', code2: 'FI', code3: 'FIN' },
  { name: 'France', code2: 'FR', code3: 'FRA' },
  { name: 'Gabon', code2: 'GA', code3: 'GAB' },
  { name: 'Gambia', code2: 'GM', code3: 'GMB' },
  { name: 'Georgia', code2: 'GE', code3: 'GEO' },
  { name: 'Germany', code2: 'DE', code3: 'DEU' },
  { name: 'Ghana', code2: 'GH', code3: 'GHA' },
  { name: 'Greece', code2: 'GR', code3: 'GRC' },
  { name: 'Greenland', code2: 'GL', code3: 'GRL' },
  { name: 'Grenada', code2: 'GD', code3: 'GRD' },
  { name: 'Guatemala', code2: 'GT', code3: 'GTM' },
  { name: 'Guinea', code2: 'GN', code3: 'GIN' },
  { name: 'Guinea-Bissau', code2: 'GW', code3: 'GNB' },
  { name: 'Guyana', code2: 'GY', code3: 'GUY' },
  { name: 'Haiti', code2: 'HT', code3: 'HTI' },
  { name: 'Honduras', code2: 'HN', code3: 'HND' },
  { name: 'Hungary', code2: 'HU', code3: 'HUN' },
  { name: 'Iceland', code2: 'IS', code3: 'ISL' },
  { name: 'India', code2: 'IN', code3: 'IND' },
  { name: 'Indonesia', code2: 'ID', code3: 'IDN' },
  { name: 'Ireland', code2: 'IE', code3: 'IRL' },
  { name: 'Israel', code2: 'IL', code3: 'ISR' },
  { name: 'Italy', code2: 'IT', code3: 'ITA' },
  { name: 'Jamaica', code2: 'JM', code3: 'JAM' },
  { name: 'Japan', code2: 'JP', code3: 'JPN' },
  { name: 'Jordan', code2: 'JO', code3: 'JOR' },
  { name: 'Kazakhstan', code2: 'KZ', code3: 'KAZ' },
  { name: 'Kiribati', code2: 'KI', code3: 'KIR' },
  { name: 'Kuwait', code2: 'KW', code3: 'KWT' },
  { name: 'Kyrgyzstan', code2: 'KG', code3: 'KGZ' },
  { name: 'Lao People`s Democratic Republic', code2: 'LA', code3: 'LAO' },
  { name: 'Latvia', code2: 'LV', code3: 'LVA' },
  { name: 'Lebanon', code2: 'LB', code3: 'LBN' },
  { name: 'Lesotho', code2: 'LS', code3: 'LSO' },
  { name: 'Liberia', code2: 'LR', code3: 'LBR' },
  { name: 'Liechtenstein', code2: 'LI', code3: 'LIE' },
  { name: 'Lithuania', code2: 'LT', code3: 'LTU' },
  { name: 'Luxembourg', code2: 'LU', code3: 'LUX' },
  { name: 'Madagascar', code2: 'MG', code3: 'MDG' },
  { name: 'Malawi', code2: 'MW', code3: 'MWI' },
  { name: 'Malaysia', code2: 'MY', code3: 'MYS' },
  { name: 'Maldives', code2: 'MV', code3: 'MDV' },
  { name: 'Mali', code2: 'ML', code3: 'MLI' },
  { name: 'Malta', code2: 'MT', code3: 'MLT' },
  { name: 'Marshall Islands', code2: 'MH', code3: 'MHL' },
  { name: 'Mauritania', code2: 'MR', code3: 'MRT' },
  { name: 'Mauritius', code2: 'MU', code3: 'MUS' },
  { name: 'Mexico', code2: 'MX', code3: 'MEX' },
  { name: 'Micronesia', code2: 'FM', code3: 'FSM' },
  { name: 'Monaco', code2: 'MC', code3: 'MCO' },
  { name: 'Mongolia', code2: 'MN', code3: 'MNG' },
  { name: 'Montenegro', code2: 'ME', code3: 'MNE' },
  { name: 'Morocco', code2: 'MA', code3: 'MAR' },
  { name: 'Mozambique', code2: 'MZ', code3: 'MOZ' },
  { name: 'Namibia', code2: 'NA', code3: 'NAM' },
  { name: 'Nepal', code2: 'NP', code3: 'NPL' },
  { name: 'Netherlands', code2: 'NL', code3: 'NLD' },
  { name: 'New Zealand', code2: 'NZ', code3: 'NZL' },
  { name: 'Nicaragua', code2: 'NI', code3: 'NIC' },
  { name: 'Niger', code2: 'NE', code3: 'NER' },
  { name: 'Norway', code2: 'NO', code3: 'NOR' },
  { name: 'Occupied Palestinian Territory', code2: 'PS', code3: 'PSE' },
  { name: 'Oman', code2: 'OM', code3: 'OMN' },
  { name: 'Pakistan', code2: 'PK', code3: 'PAK' },
  { name: 'Palau', code2: 'PW', code3: 'PLW' },
  { name: 'Panama', code2: 'PA', code3: 'PAN' },
  { name: 'Papua New Guinea', code2: 'PG', code3: 'PNG' },
  { name: 'Paraguay', code2: 'PY', code3: 'PRY' },
  { name: 'Peru', code2: 'PE', code3: 'PER' },
  { name: 'Philippines', code2: 'PH', code3: 'PHL' },
  { name: 'Poland', code2: 'PL', code3: 'POL' },
  { name: 'Portugal', code2: 'PT', code3: 'PRT' },
  { name: 'Qatar', code2: 'QA', code3: 'QAT' },
  { name: 'Republic of Korea', code2: 'KR', code3: 'KOR' },
  { name: 'Republic of Moldova', code2: 'MD', code3: 'MDA' },
  { name: 'Romania', code2: 'RO', code3: 'ROU' },
  { name: 'Russian Federation', code2: 'RU', code3: 'RUS' },
  { name: 'Rwanda', code2: 'RW', code3: 'RWA' },
  { name: 'Saint Helena', code2: 'SH', code3: 'SHN' },
  { name: 'Saint Kitts and Nevis', code2: 'KN', code3: 'KNA' },
  { name: 'Saint Lucia', code2: 'LC', code3: 'LCA' },
  { name: 'Saint Vincent and the Grenadines', code2: 'VC', code3: 'VCT' },
  { name: 'Samoa', code2: 'WS', code3: 'WSM' },
  { name: 'San Marino', code2: 'SM', code3: 'SMR' },
  { name: 'Sao Tome and Principe', code2: 'ST', code3: 'STP' },
  { name: 'Saudi Arabia', code2: 'SA', code3: 'SAU' },
  { name: 'Senegal', code2: 'SN', code3: 'SEN' },
  { name: 'Serbia', code2: 'RS', code3: 'SRB' },
  { name: 'Seychelles', code2: 'SC', code3: 'SYC' },
  { name: 'Singapore', code2: 'SG', code3: 'SGP' },
  { name: 'Slovakia', code2: 'SK', code3: 'SVK' },
  { name: 'Slovenia', code2: 'SI', code3: 'SVN' },
  { name: 'Solomon Islands', code2: 'SB', code3: 'SLB' },
  { name: 'Somalia', code2: 'SO', code3: 'SOM' },
  { name: 'South Africa', code2: 'ZA', code3: 'ZAF' },
  { name: 'Spain', code2: 'ES', code3: 'ESP' },
  { name: 'Sri Lanka', code2: 'LK', code3: 'LKA' },
  { name: 'Suriname', code2: 'SR', code3: 'SUR' },
  { name: 'Swaziland', code2: 'SZ', code3: 'SWZ' },
  { name: 'Sweden', code2: 'SE', code3: 'SWE' },
  { name: 'Switzerland', code2: 'CH', code3: 'CHE' },
  { name: 'Taiwan', code2: 'TW', code3: 'TWN' },
  { name: 'Tajikistan', code2: 'TJ', code3: 'TJK' },
  { name: 'Thailand', code2: 'TH', code3: 'THA' },
  {
    name: 'The former Yugoslav Republic of Macedonia',
    code2: 'MK',
    code3: 'MKD',
  },
  { name: 'Togo', code2: 'TG', code3: 'TGO' },
  { name: 'Tonga', code2: 'TO', code3: 'TON' },
  { name: 'Trinidad and Tobago', code2: 'TT', code3: 'TTO' },
  { name: 'Tunisia', code2: 'TN', code3: 'TUN' },
  { name: 'Turkey', code2: 'TR', code3: 'TUR' },
  { name: 'Turkmenistan', code2: 'TM', code3: 'TKM' },
  { name: 'Uganda', code2: 'UG', code3: 'UGA' },
  { name: 'Ukraine', code2: 'UA', code3: 'UKR' },
  { name: 'United Arab Emirates', code2: 'AE', code3: 'ARE' },
  { name: 'United Kingdom', code2: 'GB', code3: 'GBR' },
  { name: 'United Republic of Tanzania', code2: 'TZ', code3: 'TZA' },
  { name: 'United States', code2: 'US', code3: 'USA' },
  { name: 'Uruguay', code2: 'UY', code3: 'URY' },
  { name: 'Uzbekistan', code2: 'UZ', code3: 'UZB' },
  { name: 'Vanuatu', code2: 'VU', code3: 'VUT' },
  { name: 'Venezuela', code2: 'VE', code3: 'VEN' },
  { name: 'Vietnam', code2: 'VN', code3: 'VNM' },
  { name: 'Western Sahara', code2: 'EH', code3: 'ESH' },
  { name: 'Yemen', code2: 'YE', code3: 'YEM' },
  { name: 'Zambia', code2: 'ZM', code3: 'ZMB' },
];
// Subdivisions keyed by country alpha-2 code.
export const REGIONS_BY_COUNTRY: Record<string, Region[]> = {
  AL: [
    { code: 'AL-01', name: 'Berat' },
    { code: 'AL-09', name: 'Diber' },
    { code: 'AL-02', name: 'Durres' },
    { code: 'AL-03', name: 'Elbasan' },
    { code: 'AL-04', name: 'Fier' },
    { code: 'AL-05', name: 'Gjirokaster' },
    { code: 'AL-06', name: 'Korce' },
    { code: 'AL-07', name: 'Kukes' },
    { code: 'AL-08', name: 'Lezhe' },
    { code: 'AL-10', name: 'Shkoder' },
    { code: 'AL-11', name: 'Tirane' },
    { code: 'AL-12', name: 'Vlore' },
  ],
  DZ: [
    { code: 'DZ-01', name: 'Adrar' },
    { code: 'DZ-44', name: 'Ain Defla' },
    { code: 'DZ-46', name: 'Ain Temouchent' },
    { code: 'DZ-16', name: 'Alger' },
    { code: 'DZ-23', name: 'Annaba' },
    { code: 'DZ-05', name: 'Batna' },
    { code: 'DZ-08', name: 'Bechar' },
    { code: 'DZ-06', name: 'Bejaia' },
    { code: 'DZ-07', name: 'Biskra' },
    { code: 'DZ-09', name: 'Blida' },
    { code: 'DZ-34', name: 'Bordj Bou Arreridj' },
    { code: 'DZ-10', name: 'Bouira' },
    { code: 'DZ-35', name: 'Boumerdes' },
    { code: 'DZ-02', name: 'Chlef' },
    { code: 'DZ-25', name: 'Constantine' },
    { code: 'DZ-17', name: 'Djelfa' },
    { code: 'DZ-32', name: 'El Bayadh' },
    { code: 'DZ-39', name: 'El Oued' },
    { code: 'DZ-36', name: 'El Tarf' },
    { code: 'DZ-47', name: 'Ghardaia' },
    { code: 'DZ-24', name: 'Guelma' },
    { code: 'DZ-33', name: 'Illizi' },
    { code: 'DO-42', name: 'Jijel' },
    { code: 'DZ-40', name: 'Khenchela' },
    { code: 'DZ-03', name: 'Laghouat' },
    { code: 'DZ-28', name: "M'sila" },
    { code: 'DZ-29', name: 'Mascara' },
    { code: 'DZ-26', name: 'Medea' },
    { code: 'DZ-43', name: 'Mila' },
    { code: 'DZ-27', name: 'Mostaganem' },
    { code: 'DZ-45', name: 'Naama' },
    { code: 'DZ-31', name: 'Oran' },
    { code: 'DZ-30', name: 'Ouargla' },
    { code: 'DZ-04', name: 'Oum el Bouaghi' },
    { code: 'DZ-48', name: 'Relizane' },
    { code: 'DZ-20', name: 'Saida' },
    { code: 'DZ-19', name: 'Setif' },
    { code: 'DZ-22', name: 'Sidi Bel Abbes' },
    { code: 'DZ-21', name: 'Skikda' },
    { code: 'DZ-41', name: 'Souk Ahras' },
    { code: 'DZ-11', name: 'Tamanghasset' },
    { code: 'DZ-12', name: 'Tebessa' },
    { code: 'DZ-14', name: 'Tiaret' },
    { code: 'DZ-37', name: 'Tindouf' },
    { code: 'DZ-42', name: 'Tipaza' },
    { code: 'DZ-38', name: 'Tissemsilt' },
    { code: 'DZ-15', name: 'Tizi Ouzou' },
    { code: 'DZ-13', name: 'Tlemcen' },
  ],
  AD: [
    { code: 'AD-07', name: 'Andorra la Vella' },
    { code: 'AD-02', name: 'Canillo' },
    { code: 'AD-03', name: 'Encamp' },
    { code: 'AD-08', name: 'Escaldes-Engordany' },
    { code: 'AD-04', name: 'La Massana' },
    { code: 'AD-05', name: 'Ordino' },
    { code: 'AD-06', name: 'Sant Julia de Loria' },
  ],
  AG: [
    { code: 'AG-10', name: 'Antigua and Barbuda' },
    { code: 'AG-11', name: 'Redonda' },
    { code: 'AG-03', name: 'Saint George' },
    { code: 'AG-04', name: 'Saint John' },
    { code: 'AG-05', name: 'Saint Mary' },
    { code: 'AG-06', name: 'Saint Paul' },
    { code: 'AG-07', name: 'Saint Peter' },
    { code: 'AG-08', name: 'Saint Philip' },
  ],
  AR: [
    { code: 'AR-B', name: 'Buenos Aires' },
    { code: 'AR-K', name: 'Catamarca' },
    { code: 'AR-H', name: 'Chaco' },
    { code: 'AR-U', name: 'Chubut' },
    { code: 'AR-C', name: 'Ciudad Autonoma de Buenos Aires' },
    { code: 'AR-X', name: 'Cordoba' },
    { code: 'AR-W', name: 'Corrientes' },
    { code: 'AR-E', name: 'Entre Rios' },
    { code: 'AR-P', name: 'Formosa' },
    { code: 'AR-Y', name: 'Jujuy' },
    { code: 'AR-L', name: 'La Pampa' },
    { code: 'AR-F', name: 'La Rioja' },
    { code: 'AR-M', name: 'Mendoza' },
    { code: 'AR-N', name: 'Misiones' },
    { code: 'AR-Q', name: 'Neuquen' },
    { code: 'AR-R', name: 'Rio Negro' },
    { code: 'AR-A', name: 'Salta' },
    { code: 'AR-J', name: 'San Juan' },
    { code: 'AR-D', name: 'San Luis' },
    { code: 'AR-Z', name: 'Santa Cruz' },
    { code: 'AR-S', name: 'Santa Fe' },
    { code: 'AR-G', name: 'Santiago del Estero' },
    { code: 'AR-V', name: 'Tierra del Fuego' },
    { code: 'AR-T', name: 'Tucuman' },
  ],
  AM: [
    { code: 'AM-AG', name: 'Aragatsotn' },
    { code: 'AM-AR', name: 'Ararat' },
    { code: 'AM-AV', name: 'Armavir' },
    { code: 'AM-GR', name: "Geghark'unik'" },
    { code: 'AM-KT', name: "Kotayk'" },
    { code: 'AM-LO', name: 'Lorri' },
    { code: 'AM-SH', name: 'Shirak' },
    { code: 'AM-SU', name: "Syunik'" },
    { code: 'AM-TV', name: 'Tavush' },
    { code: 'AM-VD', name: "Vayots' Dzor" },
    { code: 'AM-ER', name: 'Yerevan' },
  ],
  AU: [
    { code: 'AU-ACT', name: 'Australian Capital Territory' },
    { code: 'AU-NSW', name: 'New South Wales' },
    { code: 'AU-NT', name: 'Northern Territory' },
    { code: 'AU-QLD', name: 'Queensland' },
    { code: 'AU-SA', name: 'South Australia' },
    { code: 'AU-TAS', name: 'Tasmania' },
    { code: 'AU-VIC', name: 'Victoria' },
    { code: 'AU-WA', name: 'Western Australia' },
  ],
  AT: [
    { code: 'AT-1', name: 'Burgenland' },
    { code: 'AT-2', name: 'Karnten' },
    { code: 'AT-3', name: 'Niederosterreich' },
    { code: 'AT-4', name: 'Oberosterreich' },
    { code: 'AT-5', name: 'Salzburg' },
    { code: 'AT-6', name: 'Steiermark' },
    { code: 'AT-7', name: 'Tirol' },
    { code: 'AT-8', name: 'Vorarlberg' },
    { code: 'AT-9', name: 'Wien' },
  ],
  AZ: [
    { code: 'AZ-ABS', name: 'Abseron' },
    { code: 'AZ-AGC', name: 'Agcabadi' },
    { code: 'AZ-AGM', name: 'Agdam' },
    { code: 'AZ-AGS', name: 'Agdas' },
    { code: 'AZ-AGA', name: 'Agstafa' },
    { code: 'AZ-AGU', name: 'Agsu' },
    { code: 'AZ-AST', name: 'Astara' },
    { code: 'AZ-BA', name: 'Baki' },
    { code: 'AZ-BAL', name: 'Balakan' },
    { code: 'AZ-BAR', name: 'Barda' },
    { code: 'AZ-BEY', name: 'Beylaqan' },
    { code: 'AZ-BIL', name: 'Bilasuvar' },
    { code: 'AZ-CAB', name: 'Cabrayil' },
    { code: 'AZ-CAL', name: 'Calilabad' },
    { code: 'AZ-DAS', name: 'Daskasan' },
    { code: 'AZ-FUZ', name: 'Fuzuli' },
    { code: 'AZ-GAD', name: 'Gadabay' },
    { code: 'AZ-GA', name: 'Ganca' },
    { code: 'AZ-GOR', name: 'Goranboy' },
    { code: 'AZ-GOY', name: 'Goycay' },
    { code: 'AZ-HAC', name: 'Haciqabul' },
    { code: 'AZ-IMI', name: 'Imisli' },
    { code: 'AZ-ISM', name: 'Ismayilli' },
    { code: 'AZ-KAL', name: 'Kalbacar' },
    { code: 'AZ-LAC', name: 'Lacin' },
    { code: 'AZ-LAN', name: 'Lankaran' },
    { code: 'AZ-LER', name: 'Lerik' },
    { code: 'AZ-MAS', name: 'Masalli' },
    { code: 'AZ-MI', name: 'Mingacevir' },
    { code: 'AZ-NA', name: 'Naftalan' },
    { code: 'AZ-NV', name: 'Naxcivan' },
    { code: 'AZ-NEF', name: 'Neftcala' },
    { code: 'AZ-OGU', name: 'Oguz' },
    { code: 'AZ-QAB', name: 'Qabala' },
    { code: 'AZ-QAX', name: 'Qax' },
    { code: 'AZ-QAZ', name: 'Qazax' },
    { code: 'AZ-QOB', name: 'Qobustan' },
    { code: 'AZ-QBA', name: 'Quba' },
    { code: 'AZ-QBI', name: 'Qubadli' },
    { code: 'AZ-QUS', name: 'Qusar' },
    { code: 'AZ-SAT', name: 'Saatli' },
    { code: 'AZ-SAB', name: 'Sabirabad' },
    { code: 'AZ-SAK', name: 'Saki' },
    { code: 'AZ-SAL', name: 'Salyan' },
    { code: 'AZ-SMI', name: 'Samaxi' },
    { code: 'AZ-SKR', name: 'Samkir' },
    { code: 'AZ-SMX', name: 'Samux' },
    { code: 'AZ-SM', name: 'Sumqayit' },
    { code: 'AZ-SUS', name: 'Susa' },
    { code: 'AZ-TAR', name: 'Tartar' },
    { code: 'AZ-TOV', name: 'Tovuz' },
    { code: 'AZ-UCA', name: 'Ucar' },
    { code: 'AZ-XAC', name: 'Xacmaz' },
    { code: 'AZ-XA', name: 'Xankandi' },
    { code: 'AZ-XIZ', name: 'Xizi' },
    { code: 'AZ-XCI', name: 'Xocali' },
    { code: 'AZ-XVD', name: 'Xocavand' },
    { code: 'AZ-YAR', name: 'Yardimli' },
    { code: 'AZ-YEV', name: 'Yevlax' },
    { code: 'AZ-ZAN', name: 'Zangilan' },
    { code: 'AZ-ZAQ', name: 'Zaqatala' },
    { code: 'AZ-ZAR', name: 'Zardab' },
  ],
  BS: [
    { code: 'BI-BL', name: 'Acklins' },
    { code: 'BS-BP', name: 'Berry Islands' },
    { code: 'BS-AK', name: 'Bimini' },
    { code: 'BS-BI', name: 'Black Point' },
    { code: 'BS-CE', name: 'Cat Island' },
    { code: 'BS-CK', name: 'Central Abaco' },
    { code: 'BS-CO', name: 'Central Andros' },
    { code: 'BS-BY', name: 'Central Eleuthera' },
    { code: 'BS-EX', name: 'City of Freeport' },
    { code: 'BS-CI', name: 'Crooked Island and Long Cay' },
    { code: 'BS-CS', name: 'East Grand Bahama' },
    { code: 'BS-EG', name: 'Exuma' },
    { code: 'BS-FP', name: 'Grand Cay' },
    { code: 'BS-GC', name: 'Harbour Island' },
    { code: 'BS-HI', name: 'Hope Town' },
    { code: 'BS-HT', name: 'Inagua' },
    { code: 'BS-IN', name: 'Long Island' },
    { code: 'BS-LI', name: 'Mangrove Cay' },
    { code: 'BS-MC', name: 'Mayaguana' },
    { code: 'BS-MG', name: 'Moores Island' },
    { code: 'BS-NP', name: 'New Providence' },
    { code: 'BS-NE', name: 'North Abaco' },
    { code: 'BS-NO', name: 'North Andros' },
    { code: 'BS-MI', name: 'North Eleuthera' },
    { code: 'BS-RC', name: 'Ragged Island' },
    { code: 'BS-NS', name: 'Rum Cay' },
    { code: 'BS-SO', name: 'San Salvador' },
    { code: 'BS-SE', name: 'South Abaco' },
    { code: 'BS-RI', name: 'South Andros' },
    { code: 'BS-SA', name: 'South Eleuthera' },
    { code: 'BS-SS', name: 'Spanish Wells' },
    { code: 'BS-SW', name: 'West Grand Bahama' },
  ],
  BH: [
    { code: 'BH-13', name: 'Al Asimah' },
    { code: 'BH-14', name: 'Al Janubiyah' },
    { code: 'BH-15', name: 'Al Muharraq' },
    { code: 'BH-16', name: 'Al Wusta' },
    { code: 'BH-17', name: 'Ash Shamaliyah' },
  ],
  BD: [
    { code: 'BD-A', name: 'Barisal' },
    { code: 'BD-B', name: 'Chittagong' },
    { code: 'BD-C', name: 'Dhaka' },
    { code: 'BD-D', name: 'Khulna' },
    { code: 'BD-E', name: 'Rajshahi' },
    { code: 'BD-F', name: 'Rangpur' },
    { code: 'BD-G', name: 'Sylhet' },
  ],
  BB: [
    { code: 'BB-01', name: 'Christ Church' },
    { code: 'BB-02', name: 'Saint Andrew' },
    { code: 'BB-03', name: 'Saint George' },
    { code: 'BB-04', name: 'Saint James' },
    { code: 'BB-05', name: 'Saint John' },
    { code: 'BB-06', name: 'Saint Joseph' },
    { code: 'BB-07', name: 'Saint Lucy' },
    { code: 'BB-08', name: 'Saint Michael' },
    { code: 'BB-09', name: 'Saint Peter' },
    { code: 'BB-10', name: 'Saint Philip' },
    { code: 'BB-11', name: 'Saint Thomas' },
  ],
  BE: [
    { code: 'BE-VAN', name: 'Antwerpen' },
    { code: 'BE-WBR', name: 'Brabant Wallon' },
    { code: 'BE-BRU', name: 'Brussels Hoofdstedelijk Gewest' },
    { code: 'BE-WHT', name: 'Hainaut' },
    { code: 'BE-WLG', name: 'Liege' },
    { code: 'BE-VLI', name: 'Limburg' },
    { code: 'BE-WLX', name: 'Luxembourg' },
    { code: 'BE-WNA', name: 'Namur' },
    { code: 'BE-VOV', name: 'Oost-Vlaanderen' },
    { code: 'BE-VLG', name: 'Vlaams Gewest' },
    { code: 'BE-VBR', name: 'Vlaams-Brabant' },
    { code: 'BE-WAL', name: 'Wallonne' },
    { code: 'BE-VWV', name: 'West-Vlaanderen' },
  ],
  BZ: [
    { code: 'BZ-BZ', name: 'Belize' },
    { code: 'BZ-CY', name: 'Cayo' },
    { code: 'BZ-CZL', name: 'Corozal' },
    { code: 'BZ-OW', name: 'Orange Walk' },
    { code: 'BZ-SC', name: 'Stann Creek' },
    { code: 'BZ-TOL', name: 'Toledo' },
  ],
  BJ: [
    { code: 'BJ-AL', name: 'Alibori' },
    { code: 'BJ-AK', name: 'Atakora' },
    { code: 'BJ-AQ', name: 'Atlantique' },
    { code: 'BJ-BO', name: 'Borgou' },
    { code: 'BJ-CO', name: 'Collines' },
    { code: 'BJ-DO', name: 'Donga' },
    { code: 'BJ-KO', name: 'Kouffo' },
    { code: 'BJ-LI', name: 'Littoral' },
    { code: 'BJ-MO', name: 'Mono' },
    { code: 'BJ-OU', name: 'Oueme' },
    { code: 'BJ-PL', name: 'Plateau' },
    { code: 'BJ-ZO', name: 'Zou' },
  ],
  BT: [
    { code: 'BT-31', name: 'Bumthang' },
    { code: 'BT-12', name: 'Chhukha' },
    { code: 'BT-22', name: 'Daga' },
    { code: 'BT-GA', name: 'Gasa' },
    { code: 'BT-13', name: 'Ha' },
    { code: 'BT-43', name: 'Lhuentse' },
    { code: 'BT-42', name: 'Mongar' },
    { code: 'BT-11', name: 'Paro' },
    { code: 'BT-41', name: 'Pemagatshel' },
    { code: 'BT-23', name: 'Punakha' },
    { code: 'BT-44', name: 'Samdrup Jongkha' },
    { code: 'BS-WG', name: 'Samtse' },
    { code: 'BT-24', name: 'Sarpang' },
    { code: 'BT-34', name: 'Shemgang' },
    { code: 'BT-15', name: 'Thimphu' },
    { code: 'BT-32', name: 'Tongsa' },
    { code: 'BT-TY', name: 'Trashi Yangste' },
    { code: 'BT-33', name: 'Trashigang' },
    { code: 'BT-14', name: 'Tsirang' },
    { code: 'BT-21', name: 'Wangdue Phodrang' },
  ],
  BO: [
    { code: 'BO-H', name: 'Chuquisaca' },
    { code: 'BO-C', name: 'Cochabamba' },
    { code: 'BO-B', name: 'El Beni' },
    { code: 'BO-L', name: 'La Paz' },
    { code: 'BO-O', name: 'Oruro' },
    { code: 'BO-N', name: 'Pando' },
    { code: 'BO-P', name: 'Potosi' },
    { code: 'BO-S', name: 'Santa Cruz' },
    { code: 'BO-T', name: 'Tarija' },
  ],
  BA: [
    { code: 'BA-BIH', name: 'Federation of Bosnia and Herzegovina' },
    { code: 'BA-SRP', name: 'Republika Srpska' },
  ],
  BW: [
    { code: 'BW-CE', name: 'Central' },
    { code: 'BW-GH', name: 'Ghanzi' },
    { code: 'BW-KG', name: 'Kgalagadi' },
    { code: 'BW-KL', name: 'Kgatleng' },
    { code: 'BW-KW', name: 'Kweneng' },
    { code: 'BW-NE', name: 'North-East' },
    { code: 'BW-NW', name: 'North-West' },
    { code: 'BW-SE', name: 'South-East' },
    { code: 'BW-SO', name: 'Southern' },
  ],
  BR: [
    { code: 'BR-AC', name: 'Acre' },
    { code: 'BR-AL', name: 'Alagoas' },
    { code: 'BR-AP', name: 'Amapa' },
    { code: 'BR-AM', name: 'Amazonas' },
    { code: 'BR-BA', name: 'Bahia' },
    { code: 'BR-CE', name: 'Ceara' },
    { code: 'BR-DF', name: 'Distrito Federal' },
    { code: 'BR-ES', name: 'Espirito Santo' },
    { code: 'BR-GO', name: 'Goias' },
    { code: 'BR-MA', name: 'Maranhao' },
    { code: 'BR-MT', name: 'Mato Grosso' },
    { code: 'BR-MS', name: 'Mato Grosso do Sul' },
    { code: 'BR-MG', name: 'Minas Gerais' },
    { code: 'BR-PA', name: 'Para' },
    { code: 'BR-PB', name: 'Paraiba' },
    { code: 'BR-PR', name: 'Parana' },
    { code: 'BR-PE', name: 'Pernambuco' },
    { code: 'BR-PI', name: 'Piaui' },
    { code: 'BR-RJ', name: 'Rio de Janeiro' },
    { code: 'BR-RN', name: 'Rio Grande do Norte' },
    { code: 'BR-RS', name: 'Rio Grande do Sul' },
    { code: 'BR-RO', name: 'Rondonia' },
    { code: 'BR-RR', name: 'Roraima' },
    { code: 'BR-SC', name: 'Santa Catarina' },
    { code: 'BR-SP', name: 'Sao Paulo' },
    { code: 'BR-SE', name: 'Sergipe' },
    { code: 'BR-TO', name: 'Tocantins' },
  ],
  BN: [
    { code: 'BN-BE', name: 'Belait' },
    { code: 'BN-BM', name: 'Brunei and Muara' },
    { code: 'BN-TE', name: 'Temburong' },
    { code: 'BN-TU', name: 'Tutong' },
  ],
  BG: [
    { code: 'BG-01', name: 'Blagoevgrad' },
    { code: 'BG-02', name: 'Burgas' },
    { code: 'BG-08', name: 'Dobrich' },
    { code: 'BG-07', name: 'Gabrovo' },
    { code: 'BG-22', name: 'Grad Sofiya' },
    { code: 'BG-26', name: 'Khaskovo' },
    { code: 'BG-09', name: 'Kurdzhali' },
    { code: 'BG-10', name: 'Kyustendil' },
    { code: 'BG-11', name: 'Lovech' },
    { code: 'BG-12', name: 'Montana' },
    { code: 'BG-13', name: 'Pazardzhik' },
    { code: 'BG-14', name: 'Pernik' },
    { code: 'BG-15', name: 'Pleven' },
    { code: 'BG-16', name: 'Plovdiv' },
    { code: 'BG-17', name: 'Razgrad' },
    { code: 'BG-18', name: 'Ruse' },
    { code: 'BG-27', name: 'Shumen' },
    { code: 'BG-19', name: 'Silistra' },
    { code: 'BG-20', name: 'Sliven' },
    { code: 'BG-21', name: 'Smolyan' },
    { code: 'BG-23', name: 'Sofiya' },
    { code: 'BG-24', name: 'Stara Zagora' },
    { code: 'BG-25', name: 'Turgovishte' },
    { code: 'BG-03', name: 'Varna' },
    { code: 'BG-04', name: 'Veliko Turnovo' },
    { code: 'BG-05', name: 'Vidin' },
    { code: 'BG-06', name: 'Vratsa' },
    { code: 'BG-28', name: 'Yambol' },
  ],
  BF: [
    { code: 'BF-BAL', name: 'Bale' },
    { code: 'BF-BAM', name: 'Bam' },
    { code: 'BF-BAN', name: 'Banwa' },
    { code: 'BF-BAZ', name: 'Bazega' },
    { code: 'BF-BGR', name: 'Bougouriba' },
    { code: 'BF-BLG', name: 'Boulgou' },
    { code: 'BF-BLK', name: 'Boulkiemde' },
    { code: 'BF-GAN', name: 'Ganzourgou' },
    { code: 'BF-GNA', name: 'Gnagna' },
    { code: 'BF-GOU', name: 'Gourma' },
    { code: 'BF-HOU', name: 'Houet' },
    { code: 'BF-IOB', name: 'Ioba' },
    { code: 'BF-KAD', name: 'Kadiogo' },
    { code: 'BF-KEN', name: 'Kenedougou' },
    { code: 'BF-COM', name: 'Komoe' },
    { code: 'BF-KMD', name: 'Komondjari' },
    { code: 'BF-KMP', name: 'Kompienga' },
    { code: 'BF-KOS', name: 'Kossi' },
    { code: 'BF-KOP', name: 'Koulpelogo' },
    { code: 'BF-KOT', name: 'Kouritenga' },
    { code: 'BF-KOW', name: 'Kourweogo' },
    { code: 'BF-LER', name: 'Leraba' },
    { code: 'BF-LOR', name: 'Loroum' },
    { code: 'BF-MOU', name: 'Mouhoun' },
    { code: 'BF-NAM', name: 'Namentenga' },
    { code: 'BF-NAO', name: 'Naouri' },
    { code: 'BF-NAY', name: 'Nayala' },
    { code: 'BF-NOU', name: 'Noumbiel' },
    { code: 'BF-OUB', name: 'Oubritenga' },
    { code: 'BF-OUD', name: 'Oudalan' },
    { code: 'BF-PAS', name: 'Passore' },
    { code: 'BF-PON', name: 'Poni' },
    { code: 'BF-SNG', name: 'Sanguie' },
    { code: 'BF-SMT', name: 'Sanmatenga' },
    { code: 'BF-SEN', name: 'Seno' },
    { code: 'BF-SIS', name: 'Sissili' },
    { code: 'BF-SOM', name: 'Soum' },
    { code: 'BF-SOR', name: 'Sourou' },
    { code: 'BF-TAP', name: 'Tapoa' },
    { code: 'BF-TUI', name: 'Tuy' },
    { code: 'BF-YAG', name: 'Yagha' },
    { code: 'BF-YAT', name: 'Yatenga' },
    { code: 'BF-ZIR', name: 'Ziro' },
    { code: 'BF-ZON', name: 'Zondoma' },
    { code: 'BF-ZOU', name: 'Zoundweogo' },
  ],
  BI: [
    { code: 'BI-BB', name: 'Bubanza' },
    { code: 'BI-BM', name: 'Bujumbura Mairie' },
    { code: 'BI-BR', name: 'Bururi' },
    { code: 'BI-CA', name: 'Cankuzo' },
    { code: 'BI-CI', name: 'Cibitoke' },
    { code: 'BI-GI', name: 'Gitega' },
    { code: 'BI-KR', name: 'Karuzi' },
    { code: 'BI-KY', name: 'Kayanza' },
    { code: 'BI-KI', name: 'Kirundo' },
    { code: 'BI-MA', name: 'Makamba' },
    { code: 'BI-MU', name: 'Muramvya' },
    { code: 'BI-MY', name: 'Muyinga' },
    { code: 'BI-MW', name: 'Mwaro' },
    { code: 'BI-NG', name: 'Ngozi' },
    { code: 'BI-RT', name: 'Rutana' },
    { code: 'BI-RY', name: 'Ruyigi' },
  ],
  KH: [
    { code: 'KH-1', name: 'Banteay Meanchey' },
    { code: 'KH-2', name: 'Battambang' },
    { code: 'KH-3', name: 'Kampong Cham' },
    { code: 'KH-4', name: 'Kampong Chhnang' },
    { code: 'KH-5', name: 'Kampong Speu' },
    { code: 'KH-6', name: 'Kampong Thom' },
    { code: 'KH-7', name: 'Kampot' },
    { code: 'KH-8', name: 'Kandal' },
    { code: 'KH-23', name: 'Kep' },
    { code: 'KH-9', name: 'Koh Kong' },
    { code: 'KH-10', name: 'Kratie' },
    { code: 'KH-11', name: 'Mondulkiri' },
    { code: 'KH-22', name: 'Oddar Meanchey' },
    { code: 'KH-24', name: 'Pailin' },
    { code: 'KH-12', name: 'Phnom Penh' },
    { code: 'KH-18', name: 'Preah Sihanouk' },
    { code: 'KH-13', name: 'Preah Vihear' },
    { code: 'KH-14', name: 'Prey Veng' },
    { code: 'KH-15', name: 'Pursat' },
    { code: 'KH-16', name: 'Ratanakiri' },
    { code: 'KH-17', name: 'Siem Reap' },
    { code: 'KH-19', name: 'Stung Treng' },
    { code: 'KH-20', name: 'Svay Rieng' },
    { code: 'KH-21', name: 'Takeo' },
  ],
  CM: [
    { code: 'CM-AD', name: 'Adamaoua' },
    { code: 'CM-CE', name: 'Centre' },
    { code: 'CM-ES', name: 'Est' },
    { code: 'CM-EN', name: 'Extreme-Nord' },
    { code: 'CM-LT', name: 'Littoral' },
    { code: 'CM-NO', name: 'Nord' },
    { code: 'CM-NW', name: 'Nord-Ouest' },
    { code: 'CM-OU', name: 'Ouest' },
    { code: 'CM-SU', name: 'Sud' },
    { code: 'CM-SW', name: 'Sud-Ouest' },
  ],
  CA: [
    { code: 'CA-AB', name: 'Alberta' },
    { code: 'CA-BC', name: 'British Columbia' },
    { code: 'CA-MB', name: 'Manitoba' },
    { code: 'CA-NB', name: 'New Brunswick' },
    { code: 'CA-NL', name: 'Newfoundland and Labrador' },
    { code: 'CA-NT', name: 'Northwest Territories' },
    { code: 'CA-NS', name: 'Nova Scotia' },
    { code: 'CA-NU', name: 'Nunavut' },
    { code: 'CA-ON', name: 'Ontario' },
    { code: 'CA-PE', name: 'Prince Edward Island' },
    { code: 'CA-QC', name: 'Quebec' },
    { code: 'CA-SK', name: 'Saskatchewan' },
    { code: 'CA-YT', name: 'Yukon' },
  ],
  CV: [
    { code: 'CV-BV', name: 'Boa Vista' },
    { code: 'CV-BR', name: 'Brava' },
    { code: 'CV-MA', name: 'Maio' },
    { code: 'CV-MO', name: 'Mosteiros' },
    { code: 'CV-PA', name: 'Paul' },
    { code: 'CV-PN', name: 'Porto Novo' },
    { code: 'CV-PR', name: 'Praia' },
    { code: 'CV-RB', name: 'Ribeira Brava' },
    { code: 'CV-RG', name: 'Ribeira Grande' },
    { code: 'CV-RS', name: 'Ribeira Grande de Santiago' },
    { code: 'CV-SL', name: 'Sal' },
    { code: 'CV-CA', name: 'Santa Catarina' },
    { code: 'CV-CF', name: 'Santa Catarina do Fogo' },
    { code: 'CV-CR', name: 'Santa Cruz' },
    { code: 'CV-SD', name: 'Sao Domingos' },
    { code: 'CV-SF', name: 'Sao Filipe' },
    { code: 'CV-SM', name: 'Sao Miguel' },
    { code: 'CV-SS', name: 'Sao Salvador do Mundo' },
    { code: 'CV-SV', name: 'Sao Vicente' },
    { code: 'CV-TA', name: 'Tarrafal' },
    { code: 'CV-TS', name: 'Tarrafal de Sao Nicolau' },
  ],
  CF: [
    { code: 'CF-BB', name: 'Bamingui-Bangoran' },
    { code: 'CF-BGF', name: 'Bangui' },
    { code: 'CF-BK', name: 'Basse-Kotto' },
    { code: 'CF-HM', name: 'Haut-Mbomou' },
    { code: 'CF-HK', name: 'Haute-Kotto' },
    { code: 'CF-KG', name: 'Kemo' },
    { code: 'CF-LB', name: 'Lobaye' },
    { code: 'CF-HS', name: 'Mambere-Kadei' },
    { code: 'CF-MB', name: 'Mbomou' },
    { code: 'CF-NM', name: 'Nana-Mambere' },
    { code: 'CF-MP', name: 'Ombella-Mpoko' },
    { code: 'CF-UK', name: 'Ouaka' },
    { code: 'CF-AC', name: 'Ouham' },
    { code: 'CF-OP', name: 'Ouham-Pende' },
    { code: 'CF-SE', name: 'Sangha-Mbaere' },
  ],
  TD: [
    { code: 'TD-BG', name: 'Barh el Ghazel' },
    { code: 'TD-BA', name: 'Batha' },
    { code: 'TD-BO', name: 'Borkou' },
    { code: 'TD-CB', name: 'Chari-Baguirmi' },
    { code: 'TD-EE', name: 'Ennedi-Est' },
    { code: 'TD-EO', name: 'Ennedi-Ouest' },
    { code: 'TD-GR', name: 'Guera' },
    { code: 'TD-HL', name: 'Hadjer-Lamis' },
    { code: 'TD-KA', name: 'Kanem' },
    { code: 'TD-LC', name: 'Lac' },
    { code: 'TD-LO', name: 'Logone Occidental' },
    { code: 'TD-LR', name: 'Logone Oriental' },
    { code: 'TD-MA', name: 'Mandoul' },
    { code: 'TD-ME', name: 'Mayo-Kebbi Est' },
    { code: 'TD-MO', name: 'Mayo-Kebbi Ouest' },
    { code: 'TD-MC', name: 'Moyen-Chari' },
    { code: 'TD-OD', name: 'Ouaddai' },
    { code: 'TD-SA', name: 'Salamat' },
    { code: 'TD-SI', name: 'Sila' },
    { code: 'TD-TA', name: 'Tandjile' },
    { code: 'TD-TI', name: 'Tibesti' },
    { code: 'TD-ND', name: 'Ville de Ndjamena' },
    { code: 'TD-WF', name: 'Wadi Fira' },
  ],
  CL: [
    { code: 'CL-AI', name: 'Aisen del General Carlos Ibanez del Campo' },
    { code: 'CL-AN', name: 'Antofagasta' },
    { code: 'CL-AR', name: 'Araucania' },
    { code: 'CL-AP', name: 'Arica y Parinacota' },
    { code: 'CL-AT', name: 'Atacama' },
    { code: 'CL-BI', name: 'Bio-Bio' },
    { code: 'CL-CO', name: 'Coquimbo' },
    { code: 'CL-LI', name: "Libertador General Bernardo O'Higgins" },
    { code: 'CL-LL', name: 'Los Lagos' },
    { code: 'CL-LR', name: 'Los Rios' },
    { code: 'CL-MA', name: 'Magallanes y de la Antartica Chilena' },
    { code: 'CL-ML', name: 'Maule' },
    { code: 'CL-RM', name: 'Region Metropolitana' },
    { code: 'CL-TA', name: 'Tarapaca' },
    { code: 'CL-VS', name: 'Valparaiso' },
  ],
  CN: [
    { code: 'CN-34', name: 'Anhui' },
    { code: 'CN-11', name: 'Beijing' },
    { code: 'CN-50', name: 'Chongqing' },
    { code: 'CN-35', name: 'Fujian' },
    { code: 'CN-62', name: 'Gansu' },
    { code: 'CN-44', name: 'Guangdong' },
    { code: 'CN-45', name: 'Guangxi' },
    { code: 'CN-52', name: 'Guizhou' },
    { code: 'CN-46', name: 'Hainan' },
    { code: 'CN-13', name: 'Hebei' },
    { code: 'CN-23', name: 'Heilongjiang' },
    { code: 'CN-41', name: 'Henan' },
    { code: 'CN-42', name: 'Hubei' },
    { code: 'CN-43', name: 'Hunan' },
    { code: 'CN-32', name: 'Jiangsu' },
    { code: 'CN-36', name: 'Jiangxi' },
    { code: 'CN-22', name: 'Jilin' },
    { code: 'CN-21', name: 'Liaoning' },
    { code: 'CN-15', name: 'Nei Menggu' },
    { code: 'CN-64', name: 'Ningxia' },
    { code: 'CN-63', name: 'Qinghai' },
    { code: 'CN-61', name: 'Shaanxi' },
    { code: 'CN-37', name: 'Shandong' },
    { code: 'CN-31', name: 'Shanghai' },
    { code: 'CN-14', name: 'Shanxi' },
    { code: 'CN-51', name: 'Sichuan' },
    { code: 'CN-12', name: 'Tianjin' },
    { code: 'CN-65', name: 'Xinjiang' },
    { code: 'CN-54', name: 'Xizang' },
    { code: 'CN-53', name: 'Yunnan' },
    { code: 'CN-33', name: 'Zhejiang' },
  ],
  CO: [
    { code: 'CO-AMA', name: 'Amazonas' },
    { code: 'CO-ANT', name: 'Antioquia' },
    { code: 'CO-ARA', name: 'Arauca' },
    { code: 'CO-ATL', name: 'Atlantico' },
    { code: 'CO-BOL', name: 'Bolivar' },
    { code: 'CO-BOY', name: 'Boyaca' },
    { code: 'CO-CAL', name: 'Caldas' },
    { code: 'CO-CAQ', name: 'Caqueta' },
    { code: 'CO-CAS', name: 'Casanare' },
    { code: 'CO-CAU', name: 'Cauca' },
    { code: 'CO-CES', name: 'Cesar' },
    { code: 'CO-CHO', name: 'Choco' },
    { code: 'CO-COR', name: 'Cordoba' },
    { code: 'CO-CUN', name: 'Cundinamarca' },
    { code: 'BT-45', name: 'Distrito Capital de Bogota' },
    { code: 'CO-GUA', name: 'Guainia' },
    { code: 'CO-GUV', name: 'Guaviare' },
    { code: 'CO-HUI', name: 'Huila' },
    { code: 'CO-LAG', name: 'La Guajira' },
    { code: 'CO-MAG', name: 'Magdalena' },
    { code: 'CO-MET', name: 'Meta' },
    { code: 'CO-NAR', name: 'Narino' },
    { code: 'CO-NSA', name: 'Norte de Santander' },
    { code: 'CO-PUT', name: 'Putumayo' },
    { code: 'CO-QUI', name: 'Quindio' },
    { code: 'CO-RIS', name: 'Risaralda' },
    { code: 'CO-SAP', name: 'San Andres y Providencia' },
    { code: 'CO-SAN', name: 'Santander' },
    { code: 'CO-SUC', name: 'Sucre' },
    { code: 'CO-TOL', name: 'Tolima' },
    { code: 'CO-VAC', name: 'Valle del Cauca' },
    { code: 'CO-VAU', name: 'Vaupes' },
    { code: 'CO-VID', name: 'Vichada' },
  ],
  KM: [
    { code: 'KM-A', name: 'Anjouan' },
    { code: 'KM-G', name: 'Grande Comore' },
    { code: 'KM-M', name: 'Moheli' },
  ],
  CR: [
    { code: 'CR-A', name: 'Alajuela' },
    { code: 'CR-C', name: 'Cartago' },
    { code: 'CR-G', name: 'Guanacaste' },
    { code: 'CR-H', name: 'Heredia' },
    { code: 'CR-L', name: 'Limon' },
    { code: 'CR-P', name: 'Puntarenas' },
    { code: 'CR-SJ', name: 'San Jose' },
  ],
  HR: [
    { code: 'HR-07', name: 'Bjelovarsko-Bilogorska' },
    { code: 'HR-12', name: 'Brodsko-Posavska' },
    { code: 'HR-19', name: 'Dubrovacko-Neretvanska' },
    { code: 'HR-21', name: 'Grad Zagreb' },
    { code: 'HR-18', name: 'Istarska' },
    { code: 'HR-04', name: 'Karlovacka' },
    { code: 'HR-06', name: 'Koprivnicko-Krizevacka' },
    { code: 'HR-02', name: 'Krapinsko-Zagorska' },
    { code: 'HR-09', name: 'Licko-Senjska' },
    { code: 'HR-20', name: 'Medimurska' },
    { code: 'HR-14', name: 'Osjecko-Baranjska' },
    { code: 'HR-11', name: 'Pozesko-Slavonska' },
    { code: 'HR-08', name: 'Primorsko-Goranska' },
    { code: 'HR-15', name: 'Sibensko-Kninska' },
    { code: 'HR-03', name: 'Sisacko-Moslavacka' },
    { code: 'HR-17', name: 'Splitsko-Dalmatinska' },
    { code: 'HR-05', name: 'Varazdinska' },
    { code: 'HR-10', name: 'Viroviticko-Podravska' },
    { code: 'HR-16', name: 'Vukovarsko-Srijemska' },
    { code: 'HR-13', name: 'Zadarska' },
    { code: 'HR-01', name: 'Zagrebacka' },
  ],
  CY: [
    { code: 'CY-04', name: 'Famagusta' },
    { code: 'CY-06', name: 'Kyrenia' },
    { code: 'CY-03', name: 'Larnaca' },
    { code: 'CY-02', name: 'Limassol' },
    { code: 'CY-01', name: 'Nicosia' },
    { code: 'CY-05', name: 'Paphos' },
  ],
  CZ: [
    { code: 'CZ-PR', name: 'Hlavni mesto Praha' },
    { code: 'CZ-JC', name: 'Jihocesky kraj' },
    { code: 'CZ-JM', name: 'Jihomoravsky kraj' },
    { code: 'CZ-KA', name: 'Karlovarsky kraj' },
    { code: 'CZ-KR', name: 'Kralovehradecky kraj' },
    { code: 'CZ-LI', name: 'Liberecky kraj' },
    { code: 'CZ-MO', name: 'Moravskoslezsky kraj' },
    { code: 'CZ-OL', name: 'Olomoucky kraj' },
    { code: 'CZ-PA', name: 'Pardubicky kraj' },
    { code: 'CZ-PL', name: 'Plzensky kraj' },
    { code: 'CZ-ST', name: 'Stredocesky kraj' },
    { code: 'CZ-US', name: 'Ustecky kraj' },
    { code: 'CZ-VY', name: 'Vysocina kraj' },
    { code: 'CZ-ZL', name: 'Zlinsky kraj' },
  ],
  DK: [
    { code: 'DK-84', name: 'Hovedstaden' },
    { code: 'DK-82', name: 'Midtjylland' },
    { code: 'DK-81', name: 'Nordjylland' },
    { code: 'DK-85', name: 'Sjelland' },
    { code: 'DK-83', name: 'Syddanmark' },
  ],
  DJ: [
    { code: 'DJ-AS', name: 'Ali Sabieh' },
    { code: 'DJ-AR', name: 'Arta' },
    { code: 'DJ-DI', name: 'Dikhil' },
    { code: 'DJ-DJ', name: 'Djibouti' },
    { code: 'DJ-OB', name: 'Obock' },
    { code: 'DJ-TA', name: 'Tadjoura' },
  ],
  DM: [
    { code: 'DM-02', name: 'Saint Andrew' },
    { code: 'DM-03', name: 'Saint David' },
    { code: 'DM-04', name: 'Saint George' },
    { code: 'DM-05', name: 'Saint John' },
    { code: 'DM-06', name: 'Saint Joseph' },
    { code: 'DM-07', name: 'Saint Luke' },
    { code: 'DM-08', name: 'Saint Mark' },
    { code: 'DM-09', name: 'Saint Patrick' },
    { code: 'DM-10', name: 'Saint Paul' },
    { code: 'CU-16', name: 'Saint Peter' },
  ],
  DO: [
    { code: 'DO-02', name: 'Azua' },
    { code: 'DO-03', name: 'Baoruco' },
    { code: 'DO-04', name: 'Barahona' },
    { code: 'DO-32', name: 'Cibao Nordeste' },
    { code: 'DO-33', name: 'Cibao Noroeste' },
    { code: 'DO-34', name: 'Cibao Norte' },
    { code: 'DO-35', name: 'Cibao Sur' },
    { code: 'DO-05', name: 'Dajabon' },
    { code: 'DO-01', name: 'Distrito Nacional' },
    { code: 'DO-06', name: 'Duarte' },
    { code: 'DO-08', name: 'El Seibo' },
    { code: 'DO-36', name: 'El Valle' },
    { code: 'DO-07', name: 'Elias Pina' },
    { code: 'DO-37', name: 'Enriquillo' },
    { code: 'DO-09', name: 'Espaillat' },
    { code: 'DO-30', name: 'Hato Mayor' },
    { code: 'DO-38', name: 'Higuamo' },
    { code: 'DO-10', name: 'Independencia' },
    { code: 'DO-11', name: 'La Altagracia' },
    { code: 'DO-12', name: 'La Romana' },
    { code: 'DO-13', name: 'La Vega' },
    { code: 'DO-14', name: 'Maria Trinidad Sanchez' },
    { code: 'DO-28', name: 'Monsenor Nouel' },
    { code: 'DO-15', name: 'Monte Cristi' },
    { code: 'DO-29', name: 'Monte Plata' },
    { code: 'DO-39', name: 'Ozama' },
    { code: 'DO-16', name: 'Pedernales' },
    { code: 'DO-17', name: 'Peravia' },
    { code: 'DO-18', name: 'Puerto Plata' },
    { code: 'DO-19', name: 'Salcedo' },
    { code: 'DO-20', name: 'Samana' },
    { code: 'DO-21', name: 'San Cristobal' },
    { code: 'DM-11', name: 'San Jose de Ocoa' },
    { code: 'DO-22', name: 'San Juan' },
    { code: 'DO-23', name: 'San Pedro De Macoris' },
    { code: 'DO-24', name: 'Sanchez Ramirez' },
    { code: 'DO-25', name: 'Santiago' },
    { code: 'DO-26', name: 'Santiago Rodriguez' },
    { code: 'DO-31', name: 'Santo Domingo' },
    { code: 'DO-40', name: 'Valdesia' },
    { code: 'DO-27', name: 'Valverde' },
    { code: 'DO-41', name: 'Yuma' },
  ],
  TL: [
    { code: 'TL-AL', name: 'Aileu' },
    { code: 'TL-AN', name: 'Ainaru' },
    { code: 'TL-BA', name: 'Baukau' },
    { code: 'TL-BO', name: 'Bobonaru' },
    { code: 'TL-DI', name: 'Dili' },
    { code: 'TL-ER', name: 'Ermera' },
    { code: 'TL-CO', name: 'Kovalima' },
    { code: 'TL-LA', name: 'Lautem' },
    { code: 'TL-LI', name: 'Likisa' },
    { code: 'TL-MT', name: 'Manatutu' },
    { code: 'TL-MF', name: 'Manufahi' },
    { code: 'TL-OE', name: 'Oekusi-Ambenu' },
    { code: 'TL-VI', name: 'Vikeke' },
  ],
  EC: [
    { code: 'EC-A', name: 'Azuay' },
    { code: 'EC-B', name: 'Bolivar' },
    { code: 'EC-F', name: 'Canar' },
    { code: 'EC-C', name: 'Carchi' },
    { code: 'EC-H', name: 'Chimborazo' },
    { code: 'EC-X', name: 'Cotopaxi' },
    { code: 'EC-O', name: 'El Oro' },
    { code: 'EC-E', name: 'Esmeraldas' },
    { code: 'EC-W', name: 'Galapagos' },
    { code: 'EC-G', name: 'Guayas' },
    { code: 'EC-I', name: 'Imbabura' },
    { code: 'EC-L', name: 'Loja' },
    { code: 'EC-R', name: 'Los Rios' },
    { code: 'EC-M', name: 'Manabi' },
    { code: 'EC-S', name: 'Morona-Santiago' },
    { code: 'EC-N', name: 'Napo' },
    { code: 'EC-D', name: 'Orellana' },
    { code: 'EC-Y', name: 'Pastaza' },
    { code: 'EC-P', name: 'Pichincha' },
    { code: 'EC-SE', name: 'Santa Elena' },
    { code: 'DZ-18', name: 'Santo Domingo de los Tsechilas' },
    { code: 'EC-U', name: 'Sucumbios' },
    { code: 'EC-T', name: 'Tungurahua' },
    { code: 'EC-Z', name: 'Zamora-Chinchipe' },
  ],
  EG: [
    { code: 'EG-DK', name: 'Ad Daqahliyah' },
    { code: 'EG-BA', name: 'Al Bahr al Ahmar' },
    { code: 'EG-BH', name: 'Al Buhayrah' },
    { code: 'EG-FYM', name: 'Al Fayyum' },
    { code: 'EG-GH', name: 'Al Gharbiyah' },
    { code: 'EG-ALX', name: 'Al Iskandariyah' },
    { code: 'EG-IS', name: "Al Isma'iliyah" },
    { code: 'EG-GZ', name: 'Al Jizah' },
    { code: 'EG-MNF', name: 'Al Minufiyah' },
    { code: 'EG-MN', name: 'Al Minya' },
    { code: 'EG-C', name: 'Al Qahirah' },
    { code: 'EG-KB', name: 'Al Qalyubiyah' },
    { code: 'EG-WAD', name: 'Al Wadi al Jadid' },
    { code: 'EG-SUZ', name: 'As Suways' },
    { code: 'EG-SHR', name: 'Ash Sharqiyah' },
    { code: 'EG-ASN', name: 'Aswan' },
    { code: 'EG-AST', name: 'Asyut' },
    { code: 'EG-BNS', name: 'Bani Suwayf' },
    { code: 'EG-PTS', name: "Bur Sa'id" },
    { code: 'EG-DT', name: 'Dumyat' },
    { code: 'EG-JS', name: "Janub Sina'" },
    { code: 'EG-KFS', name: 'Kafr ash Shaykh' },
    { code: 'EG-MT', name: 'Matruh' },
    { code: 'EG-LX', name: 'Muhafazat al Uqsur' },
    { code: 'EG-KN', name: 'Qina' },
    { code: 'EG-SIN', name: "Shamal Sina'" },
    { code: 'EG-SHG', name: 'Suhaj' },
  ],
  SV: [
    { code: 'SV-AH', name: 'Ahuachapan' },
    { code: 'SV-CA', name: 'Cabanas' },
    { code: 'SV-CH', name: 'Chalatenango' },
    { code: 'SV-CU', name: 'Cuscatlan' },
    { code: 'SV-LI', name: 'La Libertad' },
    { code: 'SV-PA', name: 'La Paz' },
    { code: 'SV-UN', name: 'La Union' },
    { code: 'SV-MO', name: 'Morazan' },
    { code: 'SV-SM', name: 'San Miguel' },
    { code: 'SV-SS', name: 'San Salvador' },
    { code: 'SV-SV', name: 'San Vicente' },
    { code: 'SV-SA', name: 'Santa Ana' },
    { code: 'SV-SO', name: 'Sonsonate' },
    { code: 'SV-US', name: 'Usulutan' },
  ],
  GQ: [
    { code: 'GQ-AN', name: 'Annobon' },
    { code: 'GQ-BN', name: 'Bioko Norte' },
    { code: 'GQ-BS', name: 'Bioko Sur' },
    { code: 'GQ-CS', name: 'Centro Sur' },
    { code: 'GQ-KN', name: 'Kie-Ntem' },
    { code: 'GQ-LI', name: 'Litoral' },
    { code: 'GQ-C', name: 'Regiao Continental' },
    { code: 'GQ-I', name: 'Regiao Insular' },
    { code: 'GD-10', name: 'Region Continental' },
    { code: 'GQ-WN', name: 'Wele-Nzas' },
  ],
  ER: [
    { code: 'ER-AN', name: 'Anseba' },
    { code: 'ER-DU', name: 'Debub' },
    { code: 'ER-DK', name: "Debubawi K'eyih Bahri" },
    { code: 'ER-GB', name: 'Gash Barka' },
    { code: 'ER-MA', name: "Ma'akel" },
    { code: 'ER-SK', name: "Semenawi K'eyih Bahri" },
  ],
  EE: [
    { code: 'EE-37', name: 'Harjumaa' },
    { code: 'EE-39', name: 'Hiiumaa' },
    { code: 'EE-44', name: 'Ida-Virumaa' },
    { code: 'EE-51', name: 'Jarvamaa' },
    { code: 'EE-49', name: 'Jogevamaa' },
    { code: 'EE-59', name: 'Laane-Virumaa' },
    { code: 'EE-57', name: 'Laanemaa' },
    { code: 'EE-67', name: 'Parnumaa' },
    { code: 'EE-65', name: 'Polvamaa' },
    { code: 'EE-70', name: 'Raplamaa' },
    { code: 'EE-74', name: 'Saaremaa' },
    { code: 'EE-78', name: 'Tartumaa' },
    { code: 'EE-82', name: 'Valgamaa' },
    { code: 'EE-84', name: 'Viljandimaa' },
    { code: 'EE-86', name: 'Vorumaa' },
  ],
  ET: [
    { code: 'ET-AA', name: 'Adis Abeba' },
    { code: 'ET-AF', name: 'Afar' },
    { code: 'ET-AM', name: 'Amara' },
    { code: 'ET-BE', name: 'Binshangul Gumuz' },
    { code: 'ET-DD', name: 'Dire Dawa' },
    { code: 'ET-GA', name: 'Gambela Hizboch' },
    { code: 'ET-HA', name: 'Hareri Hizb' },
    { code: 'ET-OR', name: 'Oromiya' },
    { code: 'ET-SO', name: 'Sumale' },
    { code: 'ET-TI', name: 'Tigray' },
    { code: 'ET-SN', name: 'YeDebub Biheroch Bihereseboch na Hizboch' },
  ],
  FJ: [
    { code: 'EC-SD', name: 'Ba' },
    { code: 'FJ-01', name: 'Bua' },
    { code: 'FJ-02', name: 'Cakaudrove' },
    { code: 'FJ-C', name: 'Central' },
    { code: 'FJ-14', name: 'Eastern' },
    { code: 'FJ-03', name: 'Kadavu' },
    { code: 'FJ-04', name: 'Lau' },
    { code: 'FJ-05', name: 'Lomaiviti' },
    { code: 'FJ-06', name: 'Macuata' },
    { code: 'FJ-07', name: 'Nadroga and Navosa' },
    { code: 'FJ-08', name: 'Naitasiri' },
    { code: 'FJ-09', name: 'Namosi' },
    { code: 'FJ-N', name: 'Northern' },
    { code: 'FJ-10', name: 'Ra' },
    { code: 'FJ-11', name: 'Rewa' },
    { code: 'FJ-E', name: 'Rotuma' },
    { code: 'FJ-12', name: 'Serua' },
    { code: 'FJ-13', name: 'Tailevu' },
    { code: 'FJ-W', name: 'Western' },
  ],
  FI: [
    { code: 'FI-01', name: 'Ahvenanmaan maakunta' },
    { code: 'FI-02', name: 'Etela-Karjala' },
    { code: 'FI-03', name: 'Etela-Pohjanmaa' },
    { code: 'FI-04', name: 'Etela-Savo' },
    { code: 'FI-05', name: 'Kainuu' },
    { code: 'FI-06', name: 'Kanta-Hame' },
    { code: 'FI-07', name: 'Keski-Pohjanmaa' },
    { code: 'FI-08', name: 'Keski-Suomi' },
    { code: 'FI-09', name: 'Kymenlaakso' },
    { code: 'FI-10', name: 'Lappi' },
    { code: 'FI-16', name: 'Paijat-Hame' },
    { code: 'FI-11', name: 'Pirkanmaa' },
    { code: 'FI-12', name: 'Pohjanmaa' },
    { code: 'FI-13', name: 'Pohjois-Karjala' },
    { code: 'FI-14', name: 'Pohjois-Pohjanmaa' },
    { code: 'FI-15', name: 'Pohjois-Savo' },
    { code: 'FI-17', name: 'Satakunta' },
    { code: 'FI-18', name: 'Uusimaa' },
    { code: 'FI-19', name: 'Varsinais-Suomi' },
  ],
  FR: [
    { code: 'FR-01', name: 'Ain' },
    { code: 'FR-02', name: 'Aisne' },
    { code: 'FR-03', name: 'Allier' },
    { code: 'FR-04', name: 'Alpes-de-Haute-Provence' },
    { code: 'FR-06', name: 'Alpes-Maritimes' },
    { code: 'FR-A', name: 'Alsace' },
    { code: 'FR-B', name: 'Aquitaine' },
    { code: 'FR-07', name: 'Ardeche' },
    { code: 'FR-08', name: 'Ardennes' },
    { code: 'FR-09', name: 'Ariege' },
    { code: 'FR-10', name: 'Aube' },
    { code: 'FR-11', name: 'Aude' },
    { code: 'FR-C', name: 'Auvergne' },
    { code: 'FR-12', name: 'Aveyron' },
    { code: 'FR-67', name: 'Bas-Rhin' },
    { code: 'FR-P', name: 'Basse-Normandie' },
    { code: 'FR-13', name: 'Bouches-du-Rhone' },
    { code: 'FR-D', name: 'Bourgogne' },
    { code: 'FR-E', name: 'Bretagne' },
    { code: 'FR-14', name: 'Calvados' },
    { code: 'FR-15', name: 'Cantal' },
    { code: 'FR-F', name: 'Centre' },
    { code: 'FR-G', name: 'Champagne-Ardenne' },
    { code: 'FR-16', name: 'Charente' },
    { code: 'FR-17', name: 'Charente-Maritime' },
    { code: 'FR-18', name: 'Cher' },
    { code: 'FR-19', name: 'Correze' },
    { code: 'FR-H', name: 'Corse' },
    { code: 'FR-2A', name: 'Corse-du-Sud' },
    { code: 'FR-21', name: "Cote-d'Or" },
    { code: 'FR-22', name: "Cotes-d'Armor" },
    { code: 'FR-23', name: 'Creuse' },
    { code: 'FR-79', name: 'Deux-Sevres' },
    { code: 'FR-24', name: 'Dordogne' },
    { code: 'FR-25', name: 'Doubs' },
    { code: 'FR-26', name: 'Drome' },
    { code: 'FR-91', name: 'Essonne' },
    { code: 'FR-27', name: 'Eure' },
    { code: 'FR-28', name: 'Eure-et-Loir' },
    { code: 'FR-29', name: 'Finistere' },
    { code: 'FR-I', name: 'Franche-Comte' },
    { code: 'FR-30', name: 'Gard' },
    { code: 'FR-32', name: 'Gers' },
    { code: 'FR-33', name: 'Gironde' },
    { code: 'FR-68', name: 'Haut-Rhin' },
    { code: 'FR-2B', name: 'Haute-Corse' },
    { code: 'FR-31', name: 'Haute-Garonne' },
    { code: 'FR-43', name: 'Haute-Loire' },
    { code: 'FR-52', name: 'Haute-Marne' },
    { code: 'FR-Q', name: 'Haute-Normandie' },
    { code: 'FR-70', name: 'Haute-Saone' },
    { code: 'FR-74', name: 'Haute-Savoie' },
    { code: 'FR-87', name: 'Haute-Vienne' },
    { code: 'FR-05', name: 'Hautes-Alpes' },
    { code: 'FR-65', name: 'Hautes-Pyrenees' },
    { code: 'FR-92', name: 'Hauts-de-Seine' },
    { code: 'FR-34', name: 'Herault' },
    { code: 'FR-J', name: 'Ile-de-France' },
    { code: 'FR-35', name: 'Ille-et-Vilaine' },
    { code: 'FR-36', name: 'Indre' },
    { code: 'FR-37', name: 'Indre-et-Loire' },
    { code: 'FR-38', name: 'Isere' },
    { code: 'FR-39', name: 'Jura' },
    { code: 'FR-40', name: 'Landes' },
    { code: 'FR-K', name: 'Languedoc-Roussillon' },
    { code: 'FR-L', name: 'Limousin' },
    { code: 'FR-41', name: 'Loir-et-Cher' },
    { code: 'FR-42', name: 'Loire' },
    { code: 'FR-44', name: 'Loire-Atlantique' },
    { code: 'FR-45', name: 'Loiret' },
    { code: 'FR-M', name: 'Lorraine' },
    { code: 'FR-46', name: 'Lot' },
    { code: 'FR-47', name: 'Lot-et-Garonne' },
    { code: 'FR-48', name: 'Lozere' },
    { code: 'FR-49', name: 'Maine-et-Loire' },
    { code: 'FR-50', name: 'Manche' },
    { code: 'FR-51', name: 'Marne' },
    { code: 'FR-53', name: 'Mayenne' },
    { code: 'FR-54', name: 'Meurthe-et-Moselle' },
    { code: 'FR-55', name: 'Meuse' },
    { code: 'FR-N', name: 'Midi-Pyrenees' },
    { code: 'FR-56', name: 'Morbihan' },
    { code: 'FR-57', name: 'Moselle' },
    { code: 'FR-58', name: 'Nievre' },
    { code: 'FR-59', name: 'Nord' },
    { code: 'FR-O', name: 'Nord-Pas-de-Calais' },
    { code: 'FR-60', name: 'Oise' },
    { code: 'FR-61', name: 'Orne' },
    { code: 'FR-75', name: 'Paris' },
    { code: 'FR-62', name: 'Pas-de-Calais' },
    { code: 'FR-R', name: 'Pays de la Loire' },
    { code: 'FR-S', name: 'Picardie' },
    { code: 'FR-T', name: 'Poitou-Charentes' },
    { code: 'FR-U', name: "Provence-Alpes-Cote d'Azur" },
    { code: 'FR-63', name: 'Puy-de-Dome' },
    { code: 'FR-64', name: 'Pyrenees-Atlantiques' },
    { code: 'FR-66', name: 'Pyrenees-Orientales' },
    { code: 'FR-69', name: 'Rhone' },
    { code: 'FR-V', name: 'Rhone-Alpes' },
    { code: 'FR-71', name: 'Saone-et-Loire' },
    { code: 'FR-72', name: 'Sarthe' },
    { code: 'FR-73', name: 'Savoie' },
    { code: 'FR-77', name: 'Seine-et-Marne' },
    { code: 'FR-76', name: 'Seine-Maritime' },
    { code: 'FR-93', name: 'Seine-Saint-Denis' },
    { code: 'FR-80', name: 'Somme' },
    { code: 'FR-81', name: 'Tarn' },
    { code: 'FR-82', name: 'Tarn-et-Garonne' },
    { code: 'FR-90', name: 'Territoire de Belfort' },
    { code: 'FR-95', name: "Val-d'Oise" },
    { code: 'FR-94', name: 'Val-de-Marne' },
    { code: 'FR-83', name: 'Var' },
    { code: 'FR-84', name: 'Vaucluse' },
    { code: 'FR-85', name: 'Vendee' },
    { code: 'FR-86', name: 'Vienne' },
    { code: 'FR-88', name: 'Vosges' },
    { code: 'FR-89', name: 'Yonne' },
    { code: 'FR-78', name: 'Yvelines' },
  ],
  GA: [
    { code: 'GA-1', name: 'Estuaire' },
    { code: 'GA-2', name: 'Haut-Ogooue' },
    { code: 'GA-3', name: 'Moyen-Ogooue' },
    { code: 'GA-4', name: 'Ngounie' },
    { code: 'GA-5', name: 'Nyanga' },
    { code: 'GA-6', name: 'Ogooue-Ivindo' },
    { code: 'GA-7', name: 'Ogooue-Lolo' },
    { code: 'GA-8', name: 'Ogooue-Maritime' },
    { code: 'GA-9', name: 'Woleu-Ntem' },
  ],
  GM: [
    { code: 'GM-B', name: 'Banjul' },
    { code: 'GM-M', name: 'Central River' },
    { code: 'GM-L', name: 'Lower River' },
    { code: 'GM-N', name: 'North Bank' },
    { code: 'GM-U', name: 'Upper River' },
    { code: 'GM-W', name: 'Western' },
  ],
  GE: [
    { code: 'GE-AB', name: 'Abkhazia' },
    { code: 'GE-AJ', name: 'Ajaria' },
    { code: 'GE-GU', name: 'Guria' },
    { code: 'GE-IM', name: 'Imereti' },
    { code: 'GE-KK', name: 'Kvemo Kartli' },
    { code: 'GE-MM', name: 'Mtskheta-Mtianeti' },
    { code: 'GE-SZ', name: 'Samegrelo and Zemo Svaneti' },
    { code: 'GE-SJ', name: 'Samtskhe-Javakheti' },
    { code: 'GE-SK', name: 'Shida Kartli' },
    { code: 'GE-TB', name: "T'bilisi" },
  ],
  DE: [
    { code: 'DE-BW', name: 'Baden-Wurttemberg' },
    { code: 'DE-BY', name: 'Bayern' },
    { code: 'DE-BE', name: 'Berlin' },
    { code: 'DE-BB', name: 'Brandenburg' },
    { code: 'DE-HB', name: 'Bremen' },
    { code: 'DE-HH', name: 'Hamburg' },
    { code: 'DE-HE', name: 'Hessen' },
    { code: 'DE-MV', name: 'Mecklenburg-Vorpommern' },
    { code: 'DE-NI', name: 'Niedersachsen' },
    { code: 'DE-NW', name: 'Nordrhein-Westfalen' },
    { code: 'DE-RP', name: 'Rheinland-Pfalz' },
    { code: 'DE-SL', name: 'Saarland' },
    { code: 'DE-SN', name: 'Sachsen' },
    { code: 'DE-ST', name: 'Sachsen-Anhalt' },
    { code: 'DE-SH', name: 'Schleswig-Holstein' },
    { code: 'DE-TH', name: 'Thuringen' },
  ],
  GH: [
    { code: 'GH-AH', name: 'Ashanti' },
    { code: 'GH-BA', name: 'Brong-Ahafo' },
    { code: 'GH-CP', name: 'Central' },
    { code: 'GH-EP', name: 'Eastern' },
    { code: 'GH-AA', name: 'Greater Accra' },
    { code: 'GH-NP', name: 'Northern' },
    { code: 'GH-UE', name: 'Upper East' },
    { code: 'GH-UW', name: 'Upper West' },
    { code: 'GH-TV', name: 'Volta' },
    { code: 'GH-WP', name: 'Western' },
  ],
  GR: [
    { code: 'GR-69', name: 'Agion Oros' },
    { code: 'GR-01', name: 'Aitolia kai Akarnania' },
    { code: 'GR-13', name: 'Akhaia' },
    { code: 'GR-A', name: 'Anatoliki Makedonia kai Thraki' },
    { code: 'GR-11', name: 'Argolis' },
    { code: 'GR-12', name: 'Arkadhia' },
    { code: 'GR-31', name: 'Arta' },
    { code: 'GR-I', name: 'Attiki' },
    { code: 'GR-A1', name: 'Attiki' },
    { code: 'GR-81', name: 'Dhodhekanisos' },
    { code: 'GR-52', name: 'Drama' },
    { code: 'GR-G', name: 'Dytiki Ellida' },
    { code: 'GR-C', name: 'Dytiki Makedonia' },
    { code: 'GR-05', name: 'Evritania' },
    { code: 'GR-71', name: 'Evros' },
    { code: 'GR-04', name: 'Evvoia' },
    { code: 'GR-63', name: 'Florina' },
    { code: 'GR-07', name: 'Fokis' },
    { code: 'GR-06', name: 'Fthiotis' },
    { code: 'GR-51', name: 'Grevena' },
    { code: 'GR-14', name: 'Ilia' },
    { code: 'GR-53', name: 'Imathia' },
    { code: 'GR-33', name: 'Ioannina' },
    { code: 'GR-F', name: 'Ionia Nisia' },
    { code: 'GR-D', name: 'Ipeiros' },
    { code: 'GR-91', name: 'Iraklion' },
    { code: 'GR-41', name: 'Kardhitsa' },
    { code: 'GR-56', name: 'Kastoria' },
    { code: 'GR-55', name: 'Kavala' },
    { code: 'GR-23', name: 'Kefallinia' },
    { code: 'GR-B', name: 'Kentriki Makedonia' },
    { code: 'GR-22', name: 'Kerkira' },
    { code: 'GR-64', name: 'Khalkidhiki' },
    { code: 'GR-94', name: 'Khania' },
    { code: 'GR-85', name: 'Khios' },
    { code: 'GR-82', name: 'Kikladhes' },
    { code: 'GR-57', name: 'Kilkis' },
    { code: 'GR-15', name: 'Korinthia' },
    { code: 'GR-58', name: 'Kozani' },
    { code: 'GR-M', name: 'Kriti' },
    { code: 'GR-16', name: 'Lakonia' },
    { code: 'GR-42', name: 'Larisa' },
    { code: 'GR-92', name: 'Lasithi' },
    { code: 'GR-83', name: 'Lesvos' },
    { code: 'GR-24', name: 'Levkas' },
    { code: 'GR-43', name: 'Magnisia' },
    { code: 'GR-17', name: 'Messinia' },
    { code: 'GR-L', name: 'Notio Aigaio' },
    { code: 'GR-59', name: 'Pella' },
    { code: 'GR-J', name: 'Peloponnisos' },
    { code: 'GR-61', name: 'Pieria' },
    { code: 'GR-34', name: 'Preveza' },
    { code: 'GR-93', name: 'Rethimni' },
    { code: 'GR-73', name: 'Rodhopi' },
    { code: 'GR-84', name: 'Samos' },
    { code: 'GR-62', name: 'Serrai' },
    { code: 'GR-H', name: 'Sterei Ellida' },
    { code: 'GR-32', name: 'Thesprotia' },
    { code: 'GR-E', name: 'Thessalia' },
    { code: 'GR-54', name: 'Thessaloniki' },
    { code: 'GR-44', name: 'Trikala' },
    { code: 'GR-03', name: 'Voiotia' },
    { code: 'GR-K', name: 'Voreio Aigaio' },
    { code: 'GR-72', name: 'Xanthi' },
    { code: 'GR-21', name: 'Zakinthos' },
  ],
  GL: [
    { code: 'GL-KU', name: 'Kujalleq' },
    { code: 'GL-QA', name: 'Qaasuitsup' },
    { code: 'GL-QE', name: 'Qeqqata' },
    { code: 'GL-SM', name: 'Sermersooq' },
  ],
  GD: [
    { code: 'GD-01', name: 'Saint Andrew' },
    { code: 'GD-02', name: 'Saint David' },
    { code: 'GD-03', name: 'Saint George' },
    { code: 'GD-04', name: 'Saint John' },
    { code: 'GD-05', name: 'Saint Mark' },
    { code: 'GD-06', name: 'Saint Patrick' },
    { code: 'FJ-R', name: 'Southern Grenadine Islands' },
  ],
  GT: [
    { code: 'GT-AV', name: 'Alta Verapaz' },
    { code: 'GT-BV', name: 'Baja Verapaz' },
    { code: 'GT-CM', name: 'Chimaltenango' },
    { code: 'GT-CQ', name: 'Chiquimula' },
    { code: 'GT-PR', name: 'El Progreso' },
    { code: 'GT-ES', name: 'Escuintla' },
    { code: 'GT-GU', name: 'Guatemala' },
    { code: 'GT-HU', name: 'Huehuetenango' },
    { code: 'GT-IZ', name: 'Izabal' },
    { code: 'GT-JA', name: 'Jalapa' },
    { code: 'GT-JU', name: 'Jutiapa' },
    { code: 'GT-PE', name: 'Peten' },
    { code: 'GT-QZ', name: 'Quetzaltenango' },
    { code: 'GT-QC', name: 'Quiche' },
    { code: 'GT-RE', name: 'Retalhuleu' },
    { code: 'GT-SA', name: 'Sacatepequez' },
    { code: 'GT-SM', name: 'San Marcos' },
    { code: 'GT-SR', name: 'Santa Rosa' },
    { code: 'GT-SO', name: 'Solola' },
    { code: 'GT-SU', name: 'Suchitepequez' },
    { code: 'GT-TO', name: 'Totonicapan' },
    { code: 'GT-ZA', name: 'Zacapa' },
  ],
  GN: [
    { code: 'GN-BE', name: 'Beyla' },
    { code: 'GN-BF', name: 'Boffa' },
    { code: 'GN-BK', name: 'Boke' },
    { code: 'GN-C', name: 'Conakry' },
    { code: 'GN-CO', name: 'Coyah' },
    { code: 'GN-DB', name: 'Dabola' },
    { code: 'GN-DL', name: 'Dalaba' },
    { code: 'GN-DI', name: 'Dinguiraye' },
    { code: 'GN-DU', name: 'Dubreka' },
    { code: 'GN-FA', name: 'Faranah' },
    { code: 'GN-FO', name: 'Forecariah' },
    { code: 'GN-FR', name: 'Fria' },
    { code: 'GN-GA', name: 'Gaoual' },
    { code: 'GN-GU', name: 'Gueckedou' },
    { code: 'GN-KA', name: 'Kankan' },
    { code: 'GN-KE', name: 'Kerouane' },
    { code: 'GN-KD', name: 'Kindia' },
    { code: 'GN-KS', name: 'Kissidougou' },
    { code: 'GN-KB', name: 'Koubia' },
    { code: 'GN-KN', name: 'Koundara' },
    { code: 'GN-KO', name: 'Kouroussa' },
    { code: 'GN-LA', name: 'Labe' },
    { code: 'GN-LE', name: 'Lelouma' },
    { code: 'GN-LO', name: 'Lola' },
    { code: 'GN-MC', name: 'Macenta' },
    { code: 'GN-ML', name: 'Mali' },
    { code: 'GN-MM', name: 'Mamou' },
    { code: 'GN-MD', name: 'Mandiana' },
    { code: 'GN-NZ', name: 'Nzerekore' },
    { code: 'GN-PI', name: 'Pita' },
    { code: 'GN-SI', name: 'Siguiri' },
    { code: 'GN-TE', name: 'Telimele' },
    { code: 'GN-TO', name: 'Tougue' },
    { code: 'GN-YO', name: 'Yomou' },
  ],
  GW: [
    { code: 'GW-BA', name: 'Bafata' },
    { code: 'GW-BM', name: 'Biombo' },
    { code: 'GW-BS', name: 'Bissau' },
    { code: 'GW-BL', name: 'Bolama' },
    { code: 'GW-CA', name: 'Cacheu' },
    { code: 'GW-GA', name: 'Gabu' },
    { code: 'GW-OI', name: 'Oio' },
    { code: 'GW-QU', name: 'Quinara' },
    { code: 'GW-TO', name: 'Tombali' },
  ],
  GY: [
    { code: 'GY-BA', name: 'Barima-Waini' },
    { code: 'GY-CU', name: 'Cuyuni-Mazaruni' },
    { code: 'GY-DE', name: 'Demerara-Mahaica' },
    { code: 'GY-EB', name: 'East Berbice-Corentyne' },
    { code: 'GY-ES', name: 'Essequibo Islands-West Demerara' },
    { code: 'GY-MA', name: 'Mahaica-Berbice' },
    { code: 'GY-PM', name: 'Pomeroon-Supenaam' },
    { code: 'GY-PT', name: 'Potaro-Siparuni' },
    { code: 'GY-UD', name: 'Upper Demerara-Berbice' },
    { code: 'GY-UT', name: 'Upper Takutu-Upper Essequibo' },
  ],
  HT: [
    { code: 'HT-AR', name: 'Artibonite' },
    { code: 'HT-CE', name: 'Centre' },
    { code: 'HT-GA', name: "Grand' Anse" },
    { code: 'HT-NI', name: 'Nippes' },
    { code: 'HT-ND', name: 'Nord' },
    { code: 'HT-NE', name: 'Nord-Est' },
    { code: 'HT-NO', name: 'Nord-Ouest' },
    { code: 'HT-OU', name: 'Ouest' },
    { code: 'HT-SD', name: 'Sud' },
    { code: 'HT-SE', name: 'Sud-Est' },
  ],
  HN: [
    { code: 'HN-AT', name: 'Atlantida' },
    { code: 'HN-CH', name: 'Choluteca' },
    { code: 'HN-CL', name: 'Colon' },
    { code: 'HN-CM', name: 'Comayagua' },
    { code: 'HN-CP', name: 'Copan' },
    { code: 'HN-CR', name: 'Cortes' },
    { code: 'HN-EP', name: 'El Paraiso' },
    { code: 'HN-FM', name: 'Francisco Morazan' },
    { code: 'HN-GD', name: 'Gracias a Dios' },
    { code: 'HN-IN', name: 'Intibuca' },
    { code: 'HN-IB', name: 'Islas de la Bahia' },
    { code: 'HN-LP', name: 'La Paz' },
    { code: 'HN-LE', name: 'Lempira' },
    { code: 'HN-OC', name: 'Ocotepeque' },
    { code: 'HN-OL', name: 'Olancho' },
    { code: 'HN-SB', name: 'Santa Barbara' },
    { code: 'HN-VA', name: 'Valle' },
    { code: 'HN-YO', name: 'Yoro' },
  ],
  HU: [
    { code: 'HU-BK', name: 'Bacs-Kiskun' },
    { code: 'HU-BA', name: 'Baranya' },
    { code: 'HU-BE', name: 'Bekes' },
    { code: 'HU-BZ', name: 'Borsod-Abauj-Zemplen' },
    { code: 'HU-BU', name: 'Budapest' },
    { code: 'HU-CS', name: 'Csongrad' },
    { code: 'HU-FE', name: 'Fejer' },
    { code: 'HU-GS', name: 'Gyor-Moson-Sopron' },
    { code: 'HU-HB', name: 'Hajdu-Bihar' },
    { code: 'HU-HE', name: 'Heves' },
    { code: 'HU-JN', name: 'Jasz-Nagykun-Szolnok' },
    { code: 'HU-KE', name: 'Komarom-Esztergom' },
    { code: 'HU-NO', name: 'Nograd' },
    { code: 'HU-PE', name: 'Pest' },
    { code: 'HU-SO', name: 'Somogy' },
    { code: 'HU-SZ', name: 'Szabolcs-Szatmar-Bereg' },
    { code: 'HU-TO', name: 'Tolna' },
    { code: 'HU-VA', name: 'Vas' },
    { code: 'HU-VE', name: 'Veszprem' },
    { code: 'HU-ZA', name: 'Zala' },
  ],
  IS: [
    { code: 'IS-7', name: 'Austurland' },
    { code: 'IS-1', name: 'Hofuoborgarsvaoio' },
    { code: 'IS-6', name: 'Norourland Eystra' },
    { code: 'IS-5', name: 'Norourland Vestra' },
    { code: 'IS-0', name: 'Reykjavik' },
    { code: 'IS-8', name: 'Suourland' },
    { code: 'IS-2', name: 'Suournes' },
    { code: 'IS-4', name: 'Vestfiroir' },
    { code: 'IS-3', name: 'Vesturland' },
  ],
  IN: [
    { code: 'IN-AN', name: 'Andaman and Nicobar Islands' },
    { code: 'IN-AP', name: 'Andhra Pradesh' },
    { code: 'IN-AR', name: 'Arunachal Pradesh' },
    { code: 'IN-AS', name: 'Assam' },
    { code: 'IN-BR', name: 'Bihar' },
    { code: 'IN-CH', name: 'Chandigarh' },
    { code: 'IN-CT', name: 'Chhattisgarh' },
    { code: 'IN-DN', name: 'Dadra and Nagar Haveli' },
    { code: 'IN-DD', name: 'Daman and Diu' },
    { code: 'IN-DL', name: 'Delhi' },
    { code: 'IN-GA', name: 'Goa' },
    { code: 'IN-GJ', name: 'Gujarat' },
    { code: 'IN-HR', name: 'Haryana' },
    { code: 'IN-HP', name: 'Himachal Pradesh' },
    { code: 'IN-JK', name: 'Jammu and Kashmir' },
    { code: 'IN-JH', name: 'Jharkhand' },
    { code: 'IN-KA', name: 'Karnataka' },
    { code: 'IN-KL', name: 'Kerala' },
    { code: 'IN-LD', name: 'Lakshadweep' },
    { code: 'IN-MP', name: 'Madhya Pradesh' },
    { code: 'IN-MH', name: 'Maharashtra' },
    { code: 'IN-MN', name: 'Manipur' },
    { code: 'IN-ML', name: 'Meghalaya' },
    { code: 'IN-MZ', name: 'Mizoram' },
    { code: 'IN-NL', name: 'Nagaland' },
    { code: 'IN-OR', name: 'Odisha' },
    { code: 'IN-PY', name: 'Puducherry' },
    { code: 'IN-PB', name: 'Punjab' },
    { code: 'IN-RJ', name: 'Rajasthan' },
    { code: 'IN-SK', name: 'Sikkim' },
    { code: 'IN-TN', name: 'Tamil Nadu' },
    { code: 'IN-TG', name: 'Telangana' },
    { code: 'IN-TR', name: 'Tripura' },
    { code: 'IN-UP', name: 'Uttar Pradesh' },
    { code: 'IN-UT', name: 'Uttarakhand' },
    { code: 'IN-WB', name: 'West Bengal' },
  ],
  ID: [
    { code: 'ID-AC', name: 'Aceh' },
    { code: 'ID-BA', name: 'Bali' },
    { code: 'ID-BT', name: 'Banten' },
    { code: 'ID-BE', name: 'Bengkulu' },
    { code: 'ID-GO', name: 'Gorontalo' },
    { code: 'ID-JK', name: 'Jakarta Raya' },
    { code: 'ID-JA', name: 'Jambi' },
    { code: 'ID-JW', name: 'Jawa' },
    { code: 'ID-JB', name: 'Jawa Barat' },
    { code: 'ID-JT', name: 'Jawa Tengah' },
    { code: 'ID-JI', name: 'Jawa Timur' },
    { code: 'ID-KA', name: 'Kalimantan' },
    { code: 'ID-KB', name: 'Kalimantan Barat' },
    { code: 'ID-KS', name: 'Kalimantan Selatan' },
    { code: 'ID-KT', name: 'Kalimantan Tengah' },
    { code: 'ID-KI', name: 'Kalimantan Timur' },
    { code: 'ID-KU', name: 'Kalimantan Utara' },
    { code: 'ID-BB', name: 'Kepulauan Bangka Belitung' },
    { code: 'ID-KR', name: 'Kepulauan Riau' },
    { code: 'ID-LA', name: 'Lampung' },
    { code: 'ID-ML', name: 'Maluku' },
    { code: 'ID-MA', name: 'Maluku' },
    { code: 'ID-MU', name: 'Maluku Utara' },
    { code: 'ID-NU', name: 'Nusa Tenggara' },
    { code: 'ID-NB', name: 'Nusa Tenggara Barat' },
    { code: 'ID-NT', name: 'Nusa Tenggara Timur' },
    { code: 'ID-PP', name: 'Papua' },
    { code: 'ID-PA', name: 'Papua' },
    { code: 'ID-PB', name: 'Papua Barat' },
    { code: 'ID-RI', name: 'Riau' },
    { code: 'ID-SL', name: 'Sulawesi' },
    { code: 'ID-SR', name: 'Sulawesi Barat' },
    { code: 'ID-SN', name: 'Sulawesi Selatan' },
    { code: 'ID-ST', name: 'Sulawesi Tengah' },
    { code: 'ID-SG', name: 'Sulawesi Tenggara' },
    { code: 'ID-SA', name: 'Sulawesi Utara' },
    { code: 'ID-SM', name: 'Sumatera' },
    { code: 'ID-SB', name: 'Sumatera Barat' },
    { code: 'ID-SS', name: 'Sumatera Selatan' },
    { code: 'ID-SU', name: 'Sumatera Utara' },
    { code: 'ID-YO', name: 'Yogyakarta' },
  ],
  IE: [
    { code: 'IE-CW', name: 'Carlow' },
    { code: 'IE-CN', name: 'Cavan' },
    { code: 'IE-CE', name: 'Clare' },
    { code: 'IE-C', name: 'Connaught' },
    { code: 'IE-CO', name: 'Cork' },
    { code: 'IE-DL', name: 'Donegal' },
    { code: 'IE-D', name: 'Dublin' },
    { code: 'IE-G', name: 'Galway' },
    { code: 'IE-KY', name: 'Kerry' },
    { code: 'IE-KE', name: 'Kildare' },
    { code: 'IE-KK', name: 'Kilkenny' },
    { code: 'IE-LS', name: 'Laois' },
    { code: 'IE-L', name: 'Leinster' },
    { code: 'IE-LM', name: 'Leitrim' },
    { code: 'IE-LK', name: 'Limerick' },
    { code: 'IE-LD', name: 'Longford' },
    { code: 'IE-LH', name: 'Louth' },
    { code: 'IE-MO', name: 'Mayo' },
    { code: 'IE-MH', name: 'Meath' },
    { code: 'IE-MN', name: 'Monaghan' },
    { code: 'IE-M', name: 'Munster' },
    { code: 'IE-OY', name: 'Offaly' },
    { code: 'IE-RN', name: 'Roscommon' },
    { code: 'IE-SO', name: 'Sligo' },
    { code: 'IE-TA', name: 'Tipperary' },
    { code: 'IE-U', name: 'Ulster' },
    { code: 'IE-WD', name: 'Waterford' },
    { code: 'IE-WH', name: 'Westmeath' },
    { code: 'IE-WX', name: 'Wexford' },
    { code: 'IE-WW', name: 'Wicklow' },
  ],
  IL: [
    { code: 'IL-D', name: 'HaDarom' },
    { code: 'IL-M', name: 'HaMerkaz' },
    { code: 'IL-Z', name: 'HaZafon' },
    { code: 'IL-HA', name: 'Hefa' },
    { code: 'IL-TA', name: 'Tel Aviv' },
    { code: 'IL-JM', name: 'Yerushalayim' },
  ],
  IT: [
    { code: 'IT-65', name: 'Abruzzi' },
    { code: 'IT-AG', name: 'Agrigento' },
    { code: 'IT-AL', name: 'Alessandria' },
    { code: 'IT-AN', name: 'Ancona' },
    { code: 'IT-AO', name: 'Aosta' },
    { code: 'IT-AR', name: 'Arezzo' },
    { code: 'IT-AP', name: 'Ascoli Piceno' },
    { code: 'IT-AT', name: 'Asti' },
    { code: 'IT-AV', name: 'Avellino' },
    { code: 'IT-BA', name: 'Bari' },
    { code: 'IT-BT', name: 'Barletta-Andria-Trani' },
    { code: 'IT-77', name: 'Basilicata' },
    { code: 'IT-BL', name: 'Belluno' },
    { code: 'IT-BN', name: 'Benevento' },
    { code: 'IT-BG', name: 'Bergamo' },
    { code: 'IT-BI', name: 'Biella' },
    { code: 'IT-BO', name: 'Bologna' },
    { code: 'IT-BZ', name: 'Bolzano' },
    { code: 'IT-BS', name: 'Brescia' },
    { code: 'IT-BR', name: 'Brindisi' },
    { code: 'IT-CA', name: 'Cagliari' },
    { code: 'IT-78', name: 'Calabria' },
    { code: 'IT-CL', name: 'Caltanissetta' },
    { code: 'IT-72', name: 'Campania' },
    { code: 'IT-CB', name: 'Campobasso' },
    { code: 'IT-CI', name: 'Carbonia-Iglesias' },
    { code: 'IT-CE', name: 'Caserta' },
    { code: 'IT-CT', name: 'Catania' },
    { code: 'IT-CZ', name: 'Catanzaro' },
    { code: 'IT-CH', name: 'Chieti' },
    { code: 'IT-CO', name: 'Como' },
    { code: 'IT-CS', name: 'Cosenza' },
    { code: 'IT-CR', name: 'Cremona' },
    { code: 'IT-KR', name: 'Crotone' },
    { code: 'IT-CN', name: 'Cuneo' },
    { code: 'IT-45', name: 'Emilia-Romagna' },
    { code: 'IT-EN', name: 'Enna' },
    { code: 'IT-FM', name: 'Fermo' },
    { code: 'IT-FE', name: 'Ferrara' },
    { code: 'IT-FI', name: 'Firenze' },
    { code: 'IT-FG', name: 'Foggia' },
    { code: 'IT-FC', name: 'Forli-Cesena' },
    { code: 'IT-36', name: 'Friuli-Venezia Giulia' },
    { code: 'IT-FR', name: 'Frosinone' },
    { code: 'IT-GE', name: 'Genova' },
    { code: 'IT-GO', name: 'Gorizia' },
    { code: 'IT-GR', name: 'Grosseto' },
    { code: 'IT-IM', name: 'Imperia' },
    { code: 'IT-IS', name: 'Isernia' },
    { code: 'IT-AQ', name: "L'Aquila" },
    { code: 'IT-SP', name: 'La Spezia' },
    { code: 'IT-LT', name: 'Latina' },
    { code: 'IT-62', name: 'Lazio' },
    { code: 'IT-LE', name: 'Lecce' },
    { code: 'IT-LC', name: 'Lecco' },
    { code: 'IT-42', name: 'Liguria' },
    { code: 'IT-LI', name: 'Livorno' },
    { code: 'IT-LO', name: 'Lodi' },
    { code: 'IT-25', name: 'Lombardia' },
    { code: 'IT-LU', name: 'Lucca' },
    { code: 'IT-MC', name: 'Macerata' },
    { code: 'IT-MN', name: 'Mantova' },
    { code: 'IT-57', name: 'Marche' },
    { code: 'IT-MS', name: 'Massa-Carrara' },
    { code: 'IT-MT', name: 'Matera' },
    { code: 'IT-VS', name: 'Medio Campidano' },
    { code: 'IT-ME', name: 'Messina' },
    { code: 'IT-MI', name: 'Milano' },
    { code: 'IT-MO', name: 'Modena' },
    { code: 'IT-67', name: 'Molise' },
    { code: 'IT-MB', name: 'Monza e Brianza' },
    { code: 'IT-NA', name: 'Napoli' },
    { code: 'IT-NO', name: 'Novara' },
    { code: 'IT-NU', name: 'Nuoro' },
    { code: 'IT-OG', name: 'Ogliastra' },
    { code: 'IT-OT', name: 'Olbia-Tempio' },
    { code: 'IT-OR', name: 'Oristano' },
    { code: 'IT-PD', name: 'Padova' },
    { code: 'IT-PA', name: 'Palermo' },
    { code: 'IT-PR', name: 'Parma' },
    { code: 'IT-PV', name: 'Pavia' },
    { code: 'IT-PG', name: 'Perugia' },
    { code: 'IT-PU', name: 'Pesaro e Urbino' },
    { code: 'IT-PE', name: 'Pescara' },
    { code: 'IT-PC', name: 'Piacenza' },
    { code: 'IT-21', name: 'Piemonte' },
    { code: 'IT-PI', name: 'Pisa' },
    { code: 'IT-PT', name: 'Pistoia' },
    { code: 'IT-PN', name: 'Pordenone' },
    { code: 'IT-PZ', name: 'Potenza' },
    { code: 'IT-PO', name: 'Prato' },
    { code: 'IT-75', name: 'Puglia' },
    { code: 'IT-RG', name: 'Ragusa' },
    { code: 'IT-RA', name: 'Ravenna' },
    { code: 'IT-RC', name: 'Reggio Calabria' },
    { code: 'IT-RE', name: 'Reggio Emilia' },
    { code: 'IT-RI', name: 'Rieti' },
    { code: 'IT-RN', name: 'Rimini' },
    { code: 'IT-RM', name: 'Roma' },
    { code: 'IT-RO', name: 'Rovigo' },
    { code: 'IT-SA', name: 'Salerno' },
    { code: 'IT-88', name: 'Sardegna' },
    { code: 'IT-SS', name: 'Sassari' },
    { code: 'IT-SV', name: 'Savona' },
    { code: 'IT-82', name: 'Sicilia' },
    { code: 'IT-SI', name: 'Siena' },
    { code: 'IT-SR', name: 'Siracusa' },
    { code: 'IT-SO', name: 'Sondrio' },
    { code: 'IT-TA', name: 'Taranto' },
    { code: 'IT-TE', name: 'Teramo' },
    { code: 'IT-TR', name: 'Terni' },
    { code: 'IT-TO', name: 'Torino' },
    { code: 'IT-52', name: 'Toscana' },
    { code: 'IT-TP', name: 'Trapani' },
    { code: 'IT-32', name: 'Trentino-Alto Adige' },
    { code: 'IT-TN', name: 'Trento' },
    { code: 'IT-TV', name: 'Treviso' },
    { code: 'IT-TS', name: 'Trieste' },
    { code: 'IT-UD', name: 'Udine' },
    { code: 'IT-55', name: 'Umbria' },
    { code: 'IT-23', name: "Valle d'Aosta" },
    { code: 'IT-VA', name: 'Varese' },
    { code: 'IT-34', name: 'Veneto' },
    { code: 'IT-VE', name: 'Venezia' },
    { code: 'IT-VB', name: 'Verbano-Cusio-Ossola' },
    { code: 'IT-VC', name: 'Vercelli' },
    { code: 'IT-VR', name: 'Verona' },
    { code: 'IT-VV', name: 'Vibo Valentia' },
    { code: 'IT-VI', name: 'Vicenza' },
    { code: 'IT-VT', name: 'Viterbo' },
  ],
  JM: [
    { code: 'JM-13', name: 'Clarendon' },
    { code: 'JM-09', name: 'Hanover' },
    { code: 'JM-01', name: 'Kingston' },
    { code: 'JM-12', name: 'Manchester' },
    { code: 'JM-04', name: 'Portland' },
    { code: 'JM-02', name: 'Saint Andrew' },
    { code: 'JM-06', name: 'Saint Ann' },
    { code: 'JM-14', name: 'Saint Catherine' },
    { code: 'JM-11', name: 'Saint Elizabeth' },
    { code: 'JM-08', name: 'Saint James' },
    { code: 'JM-05', name: 'Saint Mary' },
    { code: 'JM-03', name: 'Saint Thomas' },
    { code: 'JM-07', name: 'Trelawny' },
    { code: 'JM-10', name: 'Westmoreland' },
  ],
  JP: [
    { code: 'JP-23', name: 'Aichi' },
    { code: 'JP-05', name: 'Akita' },
    { code: 'JP-02', name: 'Aomori' },
    { code: 'JP-12', name: 'Chiba' },
    { code: 'JP-38', name: 'Ehime' },
    { code: 'JP-18', name: 'Fukui' },
    { code: 'JP-40', name: 'Fukuoka' },
    { code: 'JP-07', name: 'Fukushima' },
    { code: 'JP-21', name: 'Gifu' },
    { code: 'JP-10', name: 'Gumma' },
    { code: 'JP-34', name: 'Hiroshima' },
    { code: 'JP-01', name: 'Hokkaido' },
    { code: 'JP-28', name: 'Hyogo' },
    { code: 'JP-08', name: 'Ibaraki' },
    { code: 'JP-17', name: 'Ishikawa' },
    { code: 'JP-03', name: 'Iwate' },
    { code: 'JP-37', name: 'Kagawa' },
    { code: 'JP-46', name: 'Kagoshima' },
    { code: 'JP-14', name: 'Kanagawa' },
    { code: 'JP-39', name: 'Kochi' },
    { code: 'JP-43', name: 'Kumamoto' },
    { code: 'JP-26', name: 'Kyoto' },
    { code: 'JP-24', name: 'Mie' },
    { code: 'JP-04', name: 'Miyagi' },
    { code: 'JP-45', name: 'Miyazaki' },
    { code: 'JP-20', name: 'Nagano' },
    { code: 'JP-42', name: 'Nagasaki' },
    { code: 'JP-29', name: 'Nara' },
    { code: 'JP-15', name: 'Niigata' },
    { code: 'JP-44', name: 'Oita' },
    { code: 'JP-33', name: 'Okayama' },
    { code: 'JP-47', name: 'Okinawa' },
    { code: 'JP-27', name: 'Osaka' },
    { code: 'JP-41', name: 'Saga' },
    { code: 'JP-11', name: 'Saitama' },
    { code: 'JP-25', name: 'Shiga' },
    { code: 'JP-32', name: 'Shimane' },
    { code: 'JP-22', name: 'Shizuoka' },
    { code: 'JP-09', name: 'Tochigi' },
    { code: 'JP-36', name: 'Tokushima' },
    { code: 'JP-13', name: 'Tokyo' },
    { code: 'JP-31', name: 'Tottori' },
    { code: 'JP-16', name: 'Toyama' },
    { code: 'JP-30', name: 'Wakayama' },
    { code: 'JP-06', name: 'Yamagata' },
    { code: 'JP-35', name: 'Yamaguchi' },
    { code: 'JP-19', name: 'Yamanashi' },
  ],
  JO: [
    { code: 'JO-AJ', name: 'Ajlum' },
    { code: 'JO-AQ', name: "Al 'Aqabah" },
    { code: 'JO-BA', name: "Al Balqa'" },
    { code: 'JO-KA', name: 'Al Karak' },
    { code: 'JO-MA', name: 'Al Mafraq' },
    { code: 'JO-AM', name: 'Amman' },
    { code: 'JO-AT', name: 'At Tafilah' },
    { code: 'JO-AZ', name: "Az Zarqa'" },
    { code: 'JO-IR', name: 'Irbid' },
    { code: 'JO-JA', name: 'Jarash' },
    { code: 'JO-MN', name: "Ma'an" },
    { code: 'JO-MD', name: 'Madaba' },
  ],
  KZ: [
    { code: 'KZ-ALA', name: 'Almaty' },
    { code: 'KZ-ALM', name: 'Almaty City' },
    { code: 'KZ-AKM', name: 'Aqmola' },
    { code: 'KZ-AKT', name: 'Aqtobe' },
    { code: 'KZ-AST', name: 'Astana' },
    { code: 'KZ-ATY', name: 'Atyrau' },
    { code: 'KZ-ZAP', name: 'Bayqonyr' },
    { code: 'KZ-MAN', name: 'Mangghystau' },
    { code: 'KZ-PAV', name: 'Pavlodar' },
    { code: 'KZ-KAR', name: 'Qaraghandy' },
    { code: 'KZ-KUS', name: 'Qostanay' },
    { code: 'KZ-KZY', name: 'Qyzylorda' },
    { code: 'KZ-SEV', name: 'Severo-Kazahstanskaja oblast' },
    { code: 'KZ-VOS', name: 'Vostochno-Kazakhstanskaya oblast' },
    { code: 'KZ-YUZ', name: 'Yuzhno-Kazakhstankaya oblast' },
    { code: 'KZ-ZHA', name: 'Zhambyl' },
  ],
  KI: [
    { code: 'KI-G', name: 'Gilbert Islands' },
    { code: 'KI-L', name: 'Line Islands' },
    { code: 'KI-P', name: 'Phoenix Islands' },
  ],
  KW: [
    { code: 'KW-AH', name: 'Al Ahmadi' },
    { code: 'KW-KU', name: 'Al Asimah' },
    { code: 'KW-FA', name: 'Al Farwaniyah' },
    { code: 'KW-JA', name: 'Al Jahra' },
    { code: 'KW-HA', name: 'Hawalli' },
    { code: 'KW-MU', name: 'Mubarak al Kabir' },
  ],
  KG: [
    { code: 'KG-B', name: 'Batken' },
    { code: 'KG-GB', name: 'Bishkek' },
    { code: 'KG-C', name: 'Chuy' },
    { code: 'KG-GO', name: 'Gorod Osh' },
    { code: 'KG-J', name: 'Jalal-Abad' },
    { code: 'KG-N', name: 'Naryn' },
    { code: 'KG-O', name: 'Osh' },
    { code: 'KG-T', name: 'Talas' },
    { code: 'KG-Y', name: 'Ysyk-Kol' },
  ],
  LA: [
    { code: 'LA-AT', name: 'Attapu' },
    { code: 'LA-BK', name: 'Bokeo' },
    { code: 'LA-BL', name: 'Bolikhamxai' },
    { code: 'LA-CH', name: 'Champasak' },
    { code: 'LA-HO', name: 'Houaphan' },
    { code: 'LA-KH', name: 'Khoueng Khammouan' },
    { code: 'LA-PH', name: 'Khoueng Phongsali' },
    { code: 'LA-SL', name: 'Khoueng Salavan' },
    { code: 'LA-SV', name: 'Khoueng Savannakhet' },
    { code: 'LA-VI', name: 'Khoueng Viangchan' },
    { code: 'LA-XE', name: 'Khoueng Xekong' },
    { code: 'LA-LP', name: 'Louangphrabang' },
    { code: 'LA-LM', name: 'Loungnamtha' },
    { code: 'LA-OU', name: 'Oudomxai' },
    { code: 'LA-VT', name: 'Vientiane' },
    { code: 'LA-XA', name: 'Xaignabouri' },
    { code: 'LA-XN', name: 'XaisOmboun' },
    { code: 'LA-XI', name: 'Xiangkhoang' },
  ],
  LV: [
    { code: 'LV-011', name: 'Adazu novads' },
    { code: 'LV-001', name: 'Aglonas novads' },
    { code: 'LV-002', name: 'Aizkraukles novads' },
    { code: 'LV-003', name: 'Aizputes novads' },
    { code: 'LV-004', name: 'Aknistes novads' },
    { code: 'LV-005', name: 'Alojas novads' },
    { code: 'LV-006', name: 'Alsungas novads' },
    { code: 'LV-007', name: 'Aluksnes novads' },
    { code: 'LV-008', name: 'Amatas novads' },
    { code: 'LV-009', name: 'Apes novads' },
    { code: 'LV-012', name: 'Babites novads' },
    { code: 'LV-013', name: 'Baldones novads' },
    { code: 'LV-014', name: 'Baltinavas novads' },
    { code: 'LV-015', name: 'Balvu novads' },
    { code: 'LV-016', name: 'Bauskas novads' },
    { code: 'LV-017', name: 'Beverinas novads' },
    { code: 'LV-018', name: 'Brocenu novads' },
    { code: 'LV-019', name: 'Burtnieku novads' },
    { code: 'LV-020', name: 'Carnikavas novads' },
    { code: 'LV-022', name: 'Cesu novads' },
    { code: 'LV-021', name: 'Cesvaines novads' },
    { code: 'LV-023', name: 'Ciblas novads' },
    { code: 'LV-024', name: 'Dagdas novads' },
    { code: 'LV-DGV', name: 'Daugavpils' },
    { code: 'LV-025', name: 'Daugavpils novads' },
    { code: 'LV-026', name: 'Dobeles novads' },
    { code: 'LV-027', name: 'Dundagas novads' },
    { code: 'LV-028', name: 'Durbes novads' },
    { code: 'LV-029', name: 'Engures novads' },
    { code: 'LV-030', name: 'Erglu novads' },
    { code: 'LV-031', name: 'Garkalnes novads' },
    { code: 'LV-032', name: 'Grobinas novads' },
    { code: 'LV-033', name: 'Gulbenes novads' },
    { code: 'LV-034', name: 'Iecavas novads' },
    { code: 'LV-035', name: 'Ikskiles novads' },
    { code: 'LV-036', name: 'Ilukstes novads' },
    { code: 'LV-037', name: 'Incukalna novads' },
    { code: 'LV-038', name: 'Jaunjelgavas novads' },
    { code: 'LV-039', name: 'Jaunpiebalgas novads' },
    { code: 'LV-040', name: 'Jaunpils novads' },
    { code: 'LV-JKB', name: 'Jekabpils' },
    { code: 'LV-042', name: 'Jekabpils novads' },
    { code: 'LV-JEL', name: 'Jelgava' },
    { code: 'LV-041', name: 'Jelgavas novads' },
    { code: 'LV-JUR', name: 'Jurmala' },
    { code: 'LV-043', name: 'Kandavas novads' },
    { code: 'LV-044', name: 'Karsavas novads' },
    { code: 'LV-051', name: 'Keguma novads' },
    { code: 'LV-052', name: 'Kekavas novads' },
    { code: 'LV-045', name: 'Kocenu novads' },
    { code: 'LV-046', name: 'Kokneses novads' },
    { code: 'LV-047', name: 'Kraslavas novads' },
    { code: 'LV-048', name: 'Krimuldas novads' },
    { code: 'LV-049', name: 'Krustpils novads' },
    { code: 'LV-050', name: 'Kuldigas novads' },
    { code: 'LV-053', name: 'Lielvardes novads' },
    { code: 'LV-LPX', name: 'Liepaja' },
    { code: 'LV-055', name: 'Ligatnes novads' },
    { code: 'LV-054', name: 'Limbazu novads' },
    { code: 'LV-056', name: 'Livanu novads' },
    { code: 'LV-057', name: 'Lubanas novads' },
    { code: 'LV-058', name: 'Ludzas novads' },
    { code: 'LV-059', name: 'Madonas novads' },
    { code: 'LV-061', name: 'Malpils novads' },
    { code: 'LV-062', name: 'Marupes novads' },
    { code: 'LV-060', name: 'Mazsalacas novads' },
    { code: 'LV-063', name: 'Mersraga novads' },
    { code: 'LV-064', name: 'Naukesnu novads' },
    { code: 'LV-065', name: 'Neretas novads' },
    { code: 'LV-066', name: 'Nicas novads' },
    { code: 'LV-067', name: 'Ogres novads' },
    { code: 'LV-068', name: 'Olaines novads' },
    { code: 'LV-069', name: 'Ozolnieku novads' },
    { code: 'LV-070', name: 'Pargaujas novads' },
    { code: 'LV-071', name: 'Pavilostas novads' },
    { code: 'LV-072', name: 'Plavinu novads' },
    { code: 'LV-073', name: 'Preilu novads' },
    { code: 'LV-074', name: 'Priekules novads' },
    { code: 'LV-075', name: 'Priekulu novads' },
    { code: 'LV-076', name: 'Raunas novads' },
    { code: 'LV-REZ', name: 'Rezekne' },
    { code: 'LV-077', name: 'Rezeknes novads' },
    { code: 'LV-078', name: 'Riebinu novads' },
    { code: 'LV-RIX', name: 'Riga' },
    { code: 'LV-079', name: 'Rojas novads' },
    { code: 'LV-080', name: 'Ropazu novads' },
    { code: 'LV-081', name: 'Rucavas novads' },
    { code: 'LV-082', name: 'Rugaju novads' },
    { code: 'LV-084', name: 'Rujienas novads' },
    { code: 'LV-083', name: 'Rundales novads' },
    { code: 'LV-086', name: 'Salacgrivas novads' },
    { code: 'LV-085', name: 'Salas novads' },
    { code: 'LV-087', name: 'Salaspils novads' },
    { code: 'LV-088', name: 'Saldus novads' },
    { code: 'LV-089', name: 'Saulkrastu novads' },
    { code: 'LV-090', name: 'Sejas novads' },
    { code: 'LV-091', name: 'Siguldas novads' },
    { code: 'LV-092', name: 'Skriveru novads' },
    { code: 'LV-093', name: 'Skrundas novads' },
    { code: 'LV-094', name: 'Smiltenes novads' },
    { code: 'LV-095', name: 'Stopinu novads' },
    { code: 'LV-096', name: 'Strencu novads' },
    { code: 'LV-097', name: 'Talsu novads' },
    { code: 'LV-098', name: 'Tervetes novads' },
    { code: 'LV-099', name: 'Tukuma novads' },
    { code: 'LV-100', name: 'Vainodes novads' },
    { code: 'LV-101', name: 'Valkas novads' },
    { code: 'LV-VMR', name: 'Valmiera' },
    { code: 'LV-102', name: 'Varaklanu novads' },
    { code: 'LV-103', name: 'Varkavas novads' },
    { code: 'LV-104', name: 'Vecpiebalgas novads' },
    { code: 'LV-105', name: 'Vecumnieku novads' },
    { code: 'LV-VEN', name: 'Ventspils' },
    { code: 'LV-106', name: 'Ventspils novads' },
    { code: 'LV-107', name: 'Viesites novads' },
    { code: 'LV-108', name: 'Vilakas novads' },
    { code: 'LV-109', name: 'Vilanu novads' },
    { code: 'LV-110', name: 'Zilupes novads' },
  ],
  LB: [
    { code: 'LB-AK', name: 'Aakk' },
    { code: 'LB-BH', name: 'Baalbek-Hermel' },
    { code: 'LB-BI', name: 'Beqaa' },
    { code: 'LB-BA', name: 'Beyrouth' },
    { code: 'LB-AS', name: 'Liban-Nord' },
    { code: 'LB-JA', name: 'Liban-Sud' },
    { code: 'LB-JL', name: 'Mont-Liban' },
    { code: 'LB-NA', name: 'Nabatiye' },
  ],
  LS: [
    { code: 'LS-D', name: 'Berea' },
    { code: 'LS-B', name: 'Butha-Buthe' },
    { code: 'LS-C', name: 'Leribe' },
    { code: 'LS-E', name: 'Mafeteng' },
    { code: 'LS-A', name: 'Maseru' },
    { code: 'LS-F', name: 'Mohales Hoek' },
    { code: 'LS-J', name: 'Mokhotlong' },
    { code: 'LS-H', name: 'Qachas Nek' },
    { code: 'LS-G', name: 'Quthing' },
    { code: 'LS-K', name: 'Thaba-Tseka' },
  ],
  LR: [
    { code: 'LR-BM', name: 'Bomi' },
    { code: 'LR-BG', name: 'Bong' },
    { code: 'LR-GP', name: 'Gbarpolu' },
    { code: 'LR-GB', name: 'Grand Bassa' },
    { code: 'LR-CM', name: 'Grand Cape Mount' },
    { code: 'LR-GG', name: 'Grand Gedeh' },
    { code: 'LR-GK', name: 'Grand Kru' },
    { code: 'LR-LO', name: 'Lofa' },
    { code: 'LR-MG', name: 'Margibi' },
    { code: 'LR-MY', name: 'Maryland' },
    { code: 'LR-MO', name: 'Montserrado' },
    { code: 'LR-NI', name: 'Nimba' },
    { code: 'LR-RI', name: 'River Cess' },
    { code: 'LR-RG', name: 'River Gee' },
    { code: 'LR-SI', name: 'Sino' },
  ],
  LI: [
    { code: 'LI-01', name: 'Balzers' },
    { code: 'LI-02', name: 'Eschen' },
    { code: 'LI-03', name: 'Gamprin' },
    { code: 'LI-04', name: 'Mauren' },
    { code: 'LI-05', name: 'Planken' },
    { code: 'LI-06', name: 'Ruggell' },
    { code: 'LI-07', name: 'Schaan' },
    { code: 'LI-08', name: 'Schellenberg' },
    { code: 'LI-09', name: 'Triesen' },
    { code: 'LI-10', name: 'Triesenberg' },
    { code: 'LI-11', name: 'Vaduz' },
  ],
  LT: [
    { code: 'LT-AL', name: 'Alytaus Apskritis' },
    { code: 'LT-KU', name: 'Kauno Apskritis' },
    { code: 'LT-KL', name: 'Klaipedos Apskritis' },
    { code: 'LT-MR', name: 'Marijampoles Apskritis' },
    { code: 'LT-PN', name: 'Panevezio Apskritis' },
    { code: 'LT-SA', name: 'Siauliu Apskritis' },
    { code: 'LT-TA', name: 'Taurages Apskritis' },
    { code: 'LT-TE', name: 'Telsiu Apskritis' },
    { code: 'LT-UT', name: 'Utenos Apskritis' },
    { code: 'LT-VL', name: 'Vilniaus Apskritis' },
  ],
  LU: [
    { code: 'LU-D', name: 'Diekirch' },
    { code: 'LU-G', name: 'Grevenmacher' },
    { code: 'LU-L', name: 'Luxembourg' },
  ],
  MG: [
    { code: 'MG-T', name: 'Antananarivo' },
    { code: 'MG-D', name: 'Antsiranana' },
    { code: 'MG-F', name: 'Fianarantsoa' },
    { code: 'MG-M', name: 'Mahajanga' },
    { code: 'MG-A', name: 'Toamasina' },
    { code: 'MG-U', name: 'Toliara' },
  ],
  MW: [
    { code: 'MW-BA', name: 'Balaka' },
    { code: 'MW-BL', name: 'Blantyre' },
    { code: 'MW-C', name: 'Central Region' },
    { code: 'MW-CK', name: 'Chikwawa' },
    { code: 'MW-CR', name: 'Chiradzulu' },
    { code: 'MW-CT', name: 'Chitipa' },
    { code: 'MW-DE', name: 'Dedza' },
    { code: 'MW-DO', name: 'Dowa' },
    { code: 'MW-KR', name: 'Karonga' },
    { code: 'MW-KS', name: 'Kasungu' },
    { code: 'MW-LK', name: 'Likoma' },
    { code: 'MW-LI', name: 'Lilongwe' },
    { code: 'MW-MH', name: 'Machinga' },
    { code: 'MW-MG', name: 'Mangochi' },
    { code: 'MW-MC', name: 'Mchinji' },
    { code: 'MW-MU', name: 'Mulanje' },
    { code: 'MW-MW', name: 'Mwanza' },
    { code: 'MW-MZ', name: 'Mzimba' },
    { code: 'MW-NE', name: 'Neno' },
    { code: 'MW-NB', name: 'Nkhata Bay' },
    { code: 'MW-NK', name: 'Nkhotakota' },
    { code: 'MW-N', name: 'Northern Region' },
    { code: 'MW-NS', name: 'Nsanje' },
    { code: 'MW-NU', name: 'Ntcheu' },
    { code: 'MW-NI', name: 'Ntchisi' },
    { code: 'MW-PH', name: 'Phalombe' },
    { code: 'MW-RU', name: 'Rumphi' },
    { code: 'MW-SA', name: 'Salima' },
    { code: 'MW-S', name: 'Southern Region' },
    { code: 'MW-TH', name: 'Thyolo' },
    { code: 'MW-ZO', name: 'Zomba' },
  ],
  MY: [
    { code: 'MY-01', name: 'Johor' },
    { code: 'MY-02', name: 'Kedah' },
    { code: 'MY-03', name: 'Kelantan' },
    { code: 'MY-14', name: 'Kuala Lumpur' },
    { code: 'MY-15', name: 'Labuan' },
    { code: 'MY-04', name: 'Melaka' },
    { code: 'MY-05', name: 'Negeri Sembilan' },
    { code: 'MY-06', name: 'Pahang' },
    { code: 'MY-08', name: 'Perak' },
    { code: 'MY-09', name: 'Perlis' },
    { code: 'MY-07', name: 'Pulau Pinang' },
    { code: 'MY-16', name: 'Putrajaya' },
    { code: 'MY-12', name: 'Sabah' },
    { code: 'MY-13', name: 'Sarawak' },
    { code: 'MY-10', name: 'Selangor' },
    { code: 'MY-11', name: 'Terengganu' },
  ],
  MV: [
    { code: 'MV-02', name: 'Alifu' },
    { code: 'MV-00', name: 'Alifu Dhaalu' },
    { code: 'MV-20', name: 'Baa' },
    { code: 'MV-CE', name: 'Central' },
    { code: 'MV-17', name: 'Dhaalu' },
    { code: 'MV-14', name: 'Faafu' },
    { code: 'MV-27', name: 'Gaafu Alifu' },
    { code: 'MV-28', name: 'Gaafu Dhaalu' },
    { code: 'MV-29', name: 'Gnaviyani' },
    { code: 'MV-07', name: 'Haa Alifu' },
    { code: 'MV-23', name: 'Haa Dhaalu' },
    { code: 'MV-26', name: 'Kaafu' },
    { code: 'MV-05', name: 'Laamu' },
    { code: 'MV-03', name: 'Lhaviyani' },
    { code: 'MV-MLE', name: 'Maale' },
    { code: 'MV-12', name: 'Meemu' },
    { code: 'MV-25', name: 'Noonu' },
    { code: 'MV-NO', name: 'North' },
    { code: 'MV-NC', name: 'North Central' },
    { code: 'MV-13', name: 'Raa' },
    { code: 'MV-01', name: 'Seenu' },
    { code: 'MV-24', name: 'Shaviyani' },
    { code: 'MV-SU', name: 'South' },
    { code: 'MV-SC', name: 'South Central' },
    { code: 'MV-08', name: 'Thaa' },
    { code: 'MV-UN', name: 'Upper North' },
    { code: 'MV-US', name: 'Upper South' },
    { code: 'MV-04', name: 'Vaavu' },
  ],
  ML: [
    { code: 'ML-BKO', name: 'Bamako' },
    { code: 'ML-7', name: 'Gao' },
    { code: 'ML-1', name: 'Kayes' },
    { code: 'ML-8', name: 'Kidal' },
    { code: 'ML-2', name: 'Koulikoro' },
    { code: 'ML-5', name: 'Mopti' },
    { code: 'ML-4', name: 'Segou' },
    { code: 'ML-3', name: 'Sikasso' },
    { code: 'ML-6', name: 'Tombouctou' },
  ],
  MT: [
    { code: 'MT-01', name: 'Attard' },
    { code: 'MT-02', name: 'Balzan' },
    { code: 'MT-03', name: 'Birgu' },
    { code: 'MT-04', name: 'Birkirkara' },
    { code: 'MT-05', name: 'Birzebbuga' },
    { code: 'MT-06', name: 'Bormla' },
    { code: 'MT-07', name: 'Dingli' },
    { code: 'MT-08', name: 'Fgura' },
    { code: 'MT-09', name: 'Floriana' },
    { code: 'MT-10', name: 'Fontana' },
    { code: 'MT-13', name: 'Ghajnsielem' },
    { code: 'MT-14', name: 'Gharb' },
    { code: 'MT-15', name: 'Gharghur' },
    { code: 'MT-16', name: 'Ghasri' },
    { code: 'MT-17', name: 'Ghaxaq' },
    { code: 'MT-11', name: 'Gudja' },
    { code: 'MT-12', name: 'Gzira' },
    { code: 'MT-18', name: 'Hamrun' },
    { code: 'MT-19', name: 'Iklin' },
    { code: 'MT-20', name: 'Isla' },
    { code: 'MT-21', name: 'Kalkara' },
    { code: 'MT-22', name: 'Kercem' },
    { code: 'MT-23', name: 'Kirkop' },
    { code: 'MT-24', name: 'Lija' },
    { code: 'MT-25', name: 'Luqa' },
    { code: 'MT-26', name: 'Marsa' },
    { code: 'MT-27', name: 'Marsaskala' },
    { code: 'MT-28', name: 'Marsaxlokk' },
    { code: 'MT-29', name: 'Mdina' },
    { code: 'MT-30', name: 'Mellieha' },
    { code: 'MT-31', name: 'Mgarr' },
    { code: 'MT-32', name: 'Mosta' },
    { code: 'MT-33', name: 'Mqabba' },
    { code: 'MT-34', name: 'Msida' },
    { code: 'MT-35', name: 'Mtarfa' },
    { code: 'MT-36', name: 'Munxar' },
    { code: 'MT-37', name: 'Nadur' },
    { code: 'MT-38', name: 'Naxxar' },
    { code: 'MT-39', name: 'Paola' },
    { code: 'MT-40', name: 'Pembroke' },
    { code: 'MT-41', name: 'Pieta' },
    { code: 'MT-42', name: 'Qala' },
    { code: 'MT-43', name: 'Qormi' },
    { code: 'MT-44', name: 'Qrendi' },
    { code: 'MT-45', name: 'Rabat Gozo' },
    { code: 'MT-46', name: 'Rabat Malta' },
    { code: 'MT-47', name: 'Safi' },
    { code: 'MT-49', name: 'Saint John' },
    { code: 'MT-48', name: 'Saint Julians' },
    { code: 'MT-50', name: 'Saint Lawrence' },
    { code: 'MT-53', name: 'Saint Lucias' },
    { code: 'MT-51', name: 'Saint Pauls Bay' },
    { code: 'MT-52', name: 'Sannat' },
    { code: 'MT-54', name: 'Santa Venera' },
    { code: 'MT-55', name: 'Siggiewi' },
    { code: 'MT-56', name: 'Sliema' },
    { code: 'MT-57', name: 'Swieqi' },
    { code: 'MT-58', name: 'Ta Xbiex' },
    { code: 'MT-59', name: 'Tarxien' },
    { code: 'MT-60', name: 'Valletta' },
    { code: 'MT-61', name: 'Xaghra' },
    { code: 'MT-62', name: 'Xewkija' },
    { code: 'MT-63', name: 'Xghajra' },
    { code: 'MT-64', name: 'Zabbar' },
    { code: 'MT-65', name: 'Zebbug Gozo' },
    { code: 'MT-66', name: 'Zebbug Malta' },
    { code: 'MT-67', name: 'Zejtun' },
    { code: 'MT-68', name: 'Zurrieq' },
  ],
  MH: [
    { code: 'MH-ALL', name: 'Ailinglaplap Atoll' },
    { code: 'MH-ALK', name: 'Ailuk Atoll' },
    { code: 'MH-ARN', name: 'Arno Atoll' },
    { code: 'MH-AUR', name: 'Aur Atoll' },
    { code: 'MH-EBO', name: 'Ebon Atoll' },
    { code: 'MH-ENI', name: 'Enewetak Atoll' },
    { code: 'MH-JAB', name: 'Jabat Island' },
    { code: 'MH-JAL', name: 'Jaluit Atoll' },
    { code: 'MH-KIL', name: 'Kili Island' },
    { code: 'MH-KWA', name: 'Kwajalein Atoll' },
    { code: 'MH-LAE', name: 'Lae Atoll' },
    { code: 'MH-LIB', name: 'Lib Island' },
    { code: 'MH-LIK', name: 'Likiep Atoll' },
    { code: 'MH-MAJ', name: 'Majuro Atoll' },
    { code: 'MH-MAL', name: 'Maloelap Atoll' },
    { code: 'MH-MEJ', name: 'Mejit Island' },
    { code: 'MH-MIL', name: 'Mili Atoll' },
    { code: 'MH-NMK', name: 'Namdrik Atoll' },
    { code: 'MH-NMU', name: 'Namu Atoll' },
    { code: 'MH-L', name: 'Ralik chain' },
    { code: 'MH-T', name: 'Ratak chain' },
    { code: 'MH-RON', name: 'Rongelap Atoll' },
    { code: 'MH-UJA', name: 'Ujae Atoll' },
    { code: 'MH-UTI', name: 'Utrik Atoll' },
    { code: 'MH-WTH', name: 'Wotho Atoll' },
    { code: 'MH-WTJ', name: 'Wotje Atoll' },
  ],
  MR: [
    { code: 'MR-07', name: 'Adrar' },
    { code: 'MR-03', name: 'Assaba' },
    { code: 'MR-05', name: 'Brakna' },
    { code: 'MR-08', name: 'Dakhlet Nouadhibou' },
    { code: 'MR-04', name: 'Gorgol' },
    { code: 'MR-10', name: 'Guidimaka' },
    { code: 'MR-01', name: 'Hodh Ech Chargui' },
    { code: 'MR-02', name: 'Hodh El Gharbi' },
    { code: 'MR-12', name: 'Inchiri' },
    { code: 'MR-NKC', name: 'Nouakchott' },
    { code: 'MR-09', name: 'Tagant' },
    { code: 'MR-11', name: 'Tiris Zemmour' },
    { code: 'MR-06', name: 'Trarza' },
  ],
  MU: [
    { code: 'MU-AG', name: 'Agalega Islands' },
    { code: 'MU-BR', name: 'Beau Bassin-Rose Hill' },
    { code: 'MU-BL', name: 'Black River' },
    { code: 'MU-CC', name: 'Cargados Carajos Shoals' },
    { code: 'MU-CU', name: 'Curepipe' },
    { code: 'MU-FL', name: 'Flacq' },
    { code: 'MU-GP', name: 'Grand Port' },
    { code: 'MU-MO', name: 'Moka' },
    { code: 'MU-PA', name: 'Pamplemousses' },
    { code: 'MU-PW', name: 'Plaines Wilhems' },
    { code: 'MU-PL', name: 'Port Louis' },
    { code: 'MU-PU', name: 'Port Louis' },
    { code: 'MU-QB', name: 'Quatre Bornes' },
    { code: 'MU-RR', name: 'Riviere du Rempart' },
    { code: 'MU-RO', name: 'Rodrigues Island' },
    { code: 'MU-SA', name: 'Savanne' },
    { code: 'MU-VP', name: 'Vacoas-Phoenix' },
  ],
  MX: [
    { code: 'MX-AGU', name: 'Aguascalientes' },
    { code: 'MX-BCN', name: 'Baja California' },
    { code: 'MX-BCS', name: 'Baja California Sur' },
    { code: 'MX-CAM', name: 'Campeche' },
    { code: 'MX-CHP', name: 'Chiapas' },
    { code: 'MX-CHH', name: 'Chihuahua' },
    { code: 'MX-COA', name: 'Coahuila de Zaragoza' },
    { code: 'MX-COL', name: 'Colima' },
    { code: 'MX-DIF', name: 'Distrito Federal' },
    { code: 'MX-DUR', name: 'Durango' },
    { code: 'MX-GUA', name: 'Guanajuato' },
    { code: 'MX-GRO', name: 'Guerrero' },
    { code: 'MX-HID', name: 'Hidalgo' },
    { code: 'MX-JAL', name: 'Jalisco' },
    { code: 'MX-MEX', name: 'Mexico' },
    { code: 'MX-MIC', name: 'Michoacan de Ocampo' },
    { code: 'MX-MOR', name: 'Morelos' },
    { code: 'MX-NAY', name: 'Nayarit' },
    { code: 'MX-NLE', name: 'Nuevo Leon' },
    { code: 'MX-OAX', name: 'Oaxaca' },
    { code: 'MX-PUE', name: 'Puebla' },
    { code: 'MX-QUE', name: 'Queretaro de Arteaga' },
    { code: 'MX-ROO', name: 'Quintana Roo' },
    { code: 'MX-SLP', name: 'San Luis Potosi' },
    { code: 'MX-SIN', name: 'Sinaloa' },
    { code: 'MX-SON', name: 'Sonora' },
    { code: 'MX-TAB', name: 'Tabasco' },
    { code: 'MX-TAM', name: 'Tamaulipas' },
    { code: 'MX-TLA', name: 'Tlaxcala' },
    { code: 'MX-VER', name: 'Veracruz-Llave' },
    { code: 'MX-YUC', name: 'Yucatan' },
    { code: 'MX-ZAC', name: 'Zacatecas' },
  ],
  FM: [
    { code: 'FM-TRK', name: 'Chuuk' },
    { code: 'FM-KSA', name: 'Kosrae' },
    { code: 'FM-PNI', name: 'Pohnpei' },
    { code: 'FM-YAP', name: 'Yap' },
  ],
  MC: [
    { code: 'MC-FO', name: 'Fontvieille' },
    { code: 'MC-JE', name: 'Jardin Exotique' },
    { code: 'MC-CL', name: 'La Colle' },
    { code: 'MC-CO', name: 'La Condamine' },
    { code: 'MC-GA', name: 'La Gare' },
    { code: 'MC-SO', name: 'La Source' },
    { code: 'MC-LA', name: 'Larvotto' },
    { code: 'MC-MA', name: 'Malbousquet' },
    { code: 'MC-MO', name: 'Monaco-Ville' },
    { code: 'MC-MG', name: 'Moneghetti' },
    { code: 'MC-MC', name: 'Monte-Carlo' },
    { code: 'MC-MU', name: 'Moulins' },
    { code: 'MC-PH', name: 'Port-Hercule' },
    { code: 'MC-SR', name: 'Saint-Roman' },
    { code: 'MC-SD', name: 'Sainte-Devote' },
    { code: 'MC-SP', name: 'Spalugues' },
    { code: 'MC-VR', name: 'Vallon de la Rousse' },
  ],
  MN: [
    { code: 'MN-073', name: 'Arhangay' },
    { code: 'MN-071', name: 'Bayan-Olgiy' },
    { code: 'MN-069', name: 'Bayanhongor' },
    { code: 'MN-067', name: 'Bulgan' },
    { code: 'MN-037', name: 'Darhan-Uul' },
    { code: 'MN-061', name: 'Dornod' },
    { code: 'MN-063', name: 'Dornogovi' },
    { code: 'MN-059', name: 'Dundgovi' },
    { code: 'MN-057', name: 'Dzavhan' },
    { code: 'MN-065', name: 'Govi-Altay' },
    { code: 'MN-064', name: 'Govisumber' },
    { code: 'MN-039', name: 'Hentiy' },
    { code: 'MN-043', name: 'Hovd' },
    { code: 'MN-041', name: 'Hovsgol' },
    { code: 'MN-053', name: 'Omnogovi' },
    { code: 'MN-035', name: 'Orhon' },
    { code: 'MN-055', name: 'Ovorhangay' },
    { code: 'MN-049', name: 'Selenge' },
    { code: 'MN-051', name: 'Suhbaatar' },
    { code: 'MN-047', name: 'Tov' },
    { code: 'MN-1', name: 'Ulaanbaatar' },
    { code: 'MN-046', name: 'Uvs' },
  ],
  ME: [
    { code: 'ME-02', name: 'Opstina Bar' },
    { code: 'ME-05', name: 'Opstina Budva' },
    { code: 'ME-06', name: 'Opstina Cetinje' },
    { code: 'ME-07', name: 'Opstina Danilovgrad' },
    { code: 'ME-08', name: 'Opstina Herceg Novi' },
    { code: 'ME-09', name: 'Opstina Kolasin' },
    { code: 'ME-10', name: 'Opstina Kotor' },
    { code: 'ME-11', name: 'Opstina Mojkovac' },
    { code: 'ME-12', name: 'Opstina Niksic' },
    { code: 'ME-16', name: 'Opstina Podgorica' },
    { code: 'ME-19', name: 'Opstina Tivat' },
    { code: 'ME-20', name: 'Opstina Ulcinj' },
    { code: 'ME-21', name: 'Opstina Zabljak' },
  ],
  MA: [
    { code: 'MA-09', name: 'Chaouia-Ouardigha' },
    { code: 'MA-10', name: 'Doukkala-Abda' },
    { code: 'MA-05', name: 'Fes-Boulemane' },
    { code: 'MA-02', name: 'Gharb-Chrarda-Beni Hssen' },
    { code: 'MA-08', name: 'Grand Casablanca' },
    { code: 'MA-11', name: 'Marrakech-Tensift-Al Haouz' },
    { code: 'MA-06', name: 'Meknes-Tafilalet' },
    { code: 'MA-04', name: 'Oriental' },
    { code: 'MA-07', name: 'Rabat-Sale-Zemmour-Zaer' },
    { code: 'MA-13', name: 'Souss-Massa-Dr' },
    { code: 'MA-12', name: 'Tadla-Azilal' },
    { code: 'MA-01', name: 'Tanger-Tetouan' },
    { code: 'MA-03', name: 'Taza-Al Hoceima-Taounate' },
  ],
  MZ: [
    { code: 'MZ-P', name: 'Cabo Delgado' },
    { code: 'MZ-G', name: 'Gaza' },
    { code: 'MZ-I', name: 'Inhambane' },
    { code: 'MZ-B', name: 'Manica' },
    { code: 'MZ-L', name: 'Maputo' },
    { code: 'MZ-N', name: 'Nampula' },
    { code: 'MZ-A', name: 'Niassa' },
    { code: 'MZ-S', name: 'Sofala' },
    { code: 'MZ-T', name: 'Tete' },
    { code: 'MZ-Q', name: 'Zambezia' },
  ],
  NA: [
    { code: 'NA-CA', name: 'Caprivi' },
    { code: 'NA-ER', name: 'Erongo' },
    { code: 'NA-HA', name: 'Hardap' },
    { code: 'NA-KA', name: 'Karas' },
    { code: 'NA-KU', name: 'Kunene' },
    { code: 'NA-OW', name: 'Ohangwena' },
    { code: 'NA-OH', name: 'Omaheke' },
    { code: 'NA-OS', name: 'Omusati' },
    { code: 'NA-ON', name: 'Oshana' },
    { code: 'NA-OT', name: 'Oshikoto' },
    { code: 'NA-OD', name: 'Otjozondjupa' },
  ],
  NP: [
    { code: 'NP-BA', name: 'Bagmati' },
    { code: 'NP-BH', name: 'Bheri' },
    { code: 'NP-DH', name: 'Dhawalagiri' },
    { code: 'NP-GA', name: 'Gandaki' },
    { code: 'NP-JA', name: 'Janakpur' },
    { code: 'NP-KA', name: 'Karnali' },
    { code: 'NP-KO', name: 'Kosi' },
    { code: 'NP-LU', name: 'Lumbini' },
    { code: 'NP-MA', name: 'Mahakali' },
    { code: 'NP-ME', name: 'Mechi' },
    { code: 'NP-NA', name: 'Narayani' },
    { code: 'NP-RA', name: 'Rapti' },
    { code: 'NP-SA', name: 'Sagarmatha' },
    { code: 'NP-SE', name: 'Seti' },
  ],
  NL: [
    { code: 'NL-DR', name: 'Drenthe' },
    { code: 'NL-FL', name: 'Flevoland' },
    { code: 'NL-FR', name: 'Friesland' },
    { code: 'NL-GE', name: 'Gelderland' },
    { code: 'NL-GR', name: 'Groningen' },
    { code: 'NL-LI', name: 'Limburg' },
    { code: 'NL-NB', name: 'Noord-Brabant' },
    { code: 'NL-NH', name: 'Noord-Holland' },
    { code: 'NL-OV', name: 'Overijssel' },
    { code: 'NL-UT', name: 'Utrecht' },
    { code: 'NL-ZE', name: 'Zeeland' },
    { code: 'NL-ZH', name: 'Zuid-Holland' },
  ],
  NZ: [
    { code: 'NZ-AUK', name: 'Auckland' },
    { code: 'NZ-BOP', name: 'Bay of Plenty' },
    { code: 'NZ-CAN', name: 'Canterbury' },
    { code: 'NZ-CIT', name: 'Chatham Islands' },
    { code: 'NZ-GIS', name: 'Gisborne' },
    { code: 'NZ-HKB', name: "Hawke's Bay" },
    { code: 'NZ-MWT', name: 'Manawatu-Wanganui' },
    { code: 'NZ-MBH', name: 'Marlborough' },
    { code: 'NZ-NSN', name: 'Nelson' },
    { code: 'NZ-NTL', name: 'Northland' },
    { code: 'NZ-OTA', name: 'Otago' },
    { code: 'NZ-STL', name: 'Southland' },
    { code: 'NZ-TKI', name: 'Taranaki' },
    { code: 'NZ-TAS', name: 'Tasman' },
    { code: 'NZ-WKO', name: 'Waikato' },
    { code: 'NZ-WGN', name: 'Wellington' },
    { code: 'NZ-WTC', name: 'West Coast' },
  ],
  NI: [
    { code: 'NI-AN', name: 'Autonoma Atlantico Norte' },
    { code: 'NI-BO', name: 'Boaco' },
    { code: 'NI-CA', name: 'Carazo' },
    { code: 'NI-CI', name: 'Chinandega' },
    { code: 'NI-CO', name: 'Chontales' },
    { code: 'NI-ES', name: 'Esteli' },
    { code: 'NI-GR', name: 'Granada' },
    { code: 'NI-JI', name: 'Jinotega' },
    { code: 'NI-LE', name: 'Leon' },
    { code: 'NI-MD', name: 'Madriz' },
    { code: 'NI-MN', name: 'Managua' },
    { code: 'NI-MS', name: 'Masaya' },
    { code: 'NI-MT', name: 'Matagalpa' },
    { code: 'NI-NS', name: 'Nueva Segovia' },
    { code: 'NI-AS', name: 'Region Autonoma Atlantico Sur' },
    { code: 'NI-SJ', name: 'Rio San Juan' },
    { code: 'NI-RI', name: 'Rivas' },
  ],
  NE: [
    { code: 'NE-1', name: 'Agadez' },
    { code: 'NE-2', name: 'Diffa' },
    { code: 'NE-3', name: 'Dosso' },
    { code: 'NE-4', name: 'Maradi' },
    { code: 'NE-8', name: 'Niamey' },
    { code: 'NE-5', name: 'Tahoua' },
    { code: 'NE-6', name: 'Tillaberi' },
    { code: 'NE-7', name: 'Zinder' },
  ],
  NO: [
    { code: 'NO-02', name: 'Akershus' },
    { code: 'NO-09', name: 'Aust-Agder' },
    { code: 'NO-06', name: 'Buskerud' },
    { code: 'NO-20', name: 'Finnmark' },
    { code: 'NO-04', name: 'Hedmark' },
    { code: 'NO-12', name: 'Hordaland' },
    { code: 'NO-15', name: 'More og Romsdal' },
    { code: 'NO-17', name: 'Nord-Trondelag' },
    { code: 'NO-18', name: 'Nordland' },
    { code: 'NO-05', name: 'Oppland' },
    { code: 'NO-03', name: 'Oslo' },
    { code: 'NO-01', name: 'Ostfold' },
    { code: 'NO-11', name: 'Rogaland' },
    { code: 'NO-14', name: 'Sogn og Fjordane' },
    { code: 'NO-16', name: 'Sor-Trondelag' },
    { code: 'NO-08', name: 'Telemark' },
    { code: 'NO-19', name: 'Troms' },
    { code: 'NO-10', name: 'Vest-Agder' },
    { code: 'NO-07', name: 'Vestfold' },
  ],
  PS: [
    { code: 'PS-BTH', name: 'Bethlehem' },
    { code: 'PS-DEB', name: 'Deir El Balah' },
    { code: 'PS-GZA', name: 'Gaza' },
    { code: 'PS-HBN', name: 'Hebron' },
    { code: 'PS-JEN', name: 'Jenin' },
    { code: 'PS-JRH', name: 'Jericho Al Aghwar' },
    { code: 'PS-JEM', name: 'Jerusalem' },
    { code: 'PS-KYS', name: 'Khan Yunis' },
    { code: 'PS-NBS', name: 'Nablus' },
    { code: 'PS-NGZ', name: 'North Gaza' },
    { code: 'PS-QQA', name: 'Qalqilya' },
    { code: 'PS-RFH', name: 'Rafah' },
    { code: 'PS-RBH', name: 'Ramallah' },
    { code: 'PS-SLT', name: 'Salfit' },
    { code: 'PS-TBS', name: 'Tubas' },
    { code: 'PS-TKM', name: 'Tulkarm' },
  ],
  OM: [
    { code: 'OM-DA', name: 'Ad Dakhiliyah' },
    { code: 'OM-BA', name: 'Al Batinah' },
    { code: 'OM-BU', name: 'Al Buraymi' },
    { code: 'OM-WU', name: 'Al Wusta' },
    { code: 'OM-SH', name: 'Ash Sharqiyah' },
    { code: 'OM-ZA', name: 'Az Zahirah' },
    { code: 'OM-MA', name: 'Masqat' },
    { code: 'OM-MU', name: 'Musandam' },
    { code: 'OM-ZU', name: 'Zufar' },
  ],
  PK: [
    { code: 'PK-JK', name: 'Azad Kashmir' },
    { code: 'PK-BA', name: 'Balochistan' },
    { code: 'PK-TA', name: 'Federally Administered Tribal Areas' },
    { code: 'PK-IS', name: 'Islamabad' },
    { code: 'PK-KP', name: 'Khyber Pakhtunkhwa' },
    { code: 'PK-PB', name: 'Punjab' },
    { code: 'PK-SD', name: 'Sindh' },
  ],
  PW: [
    { code: 'PW-002', name: 'Aimeliik' },
    { code: 'PW-004', name: 'Airai' },
    { code: 'PW-010', name: 'Angaur' },
    { code: 'PW-100', name: 'Kayangel' },
    { code: 'PW-150', name: 'Koror' },
    { code: 'PW-212', name: 'Melekeok' },
    { code: 'PW-214', name: 'Ngaraard' },
    { code: 'PW-218', name: 'Ngarchelong' },
    { code: 'PW-222', name: 'Ngardmau' },
    { code: 'PW-224', name: 'Ngatpang' },
    { code: 'PW-228', name: 'Ngiwal' },
    { code: 'PW-350', name: 'Peleliu' },
  ],
  PA: [
    { code: 'PA-1', name: 'Bocas del Toro' },
    { code: 'PA-4', name: 'Chiriqui' },
    { code: 'PA-2', name: 'Cocle' },
    { code: 'PA-3', name: 'Colon' },
    { code: 'PA-5', name: 'Darien' },
    { code: 'PA-6', name: 'Herrera' },
    { code: 'PA-7', name: 'Los Santos' },
    { code: 'PA-8', name: 'Panama' },
    { code: 'PA-9', name: 'Veraguas' },
  ],
  PG: [
    { code: 'PG-CPK', name: 'Chimbu' },
    { code: 'PG-EBR', name: 'East New Britain' },
    { code: 'PG-ESW', name: 'East Sepik' },
    { code: 'PG-EHG', name: 'Eastern Highlands' },
    { code: 'PG-EPW', name: 'Enga' },
    { code: 'PG-GPK', name: 'Gulf' },
    { code: 'PG-MPM', name: 'Madang' },
    { code: 'PG-MRL', name: 'Manus' },
    { code: 'PG-MBA', name: 'Milne Bay' },
    { code: 'PG-MPL', name: 'Morobe' },
    { code: 'PG-NCD', name: 'National Capital' },
    { code: 'PG-NIK', name: 'New Ireland' },
    { code: 'PG-NPP', name: 'Northern' },
    { code: 'PG-SAN', name: 'Sandaun' },
    { code: 'PG-SHM', name: 'Southern Highlands' },
    { code: 'PG-WBK', name: 'West New Britain' },
    { code: 'PG-WPD', name: 'Western' },
    { code: 'PG-WHM', name: 'Western Highlands' },
  ],
  PY: [
    { code: 'PY-16', name: 'Alto Paraguay' },
    { code: 'PY-10', name: 'Alto Parana' },
    { code: 'PY-13', name: 'Amambay' },
    { code: 'PY-ASU', name: 'Asuncion' },
    { code: 'PY-19', name: 'Boqueron' },
    { code: 'PY-5', name: 'Caaguazu' },
    { code: 'PY-6', name: 'Caazapa' },
    { code: 'PY-14', name: 'Canindeyu' },
    { code: 'PY-11', name: 'Central' },
    { code: 'PY-1', name: 'Concepcion' },
    { code: 'PY-3', name: 'Cordillera' },
    { code: 'PY-4', name: 'Guaira' },
    { code: 'PY-7', name: 'Itapua' },
    { code: 'PY-8', name: 'Misiones' },
    { code: 'PY-12', name: 'Neembucu' },
    { code: 'PY-9', name: 'Paraguari' },
    { code: 'PY-15', name: 'Presidente Hayes' },
    { code: 'PY-2', name: 'San Pedro' },
  ],
  PE: [
    { code: 'PE-AMA', name: 'Amazonas' },
    { code: 'PE-ANC', name: 'Ancash' },
    { code: 'PE-APU', name: 'Apurimac' },
    { code: 'PE-ARE', name: 'Arequipa' },
    { code: 'PE-AYA', name: 'Ayacucho' },
    { code: 'PE-CAJ', name: 'Cajamarca' },
    { code: 'PE-CAL', name: 'Callao' },
    { code: 'PE-CUS', name: 'Cusco' },
    { code: 'PE-HUV', name: 'Huancavelica' },
    { code: 'PE-HUC', name: 'Huanuco' },
    { code: 'PE-ICA', name: 'Ica' },
    { code: 'PE-JUN', name: 'Junin' },
    { code: 'PE-LAL', name: 'La Libertad' },
    { code: 'PE-LAM', name: 'Lambayeque' },
    { code: 'PE-LIM', name: 'Lima' },
    { code: 'PE-LOR', name: 'Loreto' },
    { code: 'PE-MDD', name: 'Madre de Dios' },
    { code: 'PE-MOQ', name: 'Moquegua' },
    { code: 'PE-PAS', name: 'Pasco' },
    { code: 'PE-PIU', name: 'Piura' },
    { code: 'PE-PUN', name: 'Puno' },
    { code: 'PE-SAM', name: 'San Martin' },
    { code: 'PE-TAC', name: 'Tacna' },
    { code: 'PE-TUM', name: 'Tumbes' },
    { code: 'PE-UCA', name: 'Ucayali' },
  ],
  PH: [
    { code: 'PH-ABR', name: 'Abra' },
    { code: 'PH-AGN', name: 'Agusan del Norte' },
    { code: 'PH-AGS', name: 'Agusan del Sur' },
    { code: 'PH-AKL', name: 'Aklan' },
    { code: 'PH-ALB', name: 'Albay' },
    { code: 'PH-ANT', name: 'Antique' },
    { code: 'PH-APA', name: 'Apayao' },
    { code: 'PH-AUR', name: 'Aurora' },
    { code: 'PH-BAS', name: 'Basilan' },
    { code: 'PH-BAN', name: 'Bataan' },
    { code: 'PH-BTN', name: 'Batanes' },
    { code: 'PH-BTG', name: 'Batangas' },
    { code: 'PH-BEN', name: 'Benguet' },
    { code: 'PH-05', name: 'Bicol' },
    { code: 'PH-BIL', name: 'Biliran' },
    { code: 'PH-BOH', name: 'Bohol' },
    { code: 'PH-BUK', name: 'Bukidnon' },
    { code: 'PH-BUL', name: 'Bulacan' },
    { code: 'PH-CAG', name: 'Cagayan' },
    { code: 'PH-02', name: 'Cagayan Valley' },
    { code: 'PH-40', name: 'Calabarzon' },
    { code: 'PH-CAN', name: 'Camarines Norte' },
    { code: 'PH-CAS', name: 'Camarines Sur' },
    { code: 'PH-CAM', name: 'Camiguin' },
    { code: 'PH-CAP', name: 'Capiz' },
    { code: 'PH-13', name: 'Caraga' },
    { code: 'PH-CAT', name: 'Catanduanes' },
    { code: 'PH-CAV', name: 'Cavite' },
    { code: 'PH-CEB', name: 'Cebu' },
    { code: 'PH-03', name: 'Central Luzon' },
    { code: 'PH-07', name: 'Central Visayas' },
    { code: 'PH-COM', name: 'Compostela Valley' },
    { code: 'PH-16', name: 'Cordillera' },
    { code: 'PH-NCO', name: 'Cotabato' },
    { code: 'PH-11', name: 'Davao' },
    { code: 'PH-DAV', name: 'Davao del Norte' },
    { code: 'PH-DAS', name: 'Davao del Sur' },
    { code: 'PH-DAO', name: 'Davao Oriental' },
    { code: 'PH-DIN', name: 'Dinagat Islands' },
    { code: 'PH-EAS', name: 'Eastern Samar' },
    { code: 'PH-08', name: 'Eastern Visayas' },
    { code: 'PH-GUI', name: 'Guimaras' },
    { code: 'PH-IFU', name: 'Ifugao' },
    { code: 'PH-01', name: 'Ilocos' },
    { code: 'PH-ILN', name: 'Ilocos Norte' },
    { code: 'PH-ILS', name: 'Ilocos Sur' },
    { code: 'PH-ILI', name: 'Iloilo' },
    { code: 'PH-ISA', name: 'Isabela' },
    { code: 'PH-KAL', name: 'Kalinga-Apayao' },
    { code: 'PH-LUN', name: 'La Union' },
    { code: 'PH-LAG', name: 'Laguna' },
    { code: 'PH-LAN', name: 'Lanao del Norte' },
    { code: 'PH-LAS', name: 'Lanao del Sur' },
    { code: 'PH-LEY', name: 'Leyte' },
    { code: 'PH-MAG', name: 'Maguindanao' },
    { code: 'PH-MAD', name: 'Marinduque' },
    { code: 'PH-MAS', name: 'Masbate' },
    { code: 'PH-41', name: 'Mimaropa' },
    { code: 'PH-MDC', name: 'Mindoro Occidental' },
    { code: 'PH-MDR', name: 'Mindoro Oriental' },
    { code: 'PH-MSC', name: 'Misamis Occidental' },
    { code: 'PH-MSR', name: 'Misamis Oriental' },
    { code: 'PH-MOU', name: 'Mountain' },
    { code: 'PH-14', name: 'Muslim Mindanao' },
    { code: 'PH-00', name: 'National Capital Region' },
    { code: 'PH-NEC', name: 'Negros Occidental' },
    { code: 'PH-NER', name: 'Negros Oriental' },
    { code: 'PH-10', name: 'Northern Mindanao' },
    { code: 'PH-NSA', name: 'Northern Samar' },
    { code: 'PH-NUE', name: 'Nueva Ecija' },
    { code: 'PH-NUV', name: 'Nueva Vizcaya' },
    { code: 'PH-PLW', name: 'Palawan' },
    { code: 'PH-PAM', name: 'Pampanga' },
    { code: 'PH-PAN', name: 'Pangasinan' },
    { code: 'PH-QUE', name: 'Quezon' },
    { code: 'PH-QUI', name: 'Quirino' },
    { code: 'PH-RIZ', name: 'Rizal' },
    { code: 'PH-ROM', name: 'Romblon' },
    { code: 'PH-WSA', name: 'Samar' },
    { code: 'PH-SAR', name: 'Sarangani' },
    { code: 'PH-SIG', name: 'Siquijor' },
    { code: 'PH-12', name: 'Soccsksargen' },
    { code: 'PH-SOR', name: 'Sorsogon' },
    { code: 'PH-SCO', name: 'South Cotabato' },
    { code: 'PH-SLE', name: 'Southern Leyte' },
    { code: 'PH-SUK', name: 'Sultan Kudarat' },
    { code: 'PH-SLU', name: 'Sulu' },
    { code: 'PH-SUN', name: 'Surigao del Norte' },
    { code: 'PH-SUR', name: 'Surigao del Sur' },
    { code: 'PH-TAR', name: 'Tarlac' },
    { code: 'PH-TAW', name: 'Tawitawi' },
    { code: 'PH-06', name: 'Western Visayas' },
    { code: 'PH-ZMB', name: 'Zambales' },
    { code: 'PH-ZAN', name: 'Zamboanga del Norte' },
    { code: 'PH-ZAS', name: 'Zamboanga del Sur' },
    { code: 'PH-09', name: 'Zamboanga Peninsula' },
    { code: 'PH-ZSI', name: 'Zamboanga Sibugay' },
  ],
  PL: [
    { code: 'PL-DS', name: 'Dolnoslaskie' },
    { code: 'PL-KP', name: 'Kujawsko-Pomorskie' },
    { code: 'PL-LD', name: 'Lodzkie' },
    { code: 'PL-LU', name: 'Lubelskie' },
    { code: 'PL-LB', name: 'Lubuskie' },
    { code: 'PL-MA', name: 'Malopolskie' },
    { code: 'PL-MZ', name: 'Mazowieckie' },
    { code: 'PL-OP', name: 'Opolskie' },
    { code: 'PL-PK', name: 'Podkarpackie' },
    { code: 'PL-PD', name: 'Podlaskie' },
    { code: 'PL-PM', name: 'Pomorskie' },
    { code: 'PL-SL', name: 'Slaskie' },
    { code: 'PL-SK', name: 'Swietokrzyskie' },
    { code: 'PL-WN', name: 'Warminsko-Mazurskie' },
    { code: 'PL-WP', name: 'Wielkopolskie' },
    { code: 'PL-ZP', name: 'Zachodniopomorskie' },
  ],
  PT: [
    { code: 'PT-01', name: 'Aveiro' },
    { code: 'PT-20', name: 'Azores' },
    { code: 'PT-02', name: 'Beja' },
    { code: 'PT-03', name: 'Braga' },
    { code: 'PT-04', name: 'Braganca' },
    { code: 'PT-05', name: 'Castelo Branco' },
    { code: 'PT-06', name: 'Coimbra' },
    { code: 'PT-07', name: 'Evora' },
    { code: 'PT-08', name: 'Faro' },
    { code: 'PT-09', name: 'Guarda' },
    { code: 'PT-10', name: 'Leiria' },
    { code: 'PT-11', name: 'Lisboa' },
    { code: 'PT-30', name: 'Madeira' },
    { code: 'PT-12', name: 'Portalegre' },
    { code: 'PT-13', name: 'Porto' },
    { code: 'PT-14', name: 'Santarem' },
    { code: 'PT-15', name: 'Setubal' },
    { code: 'PT-16', name: 'Viana do Castelo' },
    { code: 'PT-17', name: 'Vila Real' },
    { code: 'PT-18', name: 'Viseu' },
  ],
  QA: [
    { code: 'QA-DA', name: 'Ad Dawhah' },
    { code: 'QA-KH', name: 'Al Khawr' },
    { code: 'QA-WA', name: 'Al Wakrah' },
    { code: 'QA-RA', name: 'Ar Rayyan' },
    { code: 'QA-ZA', name: "Az Za'ayin" },
    { code: 'QA-MS', name: 'Madinat ach Shamal' },
    { code: 'QA-US', name: 'Umm Salal' },
  ],
  KR: [
    { code: 'KR-26', name: 'Busan-gwangyeoksi' },
    { code: 'KR-43', name: 'Chungcheongbuk-do' },
    { code: 'KR-44', name: 'Chungcheongnam-do' },
    { code: 'KR-27', name: 'Daegu-gwangyeoksi' },
    { code: 'KR-30', name: 'Daejeon-gwangyeoksi' },
    { code: 'KR-42', name: 'Gangwon-do' },
    { code: 'KR-29', name: 'Gwangju-gwangyeoksi' },
    { code: 'KR-41', name: 'Gyeonggi-do' },
    { code: 'KR-47', name: 'Gyeongsangbuk-do' },
    { code: 'KR-48', name: 'Gyeongsangnam-do' },
    { code: 'KR-28', name: 'Incheon-gwangyeoksi' },
    { code: 'KR-49', name: 'Jeju-teukbyeoljachido' },
    { code: 'KR-45', name: 'Jeollabuk-do' },
    { code: 'KR-46', name: 'Jeollanam-do' },
    { code: 'KR-11', name: 'Seoul-teukbyeolsi' },
    { code: 'KR-31', name: 'Ulsan-gwangyeoksi' },
  ],
  MD: [
    { code: 'MD-AN', name: 'Anenii Noi' },
    { code: 'MD-BA', name: 'Balti' },
    { code: 'MD-BS', name: 'Basarabeasca' },
    { code: 'MD-BR', name: 'Briceni' },
    { code: 'MD-CA', name: 'Cahul' },
    { code: 'MD-CL', name: 'Calarasi' },
    { code: 'MD-CT', name: 'Cantemir' },
    { code: 'MD-CS', name: 'Causeni' },
    { code: 'MD-CU', name: 'Chisinau' },
    { code: 'MD-CM', name: 'Cimislia' },
    { code: 'MD-CR', name: 'Criuleni' },
    { code: 'MD-DO', name: 'Donduseni' },
    { code: 'MD-DR', name: 'Drochia' },
    { code: 'MD-DU', name: 'Dubasari' },
    { code: 'MD-ED', name: 'Edinet' },
    { code: 'MD-FA', name: 'Falesti' },
    { code: 'MD-FL', name: 'Floresti' },
    { code: 'MD-GA', name: 'Gagauzia' },
    { code: 'MD-GL', name: 'Glodeni' },
    { code: 'MD-HI', name: 'Hincesti' },
    { code: 'MD-IA', name: 'Ialoveni' },
    { code: 'MD-LE', name: 'Leova' },
    { code: 'MD-NI', name: 'Nisporeni' },
    { code: 'MD-OC', name: 'Ocnita' },
    { code: 'MD-OR', name: 'Orhei' },
    { code: 'MD-RE', name: 'Rezina' },
    { code: 'MD-RI', name: 'Riscani' },
    { code: 'MD-SI', name: 'Singerei' },
    { code: 'MD-SD', name: 'Soldanesti' },
    { code: 'MD-SO', name: 'Soroca' },
    { code: 'MD-SV', name: 'Stefan-Voda' },
    { code: 'MD-SN', name: 'Stinga Nistrului' },
    { code: 'MD-ST', name: 'Straseni' },
    { code: 'MD-TA', name: 'Taraclia' },
    { code: 'MD-TE', name: 'Telenesti' },
    { code: 'MD-UN', name: 'Ungheni' },
  ],
  RO: [
    { code: 'RO-AB', name: 'Alba' },
    { code: 'RO-AR', name: 'Arad' },
    { code: 'RO-AG', name: 'Arges' },
    { code: 'RO-BC', name: 'Bacau' },
    { code: 'RO-BH', name: 'Bihor' },
    { code: 'RO-BN', name: 'Bistrita-Nasaud' },
    { code: 'RO-BT', name: 'Botosani' },
    { code: 'RO-BR', name: 'Braila' },
    { code: 'RO-BV', name: 'Brasov' },
    { code: 'RO-B', name: 'Bucuresti' },
    { code: 'RO-BZ', name: 'Buzau' },
    { code: 'RO-CL', name: 'Calarasi' },
    { code: 'RO-CS', name: 'Caras-Severin' },
    { code: 'RO-CJ', name: 'Cluj' },
    { code: 'RO-CT', name: 'Constanta' },
    { code: 'RO-CV', name: 'Covasna' },
    { code: 'RO-DB', name: 'Dambovita' },
    { code: 'RO-DJ', name: 'Dolj' },
    { code: 'RO-GL', name: 'Galati' },
    { code: 'RO-GR', name: 'Giurgiu' },
    { code: 'RO-GJ', name: 'Gorj' },
    { code: 'RO-HR', name: 'Harghita' },
    { code: 'RO-HD', name: 'Hunedoara' },
    { code: 'RO-IL', name: 'Ialomita' },
    { code: 'RO-IS', name: 'Iasi' },
    { code: 'RO-IF', name: 'Ilfov' },
    { code: 'RO-MM', name: 'Maramures' },
    { code: 'RO-MH', name: 'Mehedinti' },
    { code: 'RO-MS', name: 'Mures' },
    { code: 'RO-NT', name: 'Neamt' },
    { code: 'RO-OT', name: 'Olt' },
    { code: 'RO-PH', name: 'Prahova' },
    { code: 'RO-SJ', name: 'Salaj' },
    { code: 'RO-SM', name: 'Satu Mare' },
    { code: 'RO-SB', name: 'Sibiu' },
    { code: 'RO-SV', name: 'Suceava' },
    { code: 'RO-TR', name: 'Teleorman' },
    { code: 'RO-TM', name: 'Timis' },
    { code: 'RO-TL', name: 'Tulcea' },
    { code: 'RO-VL', name: 'Valcea' },
    { code: 'RO-VS', name: 'Vaslui' },
    { code: 'RO-VN', name: 'Vrancea' },
  ],
  RU: [
    { code: 'RU-AD', name: 'Adygeya' },
    { code: 'RU-ALT', name: 'Altaisky krai' },
    { code: 'RU-AMU', name: 'Amur' },
    { code: 'RU-ARK', name: 'Arkhangelsk' },
    { code: 'RU-AST', name: "Astrakhan'" },
    { code: 'RU-BA', name: 'Bashkortostan' },
    { code: 'RU-BEL', name: 'Belgorod' },
    { code: 'RU-BRY', name: 'Bryansk' },
    { code: 'RU-BU', name: 'Buryat' },
    { code: 'RU-CHE', name: 'Chelyabinskaya oblast' },
    { code: 'RU-CHU', name: 'Chukot' },
    { code: 'RU-CU', name: 'Chuvashia' },
    { code: 'RU-DA', name: 'Dagestan' },
    { code: 'RU-AL', name: 'Gorno-Altay' },
    { code: 'RU-IN', name: 'Ingush' },
    { code: 'RU-IRK', name: 'Irkutsk' },
    { code: 'RU-IVA', name: 'Ivanovo' },
    { code: 'RU-KB', name: 'Kabardin-Balkar' },
    { code: 'RU-KGD', name: 'Kaliningrad' },
    { code: 'RU-KL', name: 'Kalmyk' },
    { code: 'RU-KLU', name: 'Kaluga' },
    { code: 'RU-KAM', name: 'Kamchatskiy kray' },
    { code: 'RU-KC', name: 'Karachay-Cherkess' },
    { code: 'RU-KR', name: 'Karelia' },
    { code: 'RU-KEM', name: 'Kemerovo' },
    { code: 'RU-KHA', name: 'Khabarovsk' },
    { code: 'RU-KK', name: 'Khakass' },
    { code: 'RU-KHM', name: 'Khanty-Mansiy' },
    { code: 'RU-KIR', name: 'Kirov' },
    { code: 'RU-KO', name: 'Komi' },
    { code: 'RU-KOS', name: 'Kostroma' },
    { code: 'RU-KDA', name: 'Krasnodarskij Kraj' },
    { code: 'RU-KYA', name: 'Krasnojarskij Kraj' },
    { code: 'RU-KGN', name: 'Kurgan' },
    { code: 'RU-KRS', name: 'Kursk' },
    { code: 'RU-LEN', name: 'Leningrad' },
    { code: 'RU-LIP', name: 'Lipetsk' },
    { code: 'RU-MAG', name: 'Magadan' },
    { code: 'RU-ME', name: 'Mariy-El' },
    { code: 'RU-MO', name: 'Mordovia' },
    { code: 'RU-MOW', name: 'Moskva' },
    { code: 'RU-MOS', name: 'Moskva' },
    { code: 'RU-MUR', name: 'Murmansk' },
    { code: 'RU-NEN', name: 'Nenets' },
    { code: 'RU-NIZ', name: 'Nizhegorod' },
    { code: 'RU-NGR', name: 'Novgorod' },
    { code: 'RU-NVS', name: 'Novosibirsk' },
    { code: 'RU-OMS', name: 'Omsk' },
    { code: 'RU-ORL', name: 'Orel' },
    { code: 'RU-ORE', name: 'Orenburg' },
    { code: 'RU-PNZ', name: 'Penza' },
    { code: 'RU-PER', name: 'Permskiy Kray' },
    { code: 'RU-PRI', name: "Primor'ye" },
    { code: 'RU-PSK', name: 'Pskov' },
    { code: 'RU-ROS', name: 'Rostov' },
    { code: 'RU-RYA', name: "Ryazan'" },
    { code: 'RU-SPE', name: 'Saint Petersburg City' },
    { code: 'RU-SA', name: 'Sakha' },
    { code: 'RU-SAK', name: 'Sakhalin' },
    { code: 'RU-SAM', name: 'Samara' },
    { code: 'RU-SAR', name: 'Saratov' },
    { code: 'RU-SMO', name: 'Smolensk' },
    { code: 'RU-STA', name: "Stavropol'" },
    { code: 'RU-SVE', name: 'Sverdlovsk' },
    { code: 'RU-TAM', name: 'Tambovskaya oblast' },
    { code: 'RU-TA', name: 'Tatarstan' },
    { code: 'RU-TOM', name: 'Tomsk' },
    { code: 'RU-TUL', name: 'Tula' },
    { code: 'RU-TY', name: 'Tuva' },
    { code: 'RU-TVE', name: "Tver'" },
    { code: 'RU-TYU', name: "Tyumen'" },
    { code: 'RU-UD', name: 'Udmurt' },
    { code: 'RU-ULY', name: "Ul'yanovsk" },
    { code: 'RU-VLA', name: 'Vladimir' },
    { code: 'RU-VGG', name: 'Volgograd' },
    { code: 'RU-VLG', name: 'Vologda' },
    { code: 'RU-VOR', name: 'Voronezh' },
    { code: 'RU-YAN', name: 'Yamal-Nenets' },
    { code: 'RU-YAR', name: "Yaroslavl'" },
    { code: 'RU-YEV', name: 'Yevrey' },
    { code: 'RU-ZAB', name: 'Zabaykalsky' },
  ],
  RW: [
    { code: 'RW-02', name: 'Est' },
    { code: 'RW-01', name: 'Kigali' },
    { code: 'RW-03', name: 'Nord' },
    { code: 'RW-04', name: 'Ouest' },
    { code: 'RW-05', name: 'Sud' },
  ],
  SH: [
    { code: 'SH-AC', name: 'Ascension' },
    { code: 'SH-HL', name: 'Saint Helena' },
    { code: 'SH-TA', name: 'Tristan da Cunha' },
  ],
  KN: [
    { code: 'KN-03', name: 'Saint George Basseterre' },
    { code: 'KN-09', name: 'Saint Paul Charlestown' },
  ],
  LC: [
    { code: 'LC-01', name: 'Anse-la-Raye' },
    { code: 'LC-02', name: 'Castries' },
    { code: 'LC-05', name: 'Dennery' },
    { code: 'LC-06', name: 'Gros-Islet' },
    { code: 'LC-07', name: 'Laborie' },
    { code: 'LC-08', name: 'Micoud' },
    { code: 'LC-10', name: 'Soufriere' },
    { code: 'LC-11', name: 'Vieux-Fort' },
  ],
  VC: [
    { code: 'VC-01', name: 'Charlotte' },
    { code: 'VC-04', name: 'Saint George' },
  ],
  WS: [
    { code: 'WS-AA', name: "A'ana" },
    { code: 'WS-AT', name: 'Atua' },
    { code: 'WS-GI', name: 'Gagaifomauga' },
    { code: 'WS-PA', name: 'Palauli' },
    { code: 'WS-TU', name: 'Tuamasaga' },
  ],
  SM: [
    { code: 'SM-01', name: 'Acquaviva' },
    { code: 'SM-02', name: 'Chiesanuova' },
    { code: 'SM-07', name: 'San Marino' },
    { code: 'SM-09', name: 'Serravalle' },
  ],
  ST: [
    { code: 'ST-P', name: 'Principe' },
    { code: 'ST-S', name: 'Sao Tome' },
  ],
  SA: [
    { code: 'SA-11', name: 'Al Bahah' },
    { code: 'SA-08', name: 'Al Hudud ash Shamaliyah' },
    { code: 'SA-12', name: 'Al Jawf' },
    { code: 'SA-03', name: 'Al Madinah' },
    { code: 'SA-05', name: 'Al Qasim' },
    { code: 'SA-01', name: 'Ar Riyad' },
    { code: 'SA-04', name: 'Ash Sharqiyah' },
    { code: 'SA-14', name: 'Asir' },
    { code: 'SA-06', name: "Ha'il" },
    { code: 'SA-09', name: 'Jizan' },
    { code: 'SA-02', name: 'Makkah' },
    { code: 'SA-10', name: 'Najran' },
    { code: 'SA-07', name: 'Tabuk' },
  ],
  SN: [
    { code: 'SN-DK', name: 'Dakar' },
    { code: 'SN-DB', name: 'Diourbel' },
    { code: 'SN-FK', name: 'Fatick' },
    { code: 'SN-KA', name: 'Kaffrine' },
    { code: 'SN-KL', name: 'Kaolack' },
    { code: 'SN-KE', name: 'Kedougou' },
    { code: 'SN-KD', name: 'Kolda' },
    { code: 'SN-LG', name: 'Louga' },
    { code: 'SN-MT', name: 'Matam' },
    { code: 'SN-SL', name: 'Saint-Louis' },
    { code: 'SN-SE', name: 'Sedhiou' },
    { code: 'SN-TC', name: 'Tambacounda' },
    { code: 'SN-TH', name: 'Thies' },
    { code: 'SN-ZG', name: 'Ziguinchor' },
  ],
  RS: [
    { code: 'RS-00', name: 'Beograd' },
    { code: 'RS-14', name: 'Borski okrug' },
    { code: 'RS-11', name: 'Branicevski okrug' },
    { code: 'RS-23', name: 'Jablanicki okrug' },
    { code: 'RS-06', name: 'Juznobacki okrug' },
    { code: 'RS-04', name: 'Juznobanatski okrug' },
    { code: 'RS-09', name: 'Kolubarski okrug' },
    { code: 'RS-KM', name: 'Kosovo' },
    { code: 'RS-25', name: 'Kosovski okrug' },
    { code: 'RS-28', name: 'Kosovsko-Mitrovacki okrug' },
    { code: 'RS-29', name: 'Kosovsko-Pomoravski okrug' },
    { code: 'RS-08', name: 'Macvanski okrug' },
    { code: 'RS-17', name: 'Moravicki okrug' },
    { code: 'RS-20', name: 'Nisavski okrug' },
    { code: 'RS-24', name: 'Pcinjski okrug' },
    { code: 'RS-26', name: 'Pecki okrug' },
    { code: 'RS-22', name: 'Pirotski okrug' },
    { code: 'RS-10', name: 'Podunavski okrug' },
    { code: 'RS-13', name: 'Pomoravski okrug' },
    { code: 'RS-27', name: 'Prizrenski okrug' },
    { code: 'RS-19', name: 'Rasinski okrug' },
    { code: 'RS-18', name: 'Raski okrug' },
    { code: 'RS-01', name: 'Severnobacki okrug' },
    { code: 'RS-03', name: 'Severnobanatski okrug' },
    { code: 'RS-02', name: 'Srednjebanatski okrug' },
    { code: 'RS-07', name: 'Sremski okrug' },
    { code: 'RS-21', name: 'Toplicki okrug' },
    { code: 'RS-VO', name: 'Vojvodina' },
    { code: 'RS-15', name: 'Zajecarski okrug' },
  ],
  SC: [{ code: 'SC-16', name: 'English River' }],
  SG: [{ code: 'SG-01', name: 'Singapore' }],
  SK: [
    { code: 'SK-BC', name: 'Banska Bystrica' },
    { code: 'SK-BL', name: 'Bratislava' },
    { code: 'SK-KI', name: 'Kosice' },
    { code: 'SK-NI', name: 'Nitra' },
    { code: 'SK-PV', name: 'Presov' },
    { code: 'SK-TC', name: 'Trencin' },
    { code: 'SK-TA', name: 'Trnava' },
    { code: 'SK-ZI', name: 'Zilina' },
  ],
  SI: [
    { code: 'SI-001', name: 'Ajdovscina' },
    { code: 'SI-003', name: 'Bled' },
    { code: 'SI-004', name: 'Bohinj' },
    { code: 'SI-005', name: 'Borovnica' },
    { code: 'SI-006', name: 'Bovec' },
    { code: 'SI-009', name: 'Brezice' },
    { code: 'SI-008', name: 'Brezovica' },
    { code: 'SI-011', name: 'Celje' },
    { code: 'SI-013', name: 'Cerknica' },
    { code: 'SI-014', name: 'Cerkno' },
    { code: 'SI-015', name: 'Crensovci' },
    { code: 'SI-017', name: 'Crnomelj' },
    { code: 'SI-018', name: 'Destrnik' },
    { code: 'SI-019', name: 'Divaca' },
    { code: 'SI-023', name: 'Domzale' },
    { code: 'SI-025', name: 'Dravograd' },
    { code: 'SI-029', name: 'Gornja Radgona' },
    { code: 'SI-032', name: 'Grosuplje' },
    { code: 'SI-160', name: 'Hoce-Slivnica' },
    { code: 'SI-162', name: 'Horjul' },
    { code: 'SI-034', name: 'Hrastnik' },
    { code: 'SI-036', name: 'Idrija' },
    { code: 'SI-037', name: 'Ig' },
    { code: 'SI-038', name: 'Ilirska Bistrica' },
    { code: 'SI-039', name: 'Ivancna Gorica' },
    { code: 'SI-040', name: 'Izola-Isola' },
    { code: 'SI-041', name: 'Jesenice' },
    { code: 'SI-043', name: 'Kamnik' },
    { code: 'SI-044', name: 'Kanal' },
    { code: 'SI-045', name: 'Kidricevo' },
    { code: 'SI-046', name: 'Kobarid' },
    { code: 'SI-048', name: 'Kocevje' },
    { code: 'SI-050', name: 'Koper-Capodistria' },
    { code: 'SI-052', name: 'Kranj' },
    { code: 'SI-053', name: 'Kranjska Gora' },
    { code: 'SI-054', name: 'Krsko' },
    { code: 'SI-057', name: 'Lasko' },
    { code: 'SI-058', name: 'Lenart' },
    { code: 'SI-059', name: 'Lendava' },
    { code: 'SI-060', name: 'Litija' },
    { code: 'SI-061', name: 'Ljubljana' },
    { code: 'SI-063', name: 'Ljutomer' },
    { code: 'SI-208', name: 'Log-Dragomer' },
    { code: 'SI-064', name: 'Logatec' },
    { code: 'SI-167', name: 'Lovrenc na Pohorju' },
    { code: 'SI-070', name: 'Maribor' },
    { code: 'SI-071', name: 'Medvode' },
    { code: 'SI-072', name: 'Menges' },
    { code: 'SI-073', name: 'Metlika' },
    { code: 'SI-074', name: 'Mezica' },
    { code: 'SI-169', name: 'Miklavz na Dravskem Polju' },
    { code: 'SI-075', name: 'Miren-Kostanjevica' },
    { code: 'SI-076', name: 'Mislinja' },
    { code: 'SI-079', name: 'Mozirje' },
    { code: 'SI-080', name: 'Murska Sobota' },
    { code: 'SI-081', name: 'Muta' },
    { code: 'SI-084', name: 'Nova Gorica' },
    { code: 'SI-085', name: 'Novo Mesto' },
    { code: 'SI-086', name: 'Odranci' },
    { code: 'SI-171', name: 'Oplotnica' },
    { code: 'SI-087', name: 'Ormoz' },
    { code: 'SI-090', name: 'Piran' },
    { code: 'SI-091', name: 'Pivka' },
    { code: 'SI-200', name: 'Poljcane' },
    { code: 'SI-173', name: 'Polzela' },
    { code: 'SI-094', name: 'Postojna' },
    { code: 'SI-174', name: 'Prebold' },
    { code: 'SI-175', name: 'Prevalje' },
    { code: 'SI-096', name: 'Ptuj' },
    { code: 'SI-098', name: 'Racam' },
    { code: 'SI-099', name: 'Radece' },
    { code: 'SI-100', name: 'Radenci' },
    { code: 'SI-101', name: 'Radlje ob Dravi' },
    { code: 'SI-102', name: 'Radovljica' },
    { code: 'SI-103', name: 'Ravne na Koroskem' },
    { code: 'SI-104', name: 'Ribnica' },
    { code: 'SI-106', name: 'Rogaska Slatina' },
    { code: 'SI-108', name: 'Ruse' },
    { code: 'SI-183', name: 'Sempeter-Vrtojba' },
    { code: 'SI-117', name: 'Sencur' },
    { code: 'SI-118', name: 'Sentilj' },
    { code: 'SI-120', name: 'Sentjur pri Celju' },
    { code: 'SI-110', name: 'Sevnica' },
    { code: 'SI-111', name: 'Sezana' },
    { code: 'SI-122', name: 'Skofja Loka' },
    { code: 'SI-123', name: 'Skofljica' },
    { code: 'SI-112', name: 'Slovenj Gradec' },
    { code: 'SI-113', name: 'Slovenska Bistrica' },
    { code: 'SI-114', name: 'Slovenske Konjice' },
    { code: 'SI-126', name: 'Sostanj' },
    { code: 'SI-127', name: 'Store' },
    { code: 'SI-203', name: 'Straza' },
    { code: 'SI-128', name: 'Tolmin' },
    { code: 'SI-129', name: 'Trbovlje' },
    { code: 'SI-130', name: 'Trebnje' },
    { code: 'SI-131', name: 'Trzic' },
    { code: 'SI-186', name: 'Trzin' },
    { code: 'SI-132', name: 'Turnisce' },
    { code: 'SI-133', name: 'Velenje' },
    { code: 'SI-136', name: 'Vipava' },
    { code: 'SI-138', name: 'Vodice' },
    { code: 'SI-139', name: 'Vojnik' },
    { code: 'SI-140', name: 'Vrhnika' },
    { code: 'SI-141', name: 'Vuzenica' },
    { code: 'SI-142', name: 'Zagorje ob Savi' },
    { code: 'SI-190', name: 'Zalec' },
    { code: 'SI-146', name: 'Zelezniki' },
    { code: 'SI-147', name: 'Ziri' },
    { code: 'SI-144', name: 'Zrece' },
    { code: 'SI-193', name: 'Zuzemberk' },
  ],
  SB: [
    { code: 'SB-CE', name: 'Central' },
    { code: 'SB-GU', name: 'Guadalcanal' },
    { code: 'SB-IS', name: 'Isabel' },
    { code: 'SB-MK', name: 'Makira' },
    { code: 'SB-ML', name: 'Malaita' },
    { code: 'SB-WE', name: 'Western' },
  ],
  SO: [
    { code: 'SO-AW', name: 'Awdal' },
    { code: 'SO-BK', name: 'Bakool' },
    { code: 'SO-BN', name: 'Banaadir' },
    { code: 'SO-BR', name: 'Bari' },
    { code: 'SO-BY', name: 'Bay' },
    { code: 'SO-GA', name: 'Galguduud' },
    { code: 'SO-GE', name: 'Gedo' },
    { code: 'SO-HI', name: 'Hiiraan' },
    { code: 'SO-JD', name: 'Jubbada Dhexe' },
    { code: 'SO-JH', name: 'Jubbada Hoose' },
    { code: 'SO-MU', name: 'Mudug' },
    { code: 'SO-NU', name: 'Nugaal' },
    { code: 'SO-SA', name: 'Sanaag' },
    { code: 'SO-SD', name: 'Shabeellaha Dhexe' },
    { code: 'SO-SH', name: 'Shabeellaha Hoose' },
    { code: 'SO-SO', name: 'Sool' },
    { code: 'SO-TO', name: 'Togdheer' },
    { code: 'SO-WO', name: 'Woqooyi Galbeed' },
  ],
  ZA: [
    { code: 'ZA-EC', name: 'Eastern Cape' },
    { code: 'ZA-FS', name: 'Free State' },
    { code: 'ZA-GT', name: 'Gauteng' },
    { code: 'ZA-NL', name: 'KwaZulu-Natal' },
    { code: 'ZA-LP', name: 'Limpopo' },
    { code: 'ZA-MP', name: 'Mpumalanga' },
    { code: 'ZA-NW', name: 'North-West' },
    { code: 'ZA-NC', name: 'Northern Cape' },
    { code: 'ZA-WC', name: 'Western Cape' },
  ],
  ES: [
    { code: 'ES-AN', name: 'Andalucia' },
    { code: 'ES-AR', name: 'Aragon' },
    { code: 'ES-AS', name: 'Asturias' },
    { code: 'ES-CN', name: 'Canarias' },
    { code: 'ES-CB', name: 'Cantabria' },
    { code: 'ES-CL', name: 'Castilla y Leon' },
    { code: 'ES-CM', name: 'Castilla-La Mancha' },
    { code: 'ES-CT', name: 'Catalonia' },
    { code: 'ES-CE', name: 'Ceuta' },
    { code: 'ES-VC', name: 'Comunidad Valenciana' },
    { code: 'ES-EX', name: 'Extremadura' },
    { code: 'ES-GA', name: 'Galicia' },
    { code: 'ES-IB', name: 'Islas Baleares' },
    { code: 'ES-RI', name: 'La Rioja' },
    { code: 'ES-MD', name: 'Madrid' },
    { code: 'ES-ML', name: 'Melilla' },
    { code: 'ES-MC', name: 'Murcia' },
    { code: 'ES-NC', name: 'Navarra' },
    { code: 'ES-PV', name: 'Pais Vasco' },
  ],
  LK: [
    { code: 'LK-9', name: 'Sabaragamuwa' },
    { code: 'LK-8', name: 'Uva' },
  ],
  SR: [
    { code: 'SR-BR', name: 'Brokopondo' },
    { code: 'SR-CM', name: 'Commewijne' },
    { code: 'SR-CR', name: 'Coronie' },
    { code: 'SR-MA', name: 'Marowijne' },
    { code: 'SR-NI', name: 'Nickerie' },
    { code: 'SR-PR', name: 'Para' },
    { code: 'SR-PM', name: 'Paramaribo' },
    { code: 'SR-SA', name: 'Saramacca' },
    { code: 'SR-WA', name: 'Wanica' },
  ],
  SZ: [
    { code: 'SZ-HH', name: 'Hhohho' },
    { code: 'SZ-LU', name: 'Lubombo' },
    { code: 'SZ-MA', name: 'Manzini' },
    { code: 'SZ-SH', name: 'Shiselweni' },
  ],
  SE: [
    { code: 'SE-K', name: 'Blekinge Lan' },
    { code: 'SE-W', name: 'Dalarnas Lan' },
    { code: 'SE-X', name: 'Gavleborgs Lan' },
    { code: 'SE-I', name: 'Gotlands Lan' },
    { code: 'SE-N', name: 'Hallands Lan' },
    { code: 'SE-Z', name: 'Jamtlands Lan' },
    { code: 'SE-F', name: 'Jonkopings Lan' },
    { code: 'SE-H', name: 'Kalmar Lan' },
    { code: 'SE-G', name: 'Kronobergs Lan' },
    { code: 'SE-BD', name: 'Norrbottens Lan' },
    { code: 'SE-T', name: 'Orebro Lan' },
    { code: 'SE-E', name: 'Ostergotlands Lan' },
    { code: 'SE-M', name: 'Skane Lan' },
    { code: 'SE-D', name: 'Sodermanlands Lan' },
    { code: 'SE-AB', name: 'Stockholms Lan' },
    { code: 'SE-C', name: 'Uppsala Lan' },
    { code: 'SE-S', name: 'Varmlands Lan' },
    { code: 'SE-AC', name: 'Vasterbottens Lan' },
    { code: 'SE-Y', name: 'Vasternorrlands Lan' },
    { code: 'SE-U', name: 'Vastmanlands Lan' },
    { code: 'SE-O', name: 'Vastra Gotaland' },
  ],
  CH: [
    { code: 'CH-AG', name: 'Aargau' },
    { code: 'CH-AR', name: 'Ausser-Rhoden' },
    { code: 'CH-BL', name: 'Basel-Landschaft' },
    { code: 'CH-BS', name: 'Basel-Stadt' },
    { code: 'CH-BE', name: 'Bern' },
    { code: 'CH-FR', name: 'Fribourg' },
    { code: 'CH-GE', name: 'Geneve' },
    { code: 'CH-GL', name: 'Glarus' },
    { code: 'CH-GR', name: 'Graubunden' },
    { code: 'CH-AI', name: 'Inner-Rhoden' },
    { code: 'CH-JU', name: 'Jura' },
    { code: 'CH-LU', name: 'Luzern' },
    { code: 'CH-NE', name: 'Neuchatel' },
    { code: 'CH-NW', name: 'Nidwalden' },
    { code: 'CH-OW', name: 'Obwalden' },
    { code: 'CH-SG', name: 'Sankt Gallen' },
    { code: 'CH-SH', name: 'Schaffhausen' },
    { code: 'CH-SZ', name: 'Schwyz' },
    { code: 'CH-SO', name: 'Solothurn' },
    { code: 'CH-TG', name: 'Thurgau' },
    { code: 'CH-TI', name: 'Ticino' },
    { code: 'CH-UR', name: 'Uri' },
    { code: 'CH-VS', name: 'Valais' },
    { code: 'CH-VD', name: 'Vaud' },
    { code: 'CH-ZG', name: 'Zug' },
    { code: 'CH-ZH', name: 'Zurich' },
  ],
  TW: [
    { code: 'TW-CHA', name: 'ChangHua County' },
    { code: 'TW-CYI', name: 'ChiaYi City' },
    { code: 'TW-CYQ', name: 'ChiaYi County' },
    { code: 'TW-HSZ', name: 'HsinChu City' },
    { code: 'TW-HSQ', name: 'HsinChu County' },
    { code: 'TW-HUA', name: 'HuaLien County' },
    { code: 'TW-ILA', name: 'ILan County' },
    { code: 'TW-KHH', name: 'KaoHsiung City' },
    { code: 'TW-KEE', name: 'KeeLung City' },
    { code: 'TW-KIN', name: 'KinMen County' },
    { code: 'TW-LIE', name: 'LienChiang County' },
    { code: 'TW-MIA', name: 'MiaoLi County' },
    { code: 'TW-NAN', name: 'NanTou County' },
    { code: 'TW-NWT', name: 'New Taipei City' },
    { code: 'TW-PEN', name: 'PengHu County' },
    { code: 'TW-PIF', name: 'PingTung County' },
    { code: 'TW-TXG', name: 'TaiChung City' },
    { code: 'TW-TNN', name: 'TaiNan City' },
    { code: 'TW-TPE', name: 'Taipei City' },
    { code: 'TW-TTT', name: 'TaiTung County' },
    { code: 'TW-TAO', name: 'TaoYuan City' },
    { code: 'TW-YUN', name: 'YunLin County' },
  ],
  TJ: [
    { code: 'TJ-KT', name: 'Khatlon' },
    { code: 'TJ-GB', name: 'Kuhistoni Badakhshon' },
    { code: 'TJ-SU', name: 'Sughd' },
  ],
  TH: [
    { code: 'TH-37', name: 'Amnat Charoen' },
    { code: 'TH-15', name: 'Ang Thong' },
    { code: 'TH-10', name: 'Bangkok' },
    { code: 'TH-31', name: 'Buriram' },
    { code: 'TH-24', name: 'Chachoengsao' },
    { code: 'TH-18', name: 'Chai Nat' },
    { code: 'TH-36', name: 'Chaiyaphum' },
    { code: 'TH-22', name: 'Chanthaburi' },
    { code: 'TH-50', name: 'Chiang Mai' },
    { code: 'TH-57', name: 'Chiang Rai' },
    { code: 'TH-20', name: 'Chon Buri' },
    { code: 'TH-86', name: 'Chumphon' },
    { code: 'TH-46', name: 'Kalasin' },
    { code: 'TH-62', name: 'Kamphaeng Phet' },
    { code: 'TH-71', name: 'Kanchanaburi' },
    { code: 'TH-40', name: 'Khon Kaen' },
    { code: 'TH-81', name: 'Krabi' },
    { code: 'TH-52', name: 'Lampang' },
    { code: 'TH-51', name: 'Lamphun' },
    { code: 'TH-42', name: 'Loei' },
    { code: 'TH-16', name: 'Lop Buri' },
    { code: 'TH-58', name: 'Mae Hong Son' },
    { code: 'TH-44', name: 'Maha Sarakham' },
    { code: 'TH-49', name: 'Mukdahan' },
    { code: 'TH-26', name: 'Nakhon Nayok' },
    { code: 'TH-73', name: 'Nakhon Pathom' },
    { code: 'TH-48', name: 'Nakhon Phanom' },
    { code: 'TH-30', name: 'Nakhon Ratchasima' },
    { code: 'TH-60', name: 'Nakhon Sawan' },
    { code: 'TH-80', name: 'Nakhon Si Thammarat' },
    { code: 'TH-55', name: 'Nan' },
    { code: 'TH-96', name: 'Narathiwat' },
    { code: 'TH-39', name: 'Nong Bua Lamphu' },
    { code: 'TH-43', name: 'Nong Khai' },
    { code: 'TH-12', name: 'Nonthaburi' },
    { code: 'TH-13', name: 'Pathum Thani' },
    { code: 'TH-94', name: 'Pattani' },
    { code: 'TH-82', name: 'Phangnga' },
    { code: 'TH-93', name: 'Phatthalung' },
    { code: 'TH-56', name: 'Phayao' },
    { code: 'TH-67', name: 'Phetchabun' },
    { code: 'TH-76', name: 'Phetchaburi' },
    { code: 'TH-66', name: 'Phichit' },
    { code: 'TH-65', name: 'Phitsanulok' },
    { code: 'TH-14', name: 'Phra Nakhon Si Ayutthaya' },
    { code: 'TH-54', name: 'Phrae' },
    { code: 'TH-83', name: 'Phuket' },
    { code: 'TH-25', name: 'Prachin Buri' },
    { code: 'TH-77', name: 'Prachuap Khiri Khan' },
    { code: 'TH-85', name: 'Ranong' },
    { code: 'TH-70', name: 'Ratchaburi' },
    { code: 'TH-21', name: 'Rayong' },
    { code: 'TH-45', name: 'Roi Et' },
    { code: 'TH-27', name: 'Sa Kaeo' },
    { code: 'TH-47', name: 'Sakon Nakhon' },
    { code: 'TH-11', name: 'Samut Prakan' },
    { code: 'TH-74', name: 'Samut Sakhon' },
    { code: 'TH-75', name: 'Samut Songkhram' },
    { code: 'TH-19', name: 'Saraburi' },
    { code: 'TH-91', name: 'Satun' },
    { code: 'TH-17', name: 'Sing Buri' },
    { code: 'TH-33', name: 'Sisaket' },
    { code: 'TH-90', name: 'Songkhla' },
    { code: 'TH-64', name: 'Sukhothai' },
    { code: 'TH-72', name: 'Suphan Buri' },
    { code: 'TH-84', name: 'Surat Thani' },
    { code: 'TH-32', name: 'Surin' },
    { code: 'TH-63', name: 'Tak' },
    { code: 'TH-92', name: 'Trang' },
    { code: 'TH-23', name: 'Trat' },
    { code: 'TH-34', name: 'Ubon Ratchathani' },
    { code: 'TH-41', name: 'Udon Thani' },
    { code: 'TH-61', name: 'Uthai Thani' },
    { code: 'TH-53', name: 'Uttaradit' },
    { code: 'TH-95', name: 'Yala' },
    { code: 'TH-35', name: 'Yasothon' },
  ],
  MK: [
    { code: 'MK-02', name: 'Aracinovo' },
    { code: 'MK-03', name: 'Berovo' },
    { code: 'MK-04', name: 'Bitola' },
    { code: 'MK-05', name: 'Bogdanci' },
    { code: 'MK-06', name: 'Bogovinje' },
    { code: 'MK-07', name: 'Bosilovo' },
    { code: 'MK-08', name: 'Brvenica' },
    { code: 'MK-80', name: 'Caska' },
    { code: 'MK-77', name: 'Centar' },
    { code: 'MK-78', name: 'Centar Zupa' },
    { code: 'MK-81', name: 'Cesinovo' },
    { code: 'MK-82', name: 'Cucer-Sandevo' },
    { code: 'MK-21', name: 'Debar' },
    { code: 'MK-23', name: 'Delcevo' },
    { code: 'MK-25', name: 'Demir Hisar' },
    { code: 'MK-24', name: 'Demir Kapija' },
    { code: 'MK-27', name: 'Dolneni' },
    { code: 'MK-28', name: 'Drugovo' },
    { code: 'MK-17', name: 'Gazi Baba' },
    { code: 'MK-18', name: 'Gevgelija' },
    { code: 'MK-19', name: 'Gostivar' },
    { code: 'MK-20', name: 'Gradsko' },
    { code: 'MK-34', name: 'Ilinden' },
    { code: 'MK-35', name: 'Jegunovce' },
    { code: 'MK-37', name: 'Karbinci' },
    { code: 'MK-38', name: 'Karpos' },
    { code: 'MK-36', name: 'Kavadarci' },
    { code: 'MK-40', name: 'Kicevo' },
    { code: 'MK-39', name: 'Kisela Voda' },
    { code: 'MK-42', name: 'Kocani' },
    { code: 'MK-41', name: 'Konce' },
    { code: 'MK-43', name: 'Kratovo' },
    { code: 'MK-44', name: 'Kriva Palanka' },
    { code: 'MK-45', name: 'Krivogastani' },
    { code: 'MK-46', name: 'Krusevo' },
    { code: 'MK-47', name: 'Kumanovo' },
    { code: 'MK-48', name: 'Lipkovo' },
    { code: 'MK-49', name: 'Lozovo' },
    { code: 'MK-51', name: 'Makedonska Kamenica' },
    { code: 'MK-52', name: 'Makedonski Brod' },
    { code: 'MK-53', name: 'Mogila' },
    { code: 'MK-54', name: 'Negotino' },
    { code: 'MK-55', name: 'Novaci' },
    { code: 'MK-56', name: 'Novo Selo' },
    { code: 'MK-58', name: 'Ohrid' },
    { code: 'MK-57', name: 'Oslomej' },
    { code: 'MK-60', name: 'Pehcevo' },
    { code: 'MK-59', name: 'Petrovec' },
    { code: 'MK-61', name: 'Plasnica' },
    { code: 'MK-62', name: 'Prilep' },
    { code: 'MK-63', name: 'Probistip' },
    { code: 'MK-64', name: 'Radovis' },
    { code: 'MK-65', name: 'Rankovce' },
    { code: 'MK-66', name: 'Resen' },
    { code: 'MK-67', name: 'Rosoman' },
    { code: 'MK-68', name: 'Saraj' },
    { code: 'MK-70', name: 'Sopiste' },
    { code: 'MK-71', name: 'Staro Nagoricane' },
    { code: 'MK-83', name: 'Stip' },
    { code: 'MK-72', name: 'Struga' },
    { code: 'MK-73', name: 'Strumica' },
    { code: 'MK-74', name: 'Studenicani' },
    { code: 'MK-84', name: 'Suto Orizari' },
    { code: 'MK-69', name: 'Sveti Nikole' },
    { code: 'MK-75', name: 'Tearce' },
    { code: 'MK-76', name: 'Tetovo' },
    { code: 'MK-10', name: 'Valandovo' },
    { code: 'MK-11', name: 'Vasilevo' },
    { code: 'MK-13', name: 'Veles' },
    { code: 'MK-12', name: 'Vevcani' },
    { code: 'MK-14', name: 'Vinica' },
    { code: 'MK-15', name: 'Vranestica' },
    { code: 'MK-16', name: 'Vrapciste' },
    { code: 'MK-31', name: 'Zajas' },
    { code: 'MK-32', name: 'Zelenikovo' },
    { code: 'MK-30', name: 'Zelino' },
    { code: 'MK-33', name: 'Zrnovci' },
  ],
  TG: [
    { code: 'TG-C', name: 'Centrale' },
    { code: 'TG-K', name: 'Kara' },
    { code: 'TG-M', name: 'Maritime' },
    { code: 'TG-P', name: 'Plateaux' },
    { code: 'TG-S', name: 'Savanes' },
  ],
  TO: [
    { code: 'TO-02', name: 'Ha' },
    { code: 'TO-04', name: 'Tongatapu' },
    { code: 'TO-05', name: 'Vava' },
  ],
  TT: [
    { code: 'TT-ARI', name: 'Arima' },
    { code: 'TT-RCM', name: 'Mayaro' },
    { code: 'TT-POS', name: 'Port-of-Spain' },
    { code: 'TT-SFO', name: 'San Fernando' },
    { code: 'TT-WTO', name: 'Tobago' },
  ],
  TN: [
    { code: 'TN-12', name: 'Aiana' },
    { code: 'TN-53', name: 'Al Mahdia' },
    { code: 'TN-52', name: 'Al Munastir' },
    { code: 'TN-31', name: 'Bajah' },
    { code: 'TN-13', name: 'Ben Arous' },
    { code: 'TN-23', name: 'Bizerte' },
    { code: 'TN-33', name: 'El Kef' },
    { code: 'TN-81', name: 'Gabes' },
    { code: 'TN-71', name: 'Gafsa' },
    { code: 'TN-32', name: 'Jendouba' },
    { code: 'TN-41', name: 'Kairouan' },
    { code: 'TN-42', name: 'Kasserine' },
    { code: 'TN-73', name: 'Kebili' },
    { code: 'TN-82', name: 'Madanin' },
    { code: 'TN-14', name: 'Manouba' },
    { code: 'TN-21', name: 'Nabeul' },
    { code: 'TN-61', name: 'Sfax' },
    { code: 'TN-43', name: 'Sidi Bou Zid' },
    { code: 'TN-34', name: 'Siliana' },
    { code: 'TN-51', name: 'Sousse' },
    { code: 'TN-83', name: 'Tataouine' },
    { code: 'TN-72', name: 'Tozeur' },
    { code: 'TN-11', name: 'Tunis' },
    { code: 'TN-22', name: 'Zaghouan' },
  ],
  TR: [
    { code: 'TR-01', name: 'Adana' },
    { code: 'TR-02', name: 'Adiyaman' },
    { code: 'TR-03', name: 'Afyonkarahisar' },
    { code: 'TR-04', name: 'Agri' },
    { code: 'TR-68', name: 'Aksaray' },
    { code: 'TR-05', name: 'Amasya' },
    { code: 'TR-06', name: 'Ankara' },
    { code: 'TR-07', name: 'Antalya' },
    { code: 'TR-75', name: 'Ardahan' },
    { code: 'TR-08', name: 'Artvin' },
    { code: 'TR-09', name: 'Aydin' },
    { code: 'TR-10', name: 'Balikesir' },
    { code: 'TR-74', name: 'Bartin' },
    { code: 'TR-72', name: 'Batman' },
    { code: 'TR-69', name: 'Bayburt' },
    { code: 'TR-11', name: 'Bilecik' },
    { code: 'TR-12', name: 'Bingol' },
    { code: 'TR-13', name: 'Bitlis' },
    { code: 'TR-14', name: 'Bolu' },
    { code: 'TR-15', name: 'Burdur' },
    { code: 'TR-16', name: 'Bursa' },
    { code: 'TR-17', name: 'Canakkale' },
    { code: 'TR-18', name: 'Cankiri' },
    { code: 'TR-19', name: 'Corum' },
    { code: 'TR-20', name: 'Denizli' },
    { code: 'TR-21', name: 'Diyarbakir' },
    { code: 'TR-81', name: 'Duzce' },
    { code: 'TR-22', name: 'Edirne' },
    { code: 'TR-23', name: 'Elazig' },
    { code: 'TR-24', name: 'Erzincan' },
    { code: 'TR-25', name: 'Erzurum' },
    { code: 'TR-26', name: 'Eskisehir' },
    { code: 'TR-27', name: 'Gaziantep' },
    { code: 'TR-28', name: 'Giresun' },
    { code: 'TR-29', name: 'Gumushane' },
    { code: 'TR-30', name: 'Hakkari' },
    { code: 'TR-31', name: 'Hatay' },
    { code: 'TR-76', name: 'Igdir' },
    { code: 'TR-32', name: 'Isparta' },
    { code: 'TR-34', name: 'Istanbul' },
    { code: 'TR-35', name: 'Izmir' },
    { code: 'TR-46', name: 'Kahramanmaras' },
    { code: 'TR-78', name: 'Karabuk' },
    { code: 'TR-70', name: 'Karaman' },
    { code: 'TR-36', name: 'Kars' },
    { code: 'TR-37', name: 'Kastamonu' },
    { code: 'TR-38', name: 'Kayseri' },
    { code: 'TR-79', name: 'Kilis' },
    { code: 'TR-71', name: 'Kirikkale' },
    { code: 'TR-39', name: 'Kirklareli' },
    { code: 'TR-40', name: 'Kirsehir' },
    { code: 'TR-41', name: 'Kocaeli' },
    { code: 'TR-42', name: 'Konya' },
    { code: 'TR-43', name: 'Kutahya' },
    { code: 'TR-44', name: 'Malatya' },
    { code: 'TR-45', name: 'Manisa' },
    { code: 'TR-47', name: 'Mardin' },
    { code: 'TR-33', name: 'Mersin' },
    { code: 'TR-48', name: 'Mugla' },
    { code: 'TR-49', name: 'Mus' },
    { code: 'TR-50', name: 'Nevsehir' },
    { code: 'TR-51', name: 'Nigde' },
    { code: 'TR-52', name: 'Ordu' },
    { code: 'TR-80', name: 'Osmaniye' },
    { code: 'TR-53', name: 'Rize' },
    { code: 'TR-54', name: 'Sakarya' },
    { code: 'TR-55', name: 'Samsun' },
    { code: 'TR-63', name: 'Sanliurfa' },
    { code: 'TR-56', name: 'Siirt' },
    { code: 'TR-57', name: 'Sinop' },
    { code: 'TR-73', name: 'Sirnak' },
    { code: 'TR-58', name: 'Sivas' },
    { code: 'TR-59', name: 'Tekirdag' },
    { code: 'TR-60', name: 'Tokat' },
    { code: 'TR-61', name: 'Trabzon' },
    { code: 'TR-62', name: 'Tunceli' },
    { code: 'TR-64', name: 'Usak' },
    { code: 'TR-65', name: 'Van' },
    { code: 'TR-77', name: 'Yalova' },
    { code: 'TR-66', name: 'Yozgat' },
    { code: 'TR-67', name: 'Zonguldak' },
  ],
  TM: [
    { code: 'TM-A', name: 'Ahal' },
    { code: 'TM-B', name: 'Balkan' },
    { code: 'TM-D', name: 'Dashoguz' },
    { code: 'TM-L', name: 'Lebap' },
    { code: 'TM-M', name: 'Mary' },
  ],
  UG: [
    { code: 'UG-317', name: 'Abim' },
    { code: 'UG-301', name: 'Adjumani' },
    { code: 'UG-314', name: 'Amolatar' },
    { code: 'UG-216', name: 'Amuria' },
    { code: 'UG-319', name: 'Amuru' },
    { code: 'UG-302', name: 'Apac' },
    { code: 'UG-303', name: 'Arua' },
    { code: 'UG-217', name: 'Budaka' },
    { code: 'UG-223', name: 'Bududa' },
    { code: 'UG-201', name: 'Bugiri' },
    { code: 'UG-224', name: 'Bukedea' },
    { code: 'UG-218', name: 'Bukwa' },
    { code: 'UG-419', name: 'Bulisa' },
    { code: 'UG-401', name: 'Bundibugyo' },
    { code: 'UG-402', name: 'Bushenyi' },
    { code: 'UG-202', name: 'Busia' },
    { code: 'UG-219', name: 'Butaleja' },
    { code: 'UG-318', name: 'Dokolo' },
    { code: 'UG-304', name: 'Gulu' },
    { code: 'UG-403', name: 'Hoima' },
    { code: 'UG-203', name: 'Iganga' },
    { code: 'UG-417', name: 'Isingiro' },
    { code: 'UG-204', name: 'Jinja' },
    { code: 'UG-315', name: 'Kaabong' },
    { code: 'UG-404', name: 'Kabale' },
    { code: 'UG-405', name: 'Kabarole' },
    { code: 'UG-213', name: 'Kaberamaido' },
    { code: 'UG-101', name: 'Kalangala' },
    { code: 'UG-220', name: 'Kaliro' },
    { code: 'UG-102', name: 'Kampala' },
    { code: 'UG-205', name: 'Kamuli' },
    { code: 'UG-413', name: 'Kamwenge' },
    { code: 'UG-414', name: 'Kanungu' },
    { code: 'UG-206', name: 'Kapchorwa' },
    { code: 'UG-406', name: 'Kasese' },
    { code: 'UG-207', name: 'Katakwi' },
    { code: 'UG-112', name: 'Kayunga' },
    { code: 'UG-407', name: 'Kibale' },
    { code: 'UG-103', name: 'Kiboga' },
    { code: 'UG-408', name: 'Kisoro' },
    { code: 'UG-305', name: 'Kitgum' },
    { code: 'UG-316', name: 'Koboko' },
    { code: 'UG-306', name: 'Kotido' },
    { code: 'UG-208', name: 'Kumi' },
    { code: 'UG-415', name: 'Kyenjojo' },
    { code: 'UG-307', name: 'Lira' },
    { code: 'UG-104', name: 'Luwero' },
    { code: 'UG-116', name: 'Lyantonde' },
    { code: 'UG-221', name: 'Manafwa' },
    { code: 'UG-320', name: 'Maracha' },
    { code: 'UG-105', name: 'Masaka' },
    { code: 'UG-409', name: 'Masindi' },
    { code: 'UG-214', name: 'Mayuge' },
    { code: 'UG-209', name: 'Mbale' },
    { code: 'UG-410', name: 'Mbarara' },
    { code: 'UG-114', name: 'Mityana' },
    { code: 'UG-308', name: 'Moroto' },
    { code: 'UG-309', name: 'Moyo' },
    { code: 'UG-106', name: 'Mpigi' },
    { code: 'UG-107', name: 'Mubende' },
    { code: 'UG-108', name: 'Mukono' },
    { code: 'UG-311', name: 'Nakapiripirit' },
    { code: 'UG-115', name: 'Nakaseke' },
    { code: 'UG-109', name: 'Nakasongola' },
    { code: 'UG-222', name: 'Namutumba' },
    { code: 'UG-310', name: 'Nebbi' },
    { code: 'UG-411', name: 'Ntungamo' },
    { code: 'UG-321', name: 'Oyam' },
    { code: 'UG-312', name: 'Pader' },
    { code: 'UG-210', name: 'Pallisa' },
    { code: 'UG-110', name: 'Rakai' },
    { code: 'UG-412', name: 'Rukungiri' },
    { code: 'UG-111', name: 'Sembabule' },
    { code: 'UG-215', name: 'Sironko' },
    { code: 'UG-211', name: 'Soroti' },
    { code: 'UG-212', name: 'Tororo' },
    { code: 'UG-113', name: 'Wakiso' },
    { code: 'UG-313', name: 'Yumbe' },
  ],
  UA: [
    { code: 'UA-71', name: "Cherkas'ka Oblast'" },
    { code: 'UA-74', name: "Chernihivs'ka Oblast'" },
    { code: 'UA-77', name: "Chernivetska Oblast'" },
    { code: 'UA-12', name: "Dnipropetrovs'ka Oblast'" },
    { code: 'UA-14', name: "Donets'ka Oblast'" },
    { code: 'UA-26', name: "Ivano-Frankivs'ka Oblast'" },
    { code: 'UA-63', name: "Kharkivs'ka Oblast'" },
    { code: 'UA-65', name: "Khersons'ka Oblast'" },
    { code: 'UA-68', name: "Khmel'nyts'ka Oblast'" },
    { code: 'UA-35', name: "Kirovohradska Oblast'" },
    { code: 'UA-43', name: 'Krym' },
    { code: 'UA-30', name: 'Kyyiv' },
    { code: 'UA-32', name: "Kyyivs'ka Oblast'" },
    { code: 'UA-09', name: "Luhans'ka Oblast'" },
    { code: 'UA-46', name: "Lvivska Oblast'" },
    { code: 'UA-48', name: "Mykolayivs'ka Oblast'" },
    { code: 'UA-51', name: "Odes'ka Oblast'" },
    { code: 'UA-53', name: "Poltavs'ka Oblast'" },
    { code: 'UA-56', name: "Rivnens'ka Oblast'" },
    { code: 'UA-40', name: "Sevastopol'" },
    { code: 'UA-59', name: "Sums'ka Oblast'" },
    { code: 'UA-61', name: "Ternopil's'ka Oblast'" },
    { code: 'UA-05', name: "Vinnyts'ka Oblast'" },
    { code: 'UA-07', name: "Volynska Oblast'" },
    { code: 'UA-21', name: "Zakarpats'ka Oblast'" },
    { code: 'UA-23', name: "Zaporiz'ka Oblast'" },
    { code: 'UA-18', name: "Zhytomyrs'ka Oblast'" },
  ],
  AE: [
    { code: 'AE-AZ', name: 'Abu Dhabi' },
    { code: 'AE-AJ', name: 'Ajman' },
    { code: 'AE-DU', name: 'Dubai' },
    { code: 'AE-FU', name: 'Fujairah' },
    { code: 'AE-RK', name: 'Ras Al Khaimah' },
    { code: 'AE-SH', name: 'Sharjah' },
    { code: 'AE-UQ', name: 'Umm Al Quwain' },
  ],
  GB: [
    { code: 'GB-ABE', name: 'Aberdeen City' },
    { code: 'GB-ABD', name: 'Aberdeenshire' },
    { code: 'GB-ANS', name: 'Angus' },
    { code: 'GB-ANT', name: 'Antrim' },
    { code: 'GB-ARD', name: 'Ards' },
    { code: 'GB-AGB', name: 'Argyll and Bute' },
    { code: 'GB-ARM', name: 'Armagh' },
    { code: 'GB-BLA', name: 'Ballymena' },
    { code: 'GB-BLY', name: 'Ballymoney' },
    { code: 'GB-BNB', name: 'Banbridge' },
    { code: 'GB-BDG', name: 'Barking and Dagenham' },
    { code: 'GB-BNE', name: 'Barnet' },
    { code: 'GB-BNS', name: 'Barnsley' },
    { code: 'GB-BAS', name: 'Bath and North East Somerset' },
    { code: 'GB-BDF', name: 'Bedford' },
    { code: 'GB-BFS', name: 'Belfast' },
    { code: 'GB-BEX', name: 'Bexley' },
    { code: 'GB-BIR', name: 'Birmingham' },
    { code: 'GB-BBD', name: 'Blackburn with Darwen' },
    { code: 'GB-BPL', name: 'Blackpool' },
    { code: 'GB-BGW', name: 'Blaenau Gwent' },
    { code: 'GB-BOL', name: 'Bolton' },
    { code: 'GB-BMH', name: 'Bournemouth' },
    { code: 'GB-BRC', name: 'Bracknell Forest' },
    { code: 'GB-BRD', name: 'Bradford' },
    { code: 'GB-BEN', name: 'Brent' },
    { code: 'GB-BGE', name: 'Bridgend' },
    { code: 'GB-BNH', name: 'Brighton and Hove' },
    { code: 'GB-BST', name: 'Bristol, City of' },
    { code: 'GB-BRY', name: 'Bromley' },
    { code: 'GB-BKM', name: 'Buckinghamshire' },
    { code: 'GB-BUR', name: 'Bury' },
    { code: 'GB-CAY', name: 'Caerphilly' },
    { code: 'GB-CLD', name: 'Calderdale' },
    { code: 'GB-CAM', name: 'Cambridgeshire' },
    { code: 'GB-CMD', name: 'Camden' },
    { code: 'GB-CRF', name: 'Cardiff' },
    { code: 'GB-CMN', name: 'Carmarthenshire' },
    { code: 'GB-CKF', name: 'Carrickfergus' },
    { code: 'GB-CSR', name: 'Castlereagh' },
    { code: 'GB-CBF', name: 'Central Bedfordshire' },
    { code: 'GB-CGN', name: 'Ceredigion' },
    { code: 'GB-CHE', name: 'Cheshire East' },
    { code: 'GB-CHW', name: 'Cheshire West and Chester' },
    { code: 'GB-CLK', name: 'Clackmannanshire' },
    { code: 'GB-CLR', name: 'Coleraine' },
    { code: 'GB-CWY', name: 'Conwy' },
    { code: 'GB-CKT', name: 'Cookstown' },
    { code: 'GB-CON', name: 'Cornwall' },
    { code: 'GB-COV', name: 'Coventry' },
    { code: 'GB-CGV', name: 'Craigavon' },
    { code: 'GB-CRY', name: 'Croydon' },
    { code: 'GB-CMA', name: 'Cumbria' },
    { code: 'GB-DAL', name: 'Darlington' },
    { code: 'GB-DEN', name: 'Denbighshire' },
    { code: 'GB-DER', name: 'Derby' },
    { code: 'GB-DBY', name: 'Derbyshire' },
    { code: 'GB-DRY', name: 'Derry' },
    { code: 'GB-DEV', name: 'Devon' },
    { code: 'GB-DNC', name: 'Doncaster' },
    { code: 'GB-DOR', name: 'Dorset' },
    { code: 'GB-DOW', name: 'Down' },
    { code: 'GB-DUD', name: 'Dudley' },
    { code: 'GB-DGY', name: 'Dumfries and Galloway' },
    { code: 'GB-DND', name: 'Dundee City' },
    { code: 'GB-DGN', name: 'Dungannon and South Tyrone' },
    { code: 'GB-DUR', name: 'Durham County' },
    { code: 'GB-EAL', name: 'Ealing' },
    { code: 'GB-EAY', name: 'East Ayrshire' },
    { code: 'GB-EDU', name: 'East Dunbartonshire' },
    { code: 'GB-ELN', name: 'East Lothian' },
    { code: 'GB-ERW', name: 'East Renfrewshire' },
    { code: 'GB-ERY', name: 'East Riding of Yorkshire' },
    { code: 'GB-ESX', name: 'East Sussex' },
    { code: 'GB-EDH', name: 'Edinburgh, City of' },
    { code: 'GB-ELS', name: 'Eilean Siar' },
    { code: 'GB-ENF', name: 'Enfield' },
    { code: 'GB-ENG', name: 'England' },
    { code: 'GB-ESS', name: 'Essex' },
    { code: 'GB-FAL', name: 'Falkirk' },
    { code: 'GB-FER', name: 'Fermanagh' },
    { code: 'GB-FIF', name: 'Fife' },
    { code: 'GB-FLN', name: 'Flintshire' },
    { code: 'GB-GAT', name: 'Gateshead' },
    { code: 'GB-GLG', name: 'Glasgow City' },
    { code: 'GB-GLS', name: 'Gloucestershire' },
    { code: 'GB-GRE', name: 'Greenwich' },
    { code: 'GB-GWN', name: 'Gwynedd' },
    { code: 'GB-HCK', name: 'Hackney' },
    { code: 'GB-HAL', name: 'Halton' },
    { code: 'GB-HMF', name: 'Hammersmith and Fulham' },
    { code: 'GB-HAM', name: 'Hampshire' },
    { code: 'GB-HRY', name: 'Haringey' },
    { code: 'GB-HRW', name: 'Harrow' },
    { code: 'GB-HPL', name: 'Hartlepool' },
    { code: 'GB-HAV', name: 'Havering' },
    { code: 'GB-HEF', name: 'Herefordshire' },
    { code: 'GB-HRT', name: 'Hertfordshire' },
    { code: 'GB-HLD', name: 'Highland' },
    { code: 'GB-HIL', name: 'Hillingdon' },
    { code: 'GB-HNS', name: 'Hounslow' },
    { code: 'GB-IVC', name: 'Inverclyde' },
    { code: 'GB-AGY', name: 'Isle of Anglesey' },
    { code: 'GB-IOW', name: 'Isle of Wight' },
    { code: 'GB-IOS', name: 'Isles of Scilly' },
    { code: 'GB-ISL', name: 'Islington' },
    { code: 'GB-KEC', name: 'Kensington and Chelsea' },
    { code: 'GB-KEN', name: 'Kent' },
    { code: 'GB-KHL', name: 'Kingston upon Hull' },
    { code: 'GB-KTT', name: 'Kingston upon Thames' },
    { code: 'GB-KIR', name: 'Kirklees' },
    { code: 'GB-KWL', name: 'Knowsley' },
    { code: 'GB-LBH', name: 'Lambeth' },
    { code: 'GB-LAN', name: 'Lancashire' },
    { code: 'GB-LRN', name: 'Larne' },
    { code: 'GB-LDS', name: 'Leeds' },
    { code: 'GB-LCE', name: 'Leicester' },
    { code: 'GB-LEC', name: 'Leicestershire' },
    { code: 'GB-LEW', name: 'Lewisham' },
    { code: 'GB-LMV', name: 'Limavady' },
    { code: 'GB-LIN', name: 'Lincolnshire' },
    { code: 'GB-LSB', name: 'Lisburn' },
    { code: 'GB-LIV', name: 'Liverpool' },
    { code: 'GB-LND', name: 'London, City of' },
    { code: 'GB-LUT', name: 'Luton' },
    { code: 'GB-MFT', name: 'Magherafelt' },
    { code: 'GB-MAN', name: 'Manchester' },
    { code: 'GB-MDW', name: 'Medway' },
    { code: 'GB-MTY', name: 'Merthyr Tydfil' },
    { code: 'GB-MRT', name: 'Merton' },
    { code: 'GB-MDB', name: 'Middlesbrough' },
    { code: 'GB-MLN', name: 'Midlothian' },
    { code: 'GB-MIK', name: 'Milton Keynes' },
    { code: 'GB-MON', name: 'Monmouthshire' },
    { code: 'GB-MRY', name: 'Moray' },
    { code: 'GB-MYL', name: 'Moyle' },
    { code: 'GB-NTL', name: 'Neath Port Talbot' },
    { code: 'GB-NET', name: 'Newcastle upon Tyne' },
    { code: 'GB-NWM', name: 'Newham' },
    { code: 'GB-NWP', name: 'Newport' },
    { code: 'GB-NYM', name: 'Newry and Mourne' },
    { code: 'GB-NTA', name: 'Newtownabbey' },
    { code: 'GB-NFK', name: 'Norfolk' },
    { code: 'GB-NAY', name: 'North Ayrshire' },
    { code: 'GB-NDN', name: 'North Down' },
    { code: 'GB-NEL', name: 'North East Lincolnshire' },
    { code: 'GB-NLK', name: 'North Lanarkshire' },
    { code: 'GB-NLN', name: 'North Lincolnshire' },
    { code: 'GB-NSM', name: 'North Somerset' },
    { code: 'GB-NTY', name: 'North Tyneside' },
    { code: 'GB-NYK', name: 'North Yorkshire' },
    { code: 'GB-NTH', name: 'Northamptonshire' },
    { code: 'GB-NIR', name: 'Northern Ireland' },
    { code: 'GB-NBL', name: 'Northumberland' },
    { code: 'GB-NGM', name: 'Nottingham' },
    { code: 'GB-NTT', name: 'Nottinghamshire' },
    { code: 'GB-OLD', name: 'Oldham' },
    { code: 'GB-OMH', name: 'Omagh' },
    { code: 'GB-ORK', name: 'Orkney Islands' },
    { code: 'GB-OXF', name: 'Oxfordshire' },
    { code: 'GB-PEM', name: 'Pembrokeshire' },
    { code: 'GB-PKN', name: 'Perth and Kinross' },
    { code: 'GB-PTE', name: 'Peterborough' },
    { code: 'GB-PLY', name: 'Plymouth' },
    { code: 'GB-POL', name: 'Poole' },
    { code: 'GB-POR', name: 'Portsmouth' },
    { code: 'GB-POW', name: 'Powys' },
    { code: 'GB-RDG', name: 'Reading' },
    { code: 'GB-RDB', name: 'Redbridge' },
    { code: 'GB-RCC', name: 'Redcar and Cleveland' },
    { code: 'GB-RFW', name: 'Renfrewshire' },
    { code: 'GB-RCT', name: 'Rhondda, Cynon, Taff' },
    { code: 'GB-RIC', name: 'Richmond upon Thames' },
    { code: 'GB-RCH', name: 'Rochdale' },
    { code: 'GB-ROT', name: 'Rotherham' },
    { code: 'GB-RUT', name: 'Rutland' },
    { code: 'GB-SLF', name: 'Salford' },
    { code: 'GB-SAW', name: 'Sandwell' },
    { code: 'GB-SCT', name: 'Scotland' },
    { code: 'GB-SFT', name: 'Sefton' },
    { code: 'GB-SHF', name: 'Sheffield' },
    { code: 'GB-ZET', name: 'Shetland Islands' },
    { code: 'GB-SHR', name: 'Shropshire' },
    { code: 'GB-SLG', name: 'Slough' },
    { code: 'GB-SOL', name: 'Solihull' },
    { code: 'GB-SOM', name: 'Somerset' },
    { code: 'GB-SAY', name: 'South Ayrshire' },
    { code: 'GB-SGC', name: 'South Gloucestershire' },
    { code: 'GB-SLK', name: 'South Lanarkshire' },
    { code: 'GB-STY', name: 'South Tyneside' },
    { code: 'GB-STH', name: 'Southampton' },
    { code: 'GB-SOS', name: 'Southend-on-Sea' },
    { code: 'GB-SWK', name: 'Southwark' },
    { code: 'GB-SHN', name: 'St. Helens' },
    { code: 'GB-STS', name: 'Staffordshire' },
    { code: 'GB-STG', name: 'Stirling' },
    { code: 'GB-SKP', name: 'Stockport' },
    { code: 'GB-STT', name: 'Stockton-on-Tees' },
    { code: 'GB-STE', name: 'Stoke-on-Trent' },
    { code: 'GB-STB', name: 'Strabane' },
    { code: 'GB-SFK', name: 'Suffolk' },
    { code: 'GB-SND', name: 'Sunderland' },
    { code: 'GB-SRY', name: 'Surrey' },
    { code: 'GB-STN', name: 'Sutton' },
    { code: 'GB-SWA', name: 'Swansea' },
    { code: 'GB-SWD', name: 'Swindon' },
    { code: 'GB-TAM', name: 'Tameside' },
    { code: 'GB-TFW', name: 'Telford and Wrekin' },
    { code: 'GB-SCB', name: 'The Scottish Borders' },
    { code: 'GB-VGL', name: 'The Vale of Glamorgan' },
    { code: 'GB-THR', name: 'Thurrock' },
    { code: 'GB-TOB', name: 'Torbay' },
    { code: 'GB-TOF', name: 'Torfaen' },
    { code: 'GB-TWH', name: 'Tower Hamlets' },
    { code: 'GB-TRF', name: 'Trafford' },
    { code: 'GB-UKM', name: 'United Kingdom' },
    { code: 'GB-WKF', name: 'Wakefield' },
    { code: 'GB-WLS', name: 'Wales' },
    { code: 'GB-WLL', name: 'Walsall' },
    { code: 'GB-WFT', name: 'Waltham Forest' },
    { code: 'GB-WND', name: 'Wandsworth' },
    { code: 'GB-WRT', name: 'Warrington' },
    { code: 'GB-WAR', name: 'Warwickshire' },
    { code: 'GB-WBK', name: 'West Berkshire' },
    { code: 'GB-WDU', name: 'West Dunbartonshire' },
    { code: 'GB-WLN', name: 'West Lothian' },
    { code: 'GB-WSX', name: 'West Sussex' },
    { code: 'GB-WSM', name: 'Westminster' },
    { code: 'GB-WGN', name: 'Wigan' },
    { code: 'GB-WIL', name: 'Wiltshire' },
    { code: 'GB-WNM', name: 'Windsor and Maidenhead' },
    { code: 'GB-WRL', name: 'Wirral' },
    { code: 'GB-WOK', name: 'Wokingham' },
    { code: 'GB-WLV', name: 'Wolverhampton' },
    { code: 'GB-WOR', name: 'Worcestershire' },
    { code: 'GB-WRX', name: 'Wrexham' },
    { code: 'GB-YOR', name: 'York' },
  ],
  TZ: [
    { code: 'TZ-01', name: 'Arusha' },
    { code: 'TZ-02', name: 'Dar es Salaam' },
    { code: 'TZ-03', name: 'Dodoma' },
    { code: 'TZ-04', name: 'Iringa' },
    { code: 'TZ-05', name: 'Kagera' },
    { code: 'TZ-08', name: 'Kigoma' },
    { code: 'TZ-09', name: 'Kilimanjaro' },
    { code: 'TZ-12', name: 'Lindi' },
    { code: 'TZ-26', name: 'Manyara' },
    { code: 'TZ-13', name: 'Mara' },
    { code: 'TZ-14', name: 'Mbeya' },
    { code: 'TZ-16', name: 'Morogoro' },
    { code: 'TZ-17', name: 'Mtwara' },
    { code: 'TZ-18', name: 'Mwanza' },
    { code: 'TZ-06', name: 'Pemba North' },
    { code: 'TZ-10', name: 'Pemba South' },
    { code: 'TZ-19', name: 'Pwani' },
    { code: 'TZ-20', name: 'Rukwa' },
    { code: 'TZ-21', name: 'Ruvuma' },
    { code: 'TZ-22', name: 'Shinyanga' },
    { code: 'TZ-23', name: 'Singida' },
    { code: 'TZ-24', name: 'Tabora' },
    { code: 'TZ-25', name: 'Tanga' },
    { code: 'TZ-07', name: 'Zanzibar North' },
  ],
  US: [
    { code: 'AL', name: 'Alabama' },
    { code: 'AK', name: 'Alaska' },
    { code: 'AS', name: 'American Samoa' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DE', name: 'Delaware' },
    { code: 'DC', name: 'District of Columbia' },
    { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' },
    { code: 'GU', name: 'Guam' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'IA', name: 'Iowa' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'ME', name: 'Maine' },
    { code: 'MD', name: 'Maryland' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MT', name: 'Montana' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NY', name: 'New York' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'MP', name: 'Northern Mariana Islands' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'AA', name: 'U.s. Armed Forces - Americas' },
    { code: 'AE', name: 'U.s. Armed Forces - Europe' },
    { code: 'AP', name: 'U.s. Armed Forces - Pacific' },
    { code: 'UM', name: 'United States Minor Outlying Islands' },
    { code: 'UT', name: 'Utah' },
    { code: 'VT', name: 'Vermont' },
    { code: 'VI', name: 'Virgin Islands' },
    { code: 'VA', name: 'Virginia' },
    { code: 'WA', name: 'Washington' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WY', name: 'Wyoming' },
  ],
  UY: [
    { code: 'UY-AR', name: 'Artigas' },
    { code: 'UY-CA', name: 'Canelones' },
    { code: 'UY-CL', name: 'Cerro Largo' },
    { code: 'UY-CO', name: 'Colonia' },
    { code: 'UY-DU', name: 'Durazno' },
    { code: 'UY-FS', name: 'Flores' },
    { code: 'UY-FD', name: 'Florida' },
    { code: 'UY-LA', name: 'Lavalleja' },
    { code: 'UY-MA', name: 'Maldonado' },
    { code: 'UY-MO', name: 'Montevideo' },
    { code: 'UY-PA', name: 'Paysandu' },
    { code: 'UY-RN', name: 'Rio Negro' },
    { code: 'UY-RV', name: 'Rivera' },
    { code: 'UY-RO', name: 'Rocha' },
    { code: 'UY-SA', name: 'Salto' },
    { code: 'UY-SJ', name: 'San Jose' },
    { code: 'UY-SO', name: 'Soriano' },
    { code: 'UY-TA', name: 'Tacuarembo' },
    { code: 'UY-TT', name: 'Treinta y Tres' },
  ],
  UZ: [
    { code: 'UZ-AN', name: 'Andijon' },
    { code: 'UZ-BU', name: 'Bukhoro' },
    { code: 'UZ-FA', name: 'Farghona' },
    { code: 'UZ-JI', name: 'Jizzax' },
    { code: 'UZ-NG', name: 'Namangan' },
    { code: 'UZ-NW', name: 'Nawoiy' },
    { code: 'UZ-QA', name: 'Qashqadaryo' },
    { code: 'UZ-QR', name: 'Qoraqalpoghiston' },
    { code: 'UZ-SA', name: 'Samarqand' },
    { code: 'UZ-SI', name: 'Sirdaryo' },
    { code: 'UZ-SU', name: 'Surkhondaryo' },
    { code: 'UZ-TO', name: 'Toshkent' },
    { code: 'UZ-TK', name: 'Toshkent Shahri' },
  ],
  VU: [
    { code: 'VU-MAP', name: 'Malampa' },
    { code: 'VU-SAM', name: 'Sanma' },
    { code: 'VU-SEE', name: 'Shefa' },
    { code: 'VU-TAE', name: 'Tafea' },
    { code: 'VU-TOB', name: 'Torba' },
  ],
  VE: [
    { code: 'VE-Z', name: 'Amazonas' },
    { code: 'VE-B', name: 'Anzoategui' },
    { code: 'VE-C', name: 'Apure' },
    { code: 'VE-D', name: 'Aragua' },
    { code: 'VE-E', name: 'Barinas' },
    { code: 'VE-F', name: 'Bolivar' },
    { code: 'VE-G', name: 'Carabobo' },
    { code: 'VE-H', name: 'Cojedes' },
    { code: 'VE-Y', name: 'Delta Amacuro' },
    { code: 'VE-A', name: 'Distrito Federal' },
    { code: 'VE-I', name: 'Falcon' },
    { code: 'VE-J', name: 'Guarico' },
    { code: 'VE-K', name: 'Lara' },
    { code: 'VE-L', name: 'Merida' },
    { code: 'VE-M', name: 'Miranda' },
    { code: 'VE-N', name: 'Monagas' },
    { code: 'VE-O', name: 'Nueva Esparta' },
    { code: 'VE-P', name: 'Portuguesa' },
    { code: 'VE-R', name: 'Sucre' },
    { code: 'VE-S', name: 'Tachira' },
    { code: 'VE-T', name: 'Trujillo' },
    { code: 'VE-X', name: 'Vargas' },
    { code: 'VE-U', name: 'Yaracuy' },
    { code: 'VE-V', name: 'Zulia' },
  ],
  VN: [
    { code: 'VN-44', name: 'An Giang' },
    { code: 'VN-43', name: 'Ba Ria-Vung Tau' },
    { code: 'VN-54', name: 'Bac Giang' },
    { code: 'VN-53', name: 'Bac Kan' },
    { code: 'VN-55', name: 'Bac Lieu' },
    { code: 'VN-56', name: 'Bac Ninh' },
    { code: 'VN-50', name: 'Ben Tre' },
    { code: 'VN-31', name: 'Binh Dinh' },
    { code: 'VN-57', name: 'Binh Duong' },
    { code: 'VN-58', name: 'Binh Phuoc' },
    { code: 'VN-40', name: 'Binh Thuan' },
    { code: 'VN-59', name: 'Ca Mau' },
    { code: 'VN-CT', name: 'Can Tho' },
    { code: 'VN-04', name: 'Cao Bang' },
    { code: 'VN-DN', name: 'Da Nang' },
    { code: 'VN-33', name: 'Dak Lak' },
    { code: 'VN-72', name: 'Dak Nong' },
    { code: 'VN-71', name: 'Dien Bien' },
    { code: 'VN-39', name: 'Dong Nai' },
    { code: 'VN-45', name: 'Dong Thap' },
    { code: 'VN-30', name: 'Gia Lai' },
    { code: 'VN-03', name: 'Ha Giang' },
    { code: 'VN-63', name: 'Ha Nam' },
    { code: 'VN-HN', name: 'Ha Noi' },
    { code: 'VN-23', name: 'Ha Tinh' },
    { code: 'VN-61', name: 'Hai Duong' },
    { code: 'VN-HP', name: 'Hai Phong' },
    { code: 'VN-73', name: 'Hau Giang' },
    { code: 'VN-SG', name: 'Ho Chi Minh' },
    { code: 'VN-14', name: 'Hoa Binh' },
    { code: 'VN-66', name: 'Hung Yen' },
    { code: 'VN-34', name: 'Khanh Hoa' },
    { code: 'VN-47', name: 'Kien Giang' },
    { code: 'VN-28', name: 'Kon Tum' },
    { code: 'VN-01', name: 'Lai Chau' },
    { code: 'VN-35', name: 'Lam Dong' },
    { code: 'VN-09', name: 'Lang Son' },
    { code: 'VN-02', name: 'Lao Cai' },
    { code: 'VN-41', name: 'Long An' },
    { code: 'VN-67', name: 'Nam Dinh' },
    { code: 'VN-22', name: 'Nghe An' },
    { code: 'VN-18', name: 'Ninh Binh' },
    { code: 'VN-36', name: 'Ninh Thuan' },
    { code: 'VN-68', name: 'Phu Tho' },
    { code: 'VN-32', name: 'Phu Yen' },
    { code: 'VN-24', name: 'Quang Binh' },
    { code: 'VN-27', name: 'Quang Nam' },
    { code: 'VN-29', name: 'Quang Ngai' },
    { code: 'VN-13', name: 'Quang Ninh' },
    { code: 'VN-25', name: 'Quang Tri' },
    { code: 'VN-52', name: 'Soc Trang' },
    { code: 'VN-05', name: 'Son La' },
    { code: 'VN-37', name: 'Tay Ninh' },
    { code: 'VN-20', name: 'Thai Binh' },
    { code: 'VN-69', name: 'Thai Nguyen' },
    { code: 'VN-21', name: 'Thanh Hoa' },
    { code: 'VN-26', name: 'Thua Thien' },
    { code: 'VN-46', name: 'Tien Giang' },
    { code: 'VN-51', name: 'Tra Vinh' },
    { code: 'VN-07', name: 'Tuyen Quang' },
    { code: 'VN-49', name: 'Vinh Long' },
    { code: 'VN-70', name: 'Vinh Phu' },
    { code: 'VN-06', name: 'Yen Bai' },
  ],
  EH: [
    { code: 'MA-16', name: 'Oued Ed-Dahab-Lagouira' },
    { code: 'MA-14', name: 'Western Sahara' },
  ],
  YE: [
    { code: 'YE-AB', name: 'Abyan' },
    { code: 'YE-DA', name: 'Ad Dali' },
    { code: 'YE-AD', name: 'Adan' },
    { code: 'YE-BA', name: "Al Bayda'" },
    { code: 'YE-HU', name: 'Al Hudaydah' },
    { code: 'YE-JA', name: 'Al Jawf' },
    { code: 'YE-MR', name: 'Al Mahrah' },
    { code: 'YE-MW', name: 'Al Mahwit' },
    { code: 'YE-AM', name: 'Amran' },
    { code: 'YE-DH', name: 'Dhamar' },
    { code: 'YE-HD', name: 'Hadramawt' },
    { code: 'YE-HJ', name: 'Hajjah' },
    { code: 'YE-IB', name: 'Ibb' },
    { code: 'YE-LA', name: 'Lahij' },
    { code: 'YE-MA', name: "Ma'rib" },
    { code: 'YE-RA', name: 'Muhafazat Raymah' },
    { code: 'YE-SD', name: "Sa'dah" },
    { code: 'YE-SN', name: "San'a'" },
    { code: 'YE-SH', name: 'Shabwah' },
    { code: 'YE-TA', name: 'Taizz' },
  ],
  ZM: [
    { code: 'ZM-02', name: 'Central' },
    { code: 'ZM-08', name: 'Copperbelt' },
    { code: 'ZM-03', name: 'Eastern' },
    { code: 'ZM-04', name: 'Luapula' },
    { code: 'ZM-09', name: 'Lusaka' },
    { code: 'ZM-06', name: 'North-Western' },
    { code: 'ZM-05', name: 'Northern' },
    { code: 'ZM-07', name: 'Southern' },
    { code: 'ZM-01', name: 'Western' },
  ],
};
const NAME_BY_CODE: Record<string, string> = {
  AL: 'Albania',
  DZ: 'Algeria',
  AD: 'Andorra',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BR: 'Brazil',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CO: 'Colombia',
  KM: 'Comoros',
  CR: 'Costa Rica',
  HR: 'Croatia',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  TL: 'East Timor',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GT: 'Guatemala',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HN: 'Honduras',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IE: 'Ireland',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KI: 'Kiribati',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: 'Lao People`s Democratic Republic',
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MR: 'Mauritania',
  MU: 'Mauritius',
  MX: 'Mexico',
  FM: 'Micronesia',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MA: 'Morocco',
  MZ: 'Mozambique',
  NA: 'Namibia',
  NP: 'Nepal',
  NL: 'Netherlands',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NO: 'Norway',
  PS: 'Occupied Palestinian Territory',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PL: 'Poland',
  PT: 'Portugal',
  QA: 'Qatar',
  KR: 'Republic of Korea',
  MD: 'Republic of Moldova',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  SH: 'Saint Helena',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SR: 'Suriname',
  SZ: 'Swaziland',
  SE: 'Sweden',
  CH: 'Switzerland',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TH: 'Thailand',
  MK: 'The former Yugoslav Republic of Macedonia',
  TG: 'Togo',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  TZ: 'United Republic of Tanzania',
  US: 'United States',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Vietnam',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
};
const CODE_BY_NAME: Record<string, string> = {
  albania: 'AL',
  algeria: 'DZ',
  andorra: 'AD',
  'antigua and barbuda': 'AG',
  argentina: 'AR',
  armenia: 'AM',
  australia: 'AU',
  austria: 'AT',
  azerbaijan: 'AZ',
  bahamas: 'BS',
  bahrain: 'BH',
  bangladesh: 'BD',
  barbados: 'BB',
  belgium: 'BE',
  belize: 'BZ',
  benin: 'BJ',
  bhutan: 'BT',
  bolivia: 'BO',
  'bosnia and herzegovina': 'BA',
  botswana: 'BW',
  brazil: 'BR',
  'brunei darussalam': 'BN',
  bulgaria: 'BG',
  'burkina faso': 'BF',
  burundi: 'BI',
  cambodia: 'KH',
  cameroon: 'CM',
  canada: 'CA',
  'cape verde': 'CV',
  'central african republic': 'CF',
  chad: 'TD',
  chile: 'CL',
  china: 'CN',
  colombia: 'CO',
  comoros: 'KM',
  'costa rica': 'CR',
  croatia: 'HR',
  cyprus: 'CY',
  'czech republic': 'CZ',
  denmark: 'DK',
  djibouti: 'DJ',
  dominica: 'DM',
  'dominican republic': 'DO',
  'east timor': 'TL',
  ecuador: 'EC',
  egypt: 'EG',
  'el salvador': 'SV',
  'equatorial guinea': 'GQ',
  eritrea: 'ER',
  estonia: 'EE',
  ethiopia: 'ET',
  fiji: 'FJ',
  finland: 'FI',
  france: 'FR',
  gabon: 'GA',
  gambia: 'GM',
  georgia: 'GE',
  germany: 'DE',
  ghana: 'GH',
  greece: 'GR',
  greenland: 'GL',
  grenada: 'GD',
  guatemala: 'GT',
  guinea: 'GN',
  'guinea-bissau': 'GW',
  guyana: 'GY',
  haiti: 'HT',
  honduras: 'HN',
  hungary: 'HU',
  iceland: 'IS',
  india: 'IN',
  indonesia: 'ID',
  ireland: 'IE',
  israel: 'IL',
  italy: 'IT',
  jamaica: 'JM',
  japan: 'JP',
  jordan: 'JO',
  kazakhstan: 'KZ',
  kiribati: 'KI',
  kuwait: 'KW',
  kyrgyzstan: 'KG',
  'lao people`s democratic republic': 'LA',
  latvia: 'LV',
  lebanon: 'LB',
  lesotho: 'LS',
  liberia: 'LR',
  liechtenstein: 'LI',
  lithuania: 'LT',
  luxembourg: 'LU',
  madagascar: 'MG',
  malawi: 'MW',
  malaysia: 'MY',
  maldives: 'MV',
  mali: 'ML',
  malta: 'MT',
  'marshall islands': 'MH',
  mauritania: 'MR',
  mauritius: 'MU',
  mexico: 'MX',
  micronesia: 'FM',
  monaco: 'MC',
  mongolia: 'MN',
  montenegro: 'ME',
  morocco: 'MA',
  mozambique: 'MZ',
  namibia: 'NA',
  nepal: 'NP',
  netherlands: 'NL',
  'new zealand': 'NZ',
  nicaragua: 'NI',
  niger: 'NE',
  norway: 'NO',
  'occupied palestinian territory': 'PS',
  oman: 'OM',
  pakistan: 'PK',
  palau: 'PW',
  panama: 'PA',
  'papua new guinea': 'PG',
  paraguay: 'PY',
  peru: 'PE',
  philippines: 'PH',
  poland: 'PL',
  portugal: 'PT',
  qatar: 'QA',
  'republic of korea': 'KR',
  'republic of moldova': 'MD',
  romania: 'RO',
  'russian federation': 'RU',
  rwanda: 'RW',
  'saint helena': 'SH',
  'saint kitts and nevis': 'KN',
  'saint lucia': 'LC',
  'saint vincent and the grenadines': 'VC',
  samoa: 'WS',
  'san marino': 'SM',
  'sao tome and principe': 'ST',
  'saudi arabia': 'SA',
  senegal: 'SN',
  serbia: 'RS',
  seychelles: 'SC',
  singapore: 'SG',
  slovakia: 'SK',
  slovenia: 'SI',
  'solomon islands': 'SB',
  somalia: 'SO',
  'south africa': 'ZA',
  spain: 'ES',
  'sri lanka': 'LK',
  suriname: 'SR',
  swaziland: 'SZ',
  sweden: 'SE',
  switzerland: 'CH',
  taiwan: 'TW',
  tajikistan: 'TJ',
  thailand: 'TH',
  'the former yugoslav republic of macedonia': 'MK',
  togo: 'TG',
  tonga: 'TO',
  'trinidad and tobago': 'TT',
  tunisia: 'TN',
  turkey: 'TR',
  turkmenistan: 'TM',
  uganda: 'UG',
  ukraine: 'UA',
  'united arab emirates': 'AE',
  'united kingdom': 'GB',
  'united republic of tanzania': 'TZ',
  'united states': 'US',
  uruguay: 'UY',
  uzbekistan: 'UZ',
  vanuatu: 'VU',
  venezuela: 'VE',
  vietnam: 'VN',
  'western sahara': 'EH',
  yemen: 'YE',
  zambia: 'ZM',
};

/** Alpha-2 code → display name. */
export function countryName(code2: string): string {
  return NAME_BY_CODE[(code2 || '').toUpperCase()] ?? code2 ?? '';
}


/**
 * The alpha-3 codes, indexed back to alpha-2.
 *
 * Built from `COUNTRIES`, which has carried `code3` all along, rather than
 * written out a third time: a country added to that list resolves here with
 * nothing further to edit.
 */
const CODE2_BY_CODE3: Record<string, string> = Object.fromEntries(
  COUNTRIES.filter((c) => c.code3).map((c) => [c.code3.toUpperCase(), c.code2]),
);

/**
 * Normalise a country to an alpha-2 code, from a code of either length or a
 * display name.
 *
 * ALPHA-3 IS WHAT THE PROFILE STORES. `clients.country_of_citizenship` holds
 * "CAN", not "CA" — and this recognised neither that nor "USA", so every
 * caller got '' back and fell through to whatever it does with an unknown
 * country. `countryDisplay` printed the raw "CAN" instead of "Canada", and
 * the citizenship flag on the client's header drew nothing at all, which is
 * how the gap was finally noticed.
 *
 * A three-letter value cannot collide with a two-letter code, and no country
 * is named in three letters, so this is a resolution added rather than an
 * order changed.
 */
export function countryCode(value: string): string {
  const v = (value || '').trim();
  if (!v) return '';
  if (NAME_BY_CODE[v.toUpperCase()]) return v.toUpperCase();
  return CODE_BY_NAME[v.toLowerCase()] ?? CODE2_BY_CODE3[v.toUpperCase()] ?? '';
}

/**
 * Every citizenship a client holds, in the order the header draws them.
 *
 * CANADA, THEN THE UNITED STATES, THEN THE REST A TO Z BY NAME. The first two
 * are the firm's home markets and the ones the forms ask about by name (the
 * NBIN-402 has a box for each and one "Other" for everything else), so they
 * lead; the rest are alphabetical so that two advisors reading the same
 * client see the flags in the same order. Accepts whatever the record stores
 * (alpha-2, alpha-3 or a name), drops repeats and anything it cannot place,
 * and answers alpha-2 codes, which is what `CountryFlag` draws from.
 */
export function orderCitizenships(values: ReadonlyArray<string>): string[] {
  const codes = [...new Set(values.map((v) => countryCode(v)).filter(Boolean))];
  const rank = (code: string) => (code === 'CA' ? 0 : code === 'US' ? 1 : 2);
  return codes.sort(
    (a, b) => rank(a) - rank(b) || countryName(a).localeCompare(countryName(b)),
  );
}

/** Subdivisions for a country alpha-2 code, or null when none are listed. */
export function regionsForCountry(code2: string): Region[] | null {
  return REGIONS_BY_COUNTRY[(code2 || '').toUpperCase()] ?? null;
}

/**
 * Resolve whatever a geocoder called a region ("Québec", "QC", "Quebec") to the
 * exact `code` the Province dropdown for that country offers.
 *
 * Necessary because the code format is NOT uniform across countries: Canadian
 * provinces are full ISO 3166-2 ("CA-QC") while US states are bare ("NY"). An
 * address search that returned "QC" therefore matched no option in the Canadian
 * list, and the Province box silently stayed on "Select…" for every Canadian
 * address — while US addresses filled correctly, which is what hid it.
 *
 * Matched against the option list itself rather than a hand-kept lookup, so it
 * cannot drift from what the dropdown actually accepts. Returns '' when nothing
 * matches, leaving the box for a human rather than guessing a province.
 */
export function resolveRegionCode(
  countryCode2: string,
  region: string,
): string {
  const raw = (region || '').trim();
  if (!raw) return '';
  const regions = regionsForCountry(countryCode2);
  if (!regions) return raw; // No list for this country: the free-text box takes it.

  // Accents matter here: Photon answers in the local language, so Quebec comes
  // back as "Québec" while the option is named "Quebec".
  const norm = (s: string) =>
    s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  const want = norm(raw);

  const hit = regions.find(
    (r) =>
      norm(r.code) === want ||
      norm(r.name) === want ||
      // "QC" against "CA-QC" — the geocoder's short form vs the ISO 3166-2 code.
      norm(r.code.split('-').pop() ?? '') === want,
  );
  return hit?.code ?? '';
}

/**
 * A subdivision as everything downstream wants it: the bare code, no prefix.
 *
 * `resolveRegionCode` answers from an ISO 3166-2 table, and that table spells
 * Canada's provinces "CA-QC" while it spells US states plain "NY" — so the
 * geocoder path produced a five-character province for Canadian addresses and
 * a correct two-character one for American ones. Everything downstream wants
 * two letters: the NBIN province box is two characters wide, the client
 * profile stores `residential_state` that way, `isValidStateProvince` requires
 * exactly two, the document language asks `state === 'QC'`, and package
 * selection reads the province to decide which provincial forms attach.
 *
 * WHAT IT COST, because the failure was silent in the worst way. The province
 * SELECT displays `bareRegionCode(value)`, so a stored "CA-QC" drew "Quebec"
 * and looked answered — while the step gate, reading the raw value, said
 * "Needed before continuing: Residential address" with no field marked and
 * Next greyed out. An advisor who picked their client's address from the
 * search box could not leave the step, and nothing on screen said why.
 *
 * Two private copies of this already existed — one in `prefill.ts`, one inside
 * `StateProvinceSelect` — which is why four other readers had none. It lives
 * beside the function that produces the prefixed form now, so the pair is
 * visible at once.
 */
export function bareRegionCode(code: string | null | undefined): string {
  const v = (code ?? '').trim();
  return v.includes('-') ? v.slice(v.indexOf('-') + 1) : v;
}

/**
 * A subdivision spelled out, for a labelled cell that is READ.
 *
 * "QC" is what the form stores, what the two-character NBIN box prints and
 * what every check downstream compares against, so nothing about the stored
 * value changes. It is not what a person reads back: a record headed
 * "Province" whose value is "QC" asks the reader to expand an abbreviation to
 * confirm an answer they are checking for correctness.
 *
 * THE ENVELOPE LINE KEEPS THE CODE, and that is not an inconsistency. Canada
 * Post and the USPS both want the two-letter abbreviation on an addressed
 * line, so "Montréal, QC H3C 0A5" is correct exactly where it appears.
 *
 * Takes the country in either spelling, because the stored value is sometimes
 * the name and sometimes the alpha-2. Returns the input untouched for a
 * country with no subdivision list, or a region that matches none of them: an
 * unrecognised value is still the one somebody entered.
 */
export function regionName(country: string, region: string): string {
  const raw = (region ?? '').trim();
  if (!raw) return '';
  const code2 = countryCode(country);
  const regions = regionsForCountry(code2);
  if (!regions) return raw;
  const resolved = resolveRegionCode(code2, raw);
  return regions.find((r) => r.code === resolved)?.name ?? raw;
}

/** A country spelled out, whether it is stored as a name or an alpha-2. */
export function countryDisplay(value: string): string {
  const v = (value ?? '').trim();
  return countryName(countryCode(v)) || v;
}

/** Address-autocomplete alpha-2 → the stored country value (alpha-2). */
export function iso2ToCountry(code2: string): string | undefined {
  const c = (code2 || '').toUpperCase();
  return NAME_BY_CODE[c] ? c : undefined;
}

export const COUNTRY_DIVIDER = '__divider__';

// Dropdown options (value = alpha-2 code, label = name): US + Canada pinned,
// a divider, then the rest alphabetically.
export const COUNTRY_OPTIONS: {
  value: string;
  label: string;
  disabled?: boolean;
}[] = [
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' },
  { value: '__divider__', label: '──────────', disabled: true },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BR', label: 'Brazil' },
  { value: 'BN', label: 'Brunei Darussalam' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CV', label: 'Cape Verde' },
  { value: 'CF', label: 'Central African Republic' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'HR', label: 'Croatia' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic' },
  { value: 'TL', label: 'East Timor' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: 'Lao People`s Democratic Republic' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NO', label: 'Norway' },
  { value: 'PS', label: 'Occupied Palestinian Territory' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'QA', label: 'Qatar' },
  { value: 'KR', label: 'Republic of Korea' },
  { value: 'MD', label: 'Republic of Moldova' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russian Federation' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'SH', label: 'Saint Helena' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SZ', label: 'Swaziland' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TH', label: 'Thailand' },
  { value: 'MK', label: 'The former Yugoslav Republic of Macedonia' },
  { value: 'TG', label: 'Togo' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'TZ', label: 'United Republic of Tanzania' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Vietnam' },
  { value: 'EH', label: 'Western Sahara' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
];
